const resources = {
    translation: {
        DASHBOARD: {
            LOCATION_CARD: {
                HEADER: {
                    SUBTITLE: {
                        ALARM: "{{count}} Alarm",
                        ALARM_plural: "{{count}} Alarmen",
                        ALARM_noData: "0 Alarmen",
                        NORMAL: "Normaal",
                    },
                    INFO: {
                        DEVICE: "{{count}} Apparaat",
                        DEVICE_plural: "{{count}} Apparaten",
                        SITE: "{{count}} Site",
                        SITE_plural: "{{count}} sites",
                        DEVICE_noData: "0 Apparaten",
                        SITE_noData: "0 locaties",
                    },
                },
                BODY: {
                    ALARMS: "{{count}} Alarm",
                    ALARMS_plural: "{{count}} Alarmen",
                    EVENTS: "{{count}} Gebeurtenis",
                    EVENTS_plural: "{{count}} Gebeurtenissen",
                    ALARMS_noData: "0 Alarmen",
                    EVENTS_noData: "0 Evenementen",
                },
                FOOTER: {
                    VIEW_LOCATION: "Bekijk locatie",
                },
            },
            SITE_CARD: {
                HEADER: {
                    INFO: {
                        DEVICE: "{{count}} Apparaat",
                        DEVICE_plural: "{{count}} Apparaten",
                        DEVICE_noData: "0 Apparaten",
                    },
                },
                BODY: {
                    ALARMS: "{{count}} Alarm",
                    ALARMS_plural: "{{count}} Alarmen",
                    EVENTS: "{{count}} Gebeurtenissen",
                    EVENTS_plural: "{{count}} Evenementen",
                    ALARMS_noData: "0 Alarmen",
                    EVENTS_noData: "0 Evenementen",
                },
                FOOTER: {
                    VIEW_LOCATION: "Bekijk site",
                },
            },
            TIMELINE_DETAILS: {
                ACKNOWLEDGED: "ERKEND",
                OPEN: "ACTIEF",
                CLOSED: "GESLOTEN",
                EARLIER: "Eerder",
                FUTURE: "Toekomst",
                INACTIVE: "INACTIEF",
                LAST_WEEK: "Laatste week",
                THIS_WEEK: "Deze week",
                TIMELINE: "Tijdlijn",
                TODAY: "Vandaag",
                UNACKNOWLEDGED: "ONBEVESTIGD",
                YESTERDAY: "Gisteren",
            },
            ADD_BUILDING: "Voeg gebouw toe aan",
            AUTO_REDIRECT_BANNER: {
                ADD_LOCATION_BUTTON: "Locatie toevoegen",
                DISMISS: "Ontslaan",
                MESSAGE: "U bent automatisch doorgestuurd naar {{location}} omdat u geen andere topniveaulocaties heeft.",
            },
            USERS_ADMIN: "Beheerder",
            USERS_ADMIN_S: "Beheerders",
            ADMINS_TITLE: "Beheerders",
            SITE_DETAILS: {
                READING_CARDS: {
                    ALARM: "Alarm",
                    BATTERY: "Batterij",
                    FULL: "Vol",
                    PENDING: "In behandeling",
                    UNKNOWN: "Onbekend",
                    VIEW_ALL: "Alles weergeven",
                },
                ALL_DETAILS: "Alle details",
                ALL_DEVICES: "Alle apparaten",
                TRENDS_CARD: {
                    CHANNELS: "Kanalen",
                    DAY: "Dag",
                    DAYS: "Dagen",
                    TITLE: "Trends",
                    TRENDVIEWER: "Trendviewer",
                    VIEW_ALL: "Bekijk de volledige Trendviewer",
                },
                DEVICES_CARD: {
                    TITLE: "Apparaten",
                    VIEW_ALL: "Alle apparaten weergeven",
                },
                TIMELINE_CARD: {
                    TITLE: "Tijdlijn",
                    VIEW_ALL_EVENTS: "Alle gebeurtenissen weergeven",
                },
            },
            ALL_BUILDINGS_COUNT: "Alle gebouwen ({{count}})",
            ALL_LOCATIONS: "Alle locaties",
            ALL_ORGANIZATION: "Alle organisaties",
            ALL_DEVICES_COUNT: "Alle systemen ({{count}})",
            ADMINS_AND: "En",
            DASHBOARD_ASSETS_TITLE: "Activa",
            STATUS_BLOCKED: "Geblokkeerd",
            STATUS_COUNT_BLOCKED: "GEBLOKKEERD ({{count}})",
            BUILDING_CONTACT: "Contactpersoon bouwen",
            BUILDING_CONTACT_DETAILS_LABEL: "Details gebouwcontact",
            CHOOSE_LOCATION: "Kies Locatie",
            CONTACT_MANAGER: "Neem contact op met uw accountmanager of",
            ADD_ORGANIZATION: "Organisatie creëren",
            OVERVIEW_TITLE: "Dashboard",
            DASHBOARD_TITLE: "Dashboard",
            DEVICES_TITLE: "Apparaten",
            EARLIER: "Eerder",
            EDIT_CONTACT_BUTTON: "Contactgegevens bewerken",
            STATUS_EMPTY: "Leeg",
            STATUS_COUNT_EMPTY: "Leeg ({{count}})",
            ERROR_LOADING_CHANNELS: "Fout bij het laden van kanalen",
            ERROR_LOADING_DATA: "Fout bij het laden van gegevens",
            ERROR_LOADING_DEVICES: "Fout bij het laden van apparaten",
            ERROR_LOADING_EVENT: "Fout bij laden van gebeurtenis",
            ERROR_LOADING_EVENTS: "Fout bij het laden van gebeurtenissen",
            ERROR_LOADING_LOCATION: "Fout bij het laden van locatie",
            ERROR_LOADING_LOCATIONS: "Fout bij het laden van locaties",
            ERROR_LOADING_ORGANIZATION: "Fout bij het laden van organisatie",
            ERROR_LOADING_SITE: "Fout bij het laden van de site",
            ERROR_LOADING_SITES: "Fout bij het laden van sites",
            ERROR_LOADING_TRENDS: "Fout bij het laden van trends",
            EVENT_NOT_FOUND: "Evenement niet gevonden",
            STATUS_ANOMALY: "Bij anomalie",
            STATUS_COUNT_ANOMALY: "In afwijking ({{count}})",
            LAST_90_DAYS: "Afgelopen 90 dagen",
            LATEST_LOGS: "Nieuwste logboeken",
            LOCATION_NOT_FOUND: "Locatie niet gevonden",
            LOCATIONS_TITLE: "Locaties",
            LOCATION: "locaties",
            DASHBOARD_LOGBOOK_TITLE: "Logboek",
            MAIN_CONTACT_LABEL: "Hoofdgebouw contact",
            ADMINS_MORE: "meer",
            DASHBOARD_MANAGE_ORGANIZATION_TITLE: "Mijn organisaties",
            NO_FOUND: "Geen {{entity}} gevonden",
            NO_EVENTS: "Geen alarmen",
            NO_CHANNELS: "Geen kanalen",
            NO_CHANNELS_ENABLED: "Geen kanalen ingeschakeld",
            NO_DATA: "Geen gegevens",
            NO_DATA_POINTS: "Geen gegevens voor datumbereik opgegeven",
            NO_DEVICES: "Geen apparaten",
            NO_LOCATION_SELECTED: "Geen locatie geselecteerd",
            NO_LOCATIONS: "Geen locaties",
            NO_ORGANIZATION_SELECTED: "Geen organisatie geselecteerd",
            NO_SITES: "Geen sites",
            NO_TRENDS: "Geen trends",
            NO_USER_DATA: "Geen gebruikersgegevens",
            STATUS_COUNT_OFFLINE: "OFFLINE ({{count}})",
            ORGANIZATION_TITLE: "ORGANISATIE",
            ORGANIZATION_NOT_FOUND: "Organisatie niet gevonden",
            ORGANIZATION: {
                ORGANIZATION: "organisaties",
            },
            BUILDING_DETAIL_PHONE: "Telefoon",
            PLATFORM_USER_DASHBOARD_WARNING: "Ga naar de webapplicatie om alle functies ervan te verkennen",
            PROJECT: "PROJECT",
            STATUS_READY: "Klaar",
            STATUS_COUNT_READY: "KLAAR ({{count}})",
            DASHBOARD_REPORTS_TITLE: "Rapporten",
            SAVE_USER_DETAILS: "Bewaar gebruikersgegevens",
            SECONDARY_CONTACT_LABEL: "Secundair gebouwcontact",
            SITE_NOT_FOUND: "Site niet gevonden",
            SITE: "sites",
            TIMELINE_TITLE: "Tijdlijn",
            NEW_SITE: "om lid te worden of een nieuwe {{entity}} te maken.",
            UNKNOWN_DEVICE_TYPE: "Onbekend",
            EDIT_USER_DETAILS: "Details gebruiker",
            USERS_TITLE: "Gebruikers",
            VIEW_LOGBOOK: "Bekijk logboek",
            USERS_VIEWER: "Kijker",
            USERS_VIEWER_S: "Kijkers",
            NOT_ACCESS: "Je hebt nog geen toegang tot {{entity}}.",
            STARRED_ORGANIZATIONS: "Toon alleen organisaties met een ster",
            ALL_CUSTOMER: "Alle klanten",
            SERVICE_LEVEL_AGREEMENT: "# Service Level Agreement",
            ADD_CUSTOMER: "Klant toevoegen",
            ON_GOING_ALERTS: 'Doorlopende waarschuwingen',
            UPCOMING_IN_DAYS: 'Binnenkort over 30 dagen',
            CUSTOMER_TITLE: "Klant",
        },
        EVENT_DETAILS: {
            ACKNOWLEDGE: "Bevestigen",
            ACKNOWLEDGED: "Bevestigd",
            ACKNOWLEDGE_BY: "Bevestigen door {{user}} op",
            ACKNOWLWEGED_ERROR: "Bevestiging mislukt bij de communicatie met het eindapparaat op {{errorDate}}. Als dit probleem zich blijft voordoen, bel dan ons ondersteuningsteam op {{phoneno}} of stuur een e-mail naar ",
            DEVICE_MODEL: "Apparaatmodel",
            DEVICE_SERIAL: "Serienummer apparaat",
            ERROR_LOADING_DEVICE_DETAILS: "Fout bij het laden van apparaatgegevens",
            ERROR_LOADING_EVENT_DETAILS: "Details gebeurtenissen laden met fout",
            TITLE: "Details evenement",
            ALARM_STATUS: "Initiële alarmstatus",
            LAST_DATA_RECEIVED: "Laatste alarmupdate ontvangen",
            NO_DEVICE_DETAILS: "Geen apparaatgegevens",
            NO_EVENT_DETAILS: "Geen evenementdetails",
            PLEASE_RETRY: "Probeer het opnieuw:",
            SENDING: "Verzenden…",
            SET_POINT: "Instelpunt (drempel)",
            THRESHOLD: "Drempel",
            TIME_ALARM_SENT: "Tijd Initieel alarm verzonden",
        },
        DEVICE_DETAILS: {
            USERS_ADMINS: "admin",
            USERS_VIEWER: "viewer",
            FIRMWARE_AVAILABLE_GUIDE_LINK: "(Gids)",
            USERS_COUNTS: "{{adminCount}} admin, {{viewerCount}} viewer",
            FIRMWARE_AVAILABLE_GUIDE: "{{availableVersion}} Beschikbaar",
            LUMINARY_ATSD: "ATSD #",
            CONNECTION_TYPE_BLE: "BLE",
            BLOCK: "Geblokkeerd",
            BUILDING: "Gebouw",
            CONNECTION_TYPE_CELLULAR: "Mobiel",
            LUMINARY_CIRCUIT: "Circuit",
            LUMINARY_CIRCUIT_HASH: "Circuit #",
            CITY: "Stad",
            CONNECTED: "Aangesloten",
            CONNECTION_TYPE: "Verbinding type",
            DATE_COMMISSIONED: "Datum in gebruik genomen",
            DEVICE_MODEL: "Apparaatmodel",
            DEVICE_SERIAL: "Serieel apparaat",
            DURATION_TEST: "Duur test",
            DURATION_TEST_DURATION: "Duur van de test Duur van de test",
            ERROR: "Fout",
            CHANNEL_DATA_ERROR: "Fout bij het laden van kanaalgegevens",
            DEVICE_CONNECTION_ERROR: "Fout bij het laden van verbindingsgegevens",
            DEVICE_DETAILS_ERROR: "Fout bij het laden van apparaatgegevens",
            CONNECTION_TYPE_ETHERNET: "Ethernet",
            EVENT: "Gebeurtenis",
            FIRMWARE_VERSION: "Firmwareversie",
            FUNCTIONAL_TEST: "Functionele test",
            DELAY_FUNCTIONAL_TEST: "Vertraging functionele test",
            GATEWAY_ADDRESS: "Gateway-adres",
            GATEWAY_NAME: "Gateway-naam",
            GATEWAY_COUNT: "Gateway van {{systemCount}} systeem",
            GATEWAY_COUNT_SYSTEMS: "Gateway van {{systemCount}} systemen",
            HOSTNAME: "Host Name",
            LUMINARY_DETAIL_INFO: "Informatie",
            IPADDRESS: "IP-adres",
            LAST_DATA: "Laatste gegevens",
            LUMINAIRE: "Armatuur",
            LUMINARY_ADDRESS: "Armatuur adres",
            LUMINAIRES: "Armaturen",
            LUMINARIES_COUNTS: "Armaturen",
            MAC_ADDRESS: "Mac-adres",
            CONNECTION_TYPE_MODBUS: "Modbus",
            LUMINARY_MODEL: "Model",
            CONNECTION_TYPE_MQTT: "MQTT",
            LUMINARY_NAME: "Naam",
            NAME: "Naam",
            NETWORK_DETAILS: "Netwerkdetails",
            LUMINARY_DISCRIPTION: "Volgende duurtest begint",
            NEXT_DURATION_TEST: "Volgende duurtest begint",
            NEXT_FUNCTIONAL_TEST: "Volgende functionele test begint",
            NO_CHANNEL_DATA: "Geen kanaalgegevens",
            NO_DEVICE_CONNECTION: "Geen verbindingsgegevens voor apparaat",
            NO_DEVICE_DETAILS: "Geen gegevens over apparaatdetails",
            OFFLINE: "Offline",
            ONLINE: "Online",
            ORGANIZATION: "Organisatie",
            PART_NUMBER: "Onderdeelnummer",
            PREVIOUS: "Vorige",
            PREVIOUS_DURATION_TEST: "Vorige duurtest gestart",
            PREVIOUS_FUNCTIONAL_TEST: "Vorige functionele test gestart",
            READY: "Gereed",
            CONNECTION_TYPE_RS485: "RS485",
            SERIAL_NUMBER: "Serienummer",
            GATEWAY_SHOW_ALL: "Alles weergeven",
            STATUS: "Status",
            LUMINARY_STATUS: "Status",
            SUBNET_MASK: "Subnetmasker",
            SYSTEM: "SYSTEEM",
            SYSTEMS: "Systemen",
            LUMINARY_DETAIL_TEST: "Testen",
            LUMINARY_TYPE: "Type",
            UPDATE_REQUIRED: "UPDATE VEREIST",
            USERS: "Gebruikers",
            WARNING: "Waarschuwing",
            CONNECTION_TYPE_WIFI: "WiFi",
            CONNECTION_TYPE_WIREPASS: "Draadpas",
            UNASSIGNED: "Niet toegewezen",
            GATEWAYS: "Poorten",
            CONNECTION_TYPE_NO_ACTIVE_CONNECTION: "Geen actieve verbinding",
            TYPE: "Type",
            SLA_Number: "SLA-nummer",
            LUMINARY_SHORT_ADDRESS: "Adres",
            ERROR_COUNT: "Aantal fouten",
            ERROR_DETAILS: "Foutdetails",
            NEXT: "Volgende",
            UP_TO_DATE: "UP-TO-DATE",
            LUMINARY_ZONE: "Zone",
            NEXT_SERVICE_DUE: "Volgende onderhoudsbeurt nodig",
            LUMINARY_LINE: "LIJN #",
            TECHNICIAN: "Technicus",
            LUMINARY_STATUS_HEADER: "Armatuurstatussen",
            ERROR_NO_SLA_FOUND: "Geen SLA gevonden",
            ACTIVE: "Actief",
            TEST_GROUP: "Test groep",
            SLA_NUMBER: 'SLA-nummer',
            INPUT_ZONES: 'Ingangszones',
            DEVICES: 'Apparaten',
            SYSTEM_REPORT: 'Systeem rapport',
            INACTIVE: "Inactief",
            STATUS_FIRE: 'In brand',
            ARCHIVE: 'Archief',
            SORT_BY_OLDEST: 'Sorteren op Oudste bovenaan',
            SORT_BY_LATEST: 'Sorteren op Nieuwste bovenaan',
            PERIODIC_SERVICE: 'Periodiek onderhoud',
            REQUESTED_SERVICE: 'Gevraagde dienst',
            UNASSIGNED_SERVICE: 'Niet-toegewezen dienst',
            CUSTOM: 'Aangepast...',
        },
        FORMS: {
            OPTIONAL: "(Optioneel)",
            BUILDING_COMPANY_ADDRESS: "Adresregel 1",
            BUILDING_COMPANY_ADDRESS2: "Adresregel 2 (optioneel)",
            BUILDING_DETAILS: " Details gebouw",
            CITY: "Stad",
            USER_ADDRESS_1: "Bedrijfsadresregel 1",
            USER_ADDRESS_2: "Bedrijfsadresregel 2",
            COMPANY_NAME: "Bedrijfsnaam",
            CONFIRM_PASSWORD: "Bevestig wachtwoord",
            COUNTRY: "Land *",
            HELPING_TEXT: "Velden met een asterisk (*) zijn verplicht",
            FIRST_NAME: "Voornaam",
            LAST_NAME: "Laatste naam",
            LOCAL_PRIMARY_EMAIL: "E-mailadres lokaal primair contact",
            LOCAL_PRIMARY_CONTACT_INFO: "Informatie lokale primaire contactpersoon ",
            LOCAL_SECONDARY_EMAIL: "E-mailadres van plaatselijk secundair contact",
            LOCAL_SECONDARY_CONTACT_INFO: "Informatie lokale secundaire contactpersoon ",
            ORGANIZATION_ADDRESS_HEADER: "Organisatie Adres",
            COMPANY_ADDRESS: "Adres van de organisatie Regel 1",
            ADDRESS_LINE_2: "Adres van de organisatie Regel 2",
            ORGANIZATION_DETAILS_HEADER: "Organisatiedetails",
            PASSWORD: "Wachtwoord",
            PASS_MATCH_ERROR: "Wachtwoorden komen niet overeen",
            PHONE_NUMBER: "Telefoonnummer",
            INVALID_CUSTOMER_NUMBER: "Geef een geldig klantnummer op",
            INVALID_EMAIL_ERROR: "Geef een geldig e-mailadres op",
            INVALID_DETAILS: "Geef geldige invoerparameters op",
            INVALID_PHONE_NUMBER: "Geef een geldig telefoonnummer op",
            INVALID_POSTAL_CODE: "Geef een geldige postcode op",
            INVALID_SLA_NUMBER: "Geef een geldig SLA-nummer op van minimaal 8 tekens",
            POSTAL_CODE: "Postcode",
            PRIMARY_CONTACT_INFORMATION: "Primaire contactgegevens",
            RESET_PASSWORD: "Wachtwoord opnieuw instellen",
            TOGGLE_PASSWORD_VISIBILITY: "Wachtwoord weergeven",
            VERIFICATION_CODE: "Verificatie Code",
            SLA_EXPIRATION_DATE_INVALID: "De vervaldatum van de SLA mag niet in het verleden liggen. Geef een geldige datum op.",
            BUILDING_ADDRESS: "Adres gebouw",
        },
        DUALSMART: {
            DS_LUMINARIES_FOUND: "Lichtbronnen gevonden",
            DS_CIRCUIT_READY: "Circuit gereed",
            DS_COMMUNICATION_FAILURE: "Communicatie fout",
            DS_DIMM_ERROR: "Dimm-fout",
            DS_OVERCURRENT: "Overstroom",
            DS_SAVE_UPDATE_BUTTON: "Update opslaan",
            DS_CONNECTED_POWER_INFO: "10W / 15VA",
            DS_SYSTEM_COMPONENTS_COUNT: "7 componenten",
            DS_LUMINARIES_FOUND_TITLE: "Op dit systeem zijn armaturen aangetroffen.",
            DS_AE_ERROR: "Ae-fout",
            DS_ALL_STATUSES: "Alle statussen",
            DS_ALL_TESTS_PASSED: "Alle tests zijn geslaagd",
            DS_ESTIMED_GUIDELINE_ONE: "Circa 10 jaar bij 20 °C",
            DS_ESTIMED_GUIDELINE_THREE: "Circa 5 jaar bij 30 °C",
            DS_ESTIMED_GUIDELINE_TWO: "Circa 5 jaar bij 25 °C",
            DS_BATTERY_CHARGER: "Batterij / oplader",
            DS_BATTERY_CHARGE: "Batterijlading",
            DS_BATTERY_OPERATION: "Batterijwerking",
            DS_BLOCK_DEVICE: "Blokkeer apparaat",
            DS_BLOCK_DEVICE_INFO: "Apparaat blokkeren Blokkeert de noodfunctie en schakelt het circuit uit",
            DS_BLOCK_SUCCESS: "Blokkeren is succesvol uitgevoerd",
            DS_BULB_ERROR_AC: "Lampfout AC",
            DS_BULB_ERROR_DC: "Lampfout DC",
            DS_CAPACITY: "Capaciteit",
            DS_CHARGER_LEVEL: "Laadniveau:",
            DS_CHARGING_ERROR: "Oplaadfout",
            DS_FUNCTIONAL_GUIDELINE: "Kies een tijd tussen 20 - 800 seconden waarin het systeem moet communiceren wanneer voor een test wordt overgeschakeld naar batterijvoeding.",
            DS_CIRCUIT: "Circuit",
            DS_CIRCUIT_FAILURE: "Storing in circuit",
            DS_CIRCUITS_INFO_HEADER: "Circuit informatie:",
            DS_CIRCUITS_NO: "Circuit nummer",
            DS_CIRCUITS: "Circuits",
            DS_COMPONENTS_DETAIL: "Component details",
            DS_CONNECTED_POWER: "Aangesloten vermogen:",
            DS_CRYSTALWAY: "Kristalweg 20m",
            DS_DAYS_BETWEEN_THE_TEST: "Dagen tussen tests",
            DS_DC1: "DC1",
            DS_DC2: "DC2",
            DS_KEEP_DEEP_DISCHARGE: "Bescherming tegen diepontlading Actief",
            DS_DELAY_ON_MAINS_RETURN: "Vertraging bij terugkeer netspanning",
            DS_ESTIMED_GUIDELINE: "Afhankelijk van de omgevingstemperatuur en de omstandigheden ter plaatse:",
            DS_DESCRIPTION: "Beschrijving",
            DS_END_DURATION_TEST_POPUP: "Wilt u de duurtest stopzetten?",
            DS_DOUBLE_ADDRESS: "Dubbel adres",
            DS_DT_FORERUN: "DT-voorloop",
            DS_DEVICE_COMMISSIONING: "Dubbele slimme inbedrijfstelling",
            DS_PASSWORD: "Dubbel slim wachtwoord",
            DS_DURATION: "Duur",
            DS_DURATION_TEST: "Duur test",
            DS_DURATION_TEST_SCHEDULE: "Duur test schema",
            DS_EDIT_BATTERY_DETAILS: "Batterijgegevens bewerken",
            DS_DASH_EMPTY: "Leeg",
            DS_ESTIMED_LIFESPAN: "Geschatte levensduur",
            DS_EXIT_SIGN: "Verlaten",
            DS_FAN_OPERATING_HOURS: "Bedrijfsuren ventilator",
            DS_FOUND: "Gevonden",
            DS_FT_FORERUN: "FT Voorloop",
            DS_FUNCTIONAL: "Functioneel",
            DS_FUNCTIONAL_LEAD_AND_TIME: "Functionele doorlooptijd",
            DS_FUNCTION_TEST: "Functionele test",
            DS_FUNCTIONAL_TEST_SCHEDULE: "Planning functionele test",
            DS_SYNC_DATE_AND_TIME_SUBTITLE: "G-Noord” Hoofdkantoor",
            DS_CIRCUITS_DESCRIPTION: "Help mij met de beschrijving",
            DS_SEARCH_LUM_INFO_TEXT: "Als u alleen armaturen hoeft toe te voegen, gebruikt u de optie Zoeken naar nieuwe armaturen",
            DS_SEARCH_LUMS_POPUP_SUB_TITLE: "Als u alleen nieuwe armaturen hoeft toe te voegen, gebruikt u de optie Zoeken naar nieuwe armaturen.",
            DS_INSTALLATION_DATE: "Installatie Datum",
            DS_INTERVAL: "Interval",
            DS_CIRCUITS_INFO: "Sleutel nodig. Beperkt gebied! Registratie vereist.",
            DS_LAST_DURATION_TEST_TIME: "Testtijd laatste duur",
            DS_LIGHTANDBUILDING: "Licht & Bouwen 2024",
            DS_LUMINAIRE_FAILURE: "Armatuur Storing",
            DS_LUMINAIRE_NAME: "Naam armatuur",
            DS_LUMINARIES: "armaturen",
            DS_MAINS_OPERATION: "Hoofdkantoor",
            DS_NORMAL_OPERATION: "Normale werking",
            DS_OPERATION_FAILED: "Operatie mislukt",
            DS_OVERTEMPERATURE: "Overtemperatuur",
            DS_OVERVOLTAGE: "Overspanning",
            DS_PREV: "Vorige",
            DS_READY_ON: "Klaar-aan",
            DS_RELEASE_DEVICE: "Laat apparaat los",
            DS_RELEASE_DEVICE_INFO: "Apparaat vrijgeven Schakelt terug naar bedrijf.",
            DS_RELASE_SUCCESS: "De vrijgave is met succes uitgevoerd",
            DS_SEARCH_LUM_WARNING_TEXT: "Gegevens ophalen. Wacht een paar seconden en probeer opnieuw te knippen of kopiëren.",
            DS_CIRCUIT_LUMINARIES_DESC: "Gegevens ophalen. Wacht een paar seconden en probeer opnieuw te knippen of kopiëren.",
            DS_SEARCH_COMPLETE: "Zoeken voltooid",
            DS_SEARCH_GUIDLINE_ONE_TEXT: "Zoek naar alle geïnstalleerde en geadresseerde armaturen",
            DS_SEARCH_ALL_LUMINARIES: "Zoek naar alle armaturen",
            DS_SEARCH_LUM_TEXT: "Search for All Luminaries zal een nieuwe configuratie creëren door het volgende te doen:",
            DS_SEARCH_LUMS_POPUP_TITLE: "Als u de zoekopdracht start, worden alle geactiveerde armaturen met een defect uit uw configuratie verwijderd.",
            DS_SEARCH_GUIDLINE_TWO_TEXT: "Als u de zoekopdracht start, worden alle geactiveerde bestanden verwijderd. defecte armaturen uit uw configuratie",
            DS_STARTS: "Begint",
            DS_SUMMARY_FT: "Samenvatting van de functietest",
            DS_SYNC_DATE_AND_TIME: "Synchronisatietestschema",
            DS_SYSTEM_COMPONENTS: "Systeemcomponenten",
            DS_SYNC_DATE_AND_TIME_TITLE: "Testdata en -tijden",
            DS_TEST_INTERVAL: "Testinterval",
            DS_TEST_LENGTH: "Testlengte",
            DS_VIEW_CIRCUITS: "Bekijk per circuit",
            DS_W: "W:",
            DS_SEARCH_FOR_NEW_LUMINARIES: "Zoek naar nieuwe armaturen",
            DS_SEARCH_LUM_NEW_TEXT: "Zoek naar nieuwe armaturen om toe te voegen aan uw verlichtingsconfiguratie:",
            DS_SEARCH_NEW_LUM_GUIDLINE_ONE_TEXT: "Hierdoor worden automatisch adressen toegewezen aan nieuwe of vervangen armaturen in uw verlichtingsconfiguratie.",
            DS_SEARCH_NEW_LUM_INFO_TEXT: "Als u alleen armaturen hoeft toe te voegen, gebruikt u de optie Zoeken naar nieuwe armaturen",
            DS_NEW: "Nieuw",
            DS_MODULE_TYPE: "Moduletype",
            DS_SEARCH_IO_MODULES: "Zoek I-Bus-modules",
            DS_SEARCH_FOR_IO_MODULES: "Zoek naar IO-modules",
            DS_SEARCH_IO_MODULES_TEXT: "Zoeken naar IO-modules Maak een nieuwe configuratie door het volgende te doen:",
            DS_SEARCH_GUIDELINE_IO_MODULES_TEXT: "Zoek naar alle geïnstalleerde modules op de bus om deze te configureren en te programmeren.",
            DS_SEARCH_IO_MODULES_BTN_TEXT: "Zoeken naar IO-modules",
            DS_SEARCH_IO_MODULES_POPUP_TITLE: "Als modules niet correct zijn aangesloten, zal dit de toegepaste configuratie permanent wijzigen.",
            DS_SEARCH_IO_MODULES_POPUP_SUB_TITLE: "Zorg ervoor dat alle verbindingen correct zijn voordat u met zoeken begint.",
            DS_PHYSICAL_MODULES: "Fysieke modules",
            DS_SUBSCRIBED_MODULES: "Onderschreven",
            DS_MODULES_FOUND: "Modules gevonden",
            DS_MODULE_NUMBER: "Modulenr.",
            DS_SEARCHING: "Zoeken...",
            DS_TIMER: "Timer",
            DS_SET_TIMER: "Timer instellen",
            DS_SUBMIT_CHANGES: "Wijzigingen indienen",
            DS_TIMER_1: "Timer 1",
            DS_TIMER_2: "Timer 2",
            DS_TIME_TITLE: "Timertitel (optioneel)",
            DS_DAYS: "Dagen van de week en tijd",
            DS_ACTIVE_DAYS: "Selecteer de dagen van de week waarop ___ actief moet zijn.",
            DS_START_TIME: "Begintijd",
            DS_END_TIME: "Eindtijd",
            DS_SET_RELAY_BUZZER: "Relais zoemer instellen",
            DS_RESET_TO_DEFAULT_VALUES: "Terugzetten naar standaardwaarden",
            DS_RESET_TO_DEFAULT_VALUES_INFO: "Selecteer de uitgang om de functies ervan toe te wijzen. Tik op “Opslaan” als u klaar bent.",
            DS_SEARCH_NEW_LUMINARIES_INFO: "Gebruik deze resultaten om een ​​nieuwe verlichtingsconfiguratie te maken en te delen met behulp van ‘Exporteren’.",
            DS_RELAY_NO: "Relais nr.",
            DS_RESET_RELAY_BUZZER_POPUP_TITLE: "Bevestigen",
            DS_RESET_RELAY_ONE_TO_DEFAULT: "Reset relais 1 naar standaard",
            DS_RESET_RELAY_BUZZER_TO_DEFAULT: "Reset relais en zoemer naar standaard",
            DS_UNSAVED_CHANGES_POPUP_TITLE: "Er zijn niet-opgeslagen wijzigingen",
            DS_UNSAVED_CHANGES_POPUP_SUB_TITLE: "U heeft uw wijzigingen in Relay 1 niet opgeslagen. Wilt u opslaan?",
            DS_DISCARED_CHANGES: "Wijzigingen negeren",
            DS_CIRCUIT_TITLE: "Armaturen die in dit venster aan/uit worden geschakeld, keren terug naar hun geconfigureerde status nadat het systeem de volgende schakelhandeling heeft voltooid.",
            DS_EMPTY: "Leeg / mislukt",
            LUM_TITLE: "Tik op armaturen om ze in en uit te schakelen",
            ALL_OFF: "Alles uit",
            DS_RESET_TITLE: "Terugzetten naar standaard",
            DS_CONTROL_LUM: "Controle armaturen",
            DS_LUM_BUTTON: "Armaturen in-/uitschakelen",
            DS_APPLY: "Pas toe",
            DS_SET_IO_BUS_MODULES_TITLE: "I-Bus-modules instellen",
            DS_NEXT_MODULE: "Opslaan en naar volgende module gaan",
            DS_MODULE_DETAILS: "Module details",
            DS_MODULE_NAME: "Module naam",
            DS_LOCAL_ONLY: "Alleen lokaal",
            DS_PUBLISH: "Publiceren",
            DS_SUBSCRIBE: "Abonneren",
            DS_ACU_BUS_ID: "ACU-bus-ID",
            DS_BUS_MODULE: "Bus module",
            DS_INPUTS: "Ingangen",
            DS_CONFIGURED_MODULE_TITLE: "Er zijn momenteel geen fasebewakingsingangen geconfigureerd op deze module.",
            DS_CONFIGURE_INPUTS: "Configureer ingangen",
            DS_BLOCK: "Blok",
            DS_RELEASE: "Vrijgeven",
            DS_BLOCK_GUIDLINE: "Hiermee wordt de noodoproepfunctie geblokkeerd en worden de circuits uitgeschakeld.",
            DS_RUN_TESTS: "Tests uitvoeren",
            DS_LUMINARIE_CONTROLS: "Armatuurbediening",
            DS_LUMINARIE_CONTROLS_GUIDELINE: "Met deze functies kunt u de geconfigureerde programmering van de armatuur negeren totdat deze wordt uitgeschakeld.",
            DS_ALL_LUMINARIES_ON: "Alle armaturen aan",
            DS_INACTIVE: "Inactief",
            DS_MAINTAINED_LUMINARIES_OFF: "Onderhouds armaturen uit",
            DS_NON_MAINTAINED_LUMINARIES_OFF: "Niet-permanente armaturen Aan",
            DS_RESET_SYSTEM_STATE: "Systeemstatus resetten",
            DS_MANUAL_RESET: "Handmatige reset",
            DS_RESET_ISO_FAILURE: "ISO-storing resetten",
            DS_RECHARGE_DEEP_DISCHARGE_PROTECTION: "Reset diepontladingsbeveiliging",
            DS_SIMULATE_MAINS_FAILURE: "Simuleer netstoring",
            DS_SEARCH_ISO_FAILURE: "Zoek ISO-fout",
            DS_SET_I_BUS_MODULES: "I-Bus-modules instellen",
            DS_COMMISSIONING: "Inbedrijfstelling",
            DS_DATE_AND_TIME: "Datum en tijd",
            DS_RESET_SERVICE_CENTER: "Serviceteller resetten",
            DS_ALERT_LEVEL: "Waarschuwingsniveau",
            DS_DRY_CONTACT: "Droog contact",
            DS_BUILDING_MANAGMENT_SYSTEM: "Gebouwbeheersysteem (GBS)",
            DS_MODBUS: "Modbus",
            MANAGE_INTERNET_CONNECTION: "Beheer de internetverbinding",
            INTERNET_CONNECTION: "Internetverbinding",
            SYSTEM_LOCATION: "Systeemlocatie",
            SUB_LOCATION: "Sublocatie",
            TIME_PERIOD_NINTY_DAYS: "Elke 90 dagen",
            DS_SEARCH_ISO_FAILURE_TITLE: "Zoeken naar isolatiefouten?",
            DS_SEARCH_ISO_FAILURE_BODY: "Druk op “Zoeken” om de betrokken circuits te bepalen als u een ISO-foutbericht ontvangt.",
            DS_SEARCH: "Zoeken",
            DS_MAIN_FAILURE_MSG: "Dit simuleert gelijkstroomwerking en duurt ongeveer 5 seconden voordat er wordt teruggeschakeld naar de normale werking.",
            DS_START: "Begin",
            DS_DEEP_DISCHARGE: "Bevestiging van bescherming tegen diepe ontlading",
            DS_DEEP_DISCHARGE_MSG: "Door “Bevestigen” te selecteren, verifieert u dat u getuige bent geweest van een diepe ontlading van de batterijen van het systeem",
            DS_ACKNOWLEDGE: "Erkennen",
            DS_RESET_ISO: "Isolatiefout resetten?",
            DS_RESET_ISO_MSG: "Als de ISO-fout zich opnieuw voordoet en er geen oorzaak kan worden gevonden na controle van de eindcircuits, neem dan contact op met de serviceafdeling.",
            DS_RESET: "Opnieuw instellen",
            DS_MANUAL_RESET_TITLE: "Handmatige reset uitvoeren?",
            DS_MANUAL_RESET_MSG: "Alle veiligheidsarmaturen schakelen op basis van hun programmering terug naar de normale werking",
            DS_BLOCK_TITLE: "Het systeem blokkeren en de duurtest beëindigen?",
            DS_CONFIRM_BLOCK: "Bevestig & Blokkeer",
            DS_BLOCK_TEXT: "De batterij heeft minimaal 24 uur nodig om op te laden voordat een nieuwe duurtest wordt uitgevoerd.",
            TRIGGERS: "Triggers",
            DEFAULT_TRIGGERS: "Standaardtriggers",
            OPTIONAL_TRIGGERS: "Optionele triggers",
            EMPTY_TRIGGERS_LINE: "Er zijn geen optionele triggers geconfigureerd.",
            ADD_TRIGGER: "Trigger toevoegen",
            SELECT_TRIGGERS: "Selecteer Triggers",
            ASSIGN: "Toewijzen",
            ASSIGN_TRIGGERS: "Triggers toewijzen",
            SELECTED: "Gekozen",
            INSTALLED: "Geïnstalleerd",
            SCENARIO: "Scenario",
            LUMINARIES_COUNT: "10 van 10 Armaturen",
            DS_INPUT_OF_PHASE_MONITOR: "Ingang van een fasemonitor",
            DS_CIRCUIT_TRIGGERS_SUCCESSFULLY_LINE: "Circuit nr. 1 Triggers zijn succesvol geconfigureerd.",
            DS_SET_OTHER_CIRCUIT_TRIGGERS: "Stel andere circuittriggers in",
            DS_ASSIGN_DEFAULT_TRIGGERS_GUIDELINE: "Tik of sleep over armaturen om ze aan deze trigger toe te wijzen.",
            DS_ASSIGN_TRIGGERS_GUIDELINE_TWO: "Bevestig elke trigger voor circuit 1.",
            DS_NON_MAINTAINED_LIGHT: "Niet-onderhouden licht",
            DS_MAINTAINED_LIGHT: "Onderhouden licht",
            DS_INSTALLED_LUMINARIES: "Geïnstalleerde armaturen",
            DS_TIMER_SCHEDULE: "Weekdag schema",
            DS_DEEP_DISCHARGE_TITLE: "Diepe ontlading",
            DS_STIMULATE_MAIN_FAILURE: "Stimuleer hoofdstoring",
            DS_START_FUNCTIONAL_TEST: "Functionele test starten",
            DS_SHORT_LEAD_TIME: "Gebruik een korte doorlooptijd",
            DS_ASSIGNED_PHASE_MONITORING_INPUT: "Toegewezen fasebewakingsingangen",
            DS_INPUT_CONFIGURATION_TITLE: "Invoerconfiguratie",
            DS_ASSIGNED_FUNCTION: "Toegewezen functie",
            DS_PHASE_MONITORING_INPUT: "Fasebewakingsingangen L1/L2/L3",
            DS_RESET_OPTION: "Optie opnieuw instellen",
            DS_LENGTH_OF_TIME: "Tijdsduur",
            DS_PHASE_MONITOR: ": Fasemonitor",
            DS_ENTRY_MESSAGE: "Voer uw inloggegevens in",
            DS_NO_OPERATION_POSSIBLE: "Geen bediening mogelijk",
            LUMINARY_TOTAL: "totaal armaturen",
            DS_TOTAL_FAILURES: "Totaal aantal storingen",
            DS_MAINTAINED_LUMINARIES_ON: "Onderhouden armaturen aan",
            DS_SET_TEST_SCHEDULE: "Stel het testschema in voor",
            DS_NEXT_TEST_DATE: "Volgende testdatum",
            BROKER_URL: "Broker-URL",
            PORT: "Poort",
            ENCRYPTION: "Versleuteling",
            AUTHENTICATION: "Authenticatie",
            SYNCHRONIZATION: "Synchronisatie",
            MAX_UPDATE_RATE: "Maximale updatefrequentie (in seconden)",
            CLIENT_ID : "Client-ID",
            KEEP_ALIVE_TIME: "Keep-alive tijd (in seconden)",
            ENCRYPTION_PROTOCOL: "Versleutelingsprotocol",
            TCP_CONNECTION: "TCP-verbinding",
            GENERAL: "Algemeen",
            MODBUS_TCP_PORT: "Modbus TCP-poort",
            ADVANCED: "Geavanceerd",
            DS_INPUTS_RELAYS: "Ingangen & relais",
            CIRCUITS: "circuits",
            DS_SYSTEM_COMPONENT: "Systeemcomponent",
            DS_BATTERY: "Accu",
            DS_BATTERY_VOLTAGE: "Spanning",
            DS_BATTERY_CURRENT: "Stroom",
            DS_BATTERY_CHARGE_LEVEL: "Laadniveau",
            DS_3PM_BUS: "I Bus-modules",
            DS_MODULES: "10 modules",
            DS_SYSTEM_MODULE_ADDRESS: "Moduleadres",
            DS_DC: "DC / DC",
            DS_STATE: "Status",
            DS_DC_OVERLOAD: "Overbelasting",
            DS_DC_TEMPRATURE: "Temperatuur",
            DS_DC_HARDWARE_REV: "Hardwareversie",
            DS_DEFAULT_INPUTS: "Standaard ingangen",
            DS_S1_S2_NOT_BLOCKED_DESC: "Systeem niet geblokkeerd via S1/S2",
            DS_PUBLISHED: "GEPLAATST",
            DS_S3_S4_MAINS_FAILURE_DESC: "Netspanningsuitval S3/S4 gedetecteerd",
            DS_OPTIONAL_INPUTS: "Optionele ingangen",
            DS_ENERGIZED: "Geactiveerd",
            DS_START_DT: "Start duurtest",
            DS_DE_ENERGIZED: "Gedeactiveerd",
            DS_NOT_CONFIGURED: "Niet geconfigureerd",
            DS_FUCTIONAL_TEST_TEXT: "Geschatte testduur: 00:02:00\n\n' + 'Voorlooptijd: Standaard \n",
            GENERAL_SETTINGS: "Algemene instellingen",
            SYSTEM_CONTROLS: "Systeembediening",
            GENERAL_SETTINGS_LAUNCH_FT_TITLE: "Start functionele test na ingang vrijgave",
            GENERAL_SETTINGS_LAUNCH_FT_SUBTITLE: "Het systeem voert een functionele test uit zodra het is vrijgegeven",
            GENERAL_SETTINGS_SHUTDOWN_ATSD_TITLE: "Centrale ATSD-omschakeling uitschakelen bij stroomuitval",
            GENERAL_SETTINGS_SHUTDOWN_ATSD_SUBTITLE: "Dit betekent dat de armaturen bij stroomuitval via fasebesturing worden ingeschakeld.",
            GENERAL_SETTINGS_ENABLED_DIM_TITLE: "Dimwaarde inschakelen bij scenario-instelling",
            GENERAL_SETTINGS_ENABLED_DIM_SUBTITLE: "Hiermee kunt u dimwaarden toepassen in de circuittriggerconfiguratie.",
            VISIONGUARD: {
                MQTT_CONNECTION: "MQTT-verbinding",
                EDIT_DETAILS: "Details bewerken"
            },
            MODBUS: {
                MODBUS_SETTINGS: "Modbus-instellingen",
                ADVANCED_SETTINGS_TITLE: "De uitgebreide commando's worden via de modbus uitgevoerd als deze hieronder zijn geactiveerd.",
                START_STOP_DURATION_TEST: "Start/Stop duurtest",
                MANUAL_RESET: "Handmatige reset",
                BLOCK_RELEASE: "Blokkeren/Vrijgeven",
                RESET_DEEP_DISCHRGE_PROTECTION: "Reset diepe ontladingsbeveiliging",
                ALL_LUMINARIES_ON: "Alle armaturen aan / Alle armaturen naar schakelstand",
                BMS_SWITCH: "BMS-schakelaar"
            },
            BUZZER: {
                CHARGER_FAILURE: "Laderstoring",
                LUM_FAILURE: "Armatuurstoring",
                DEVICE_FAILURE: "Apparaatstoring"
            },
            DS_VIEW_ALL_LUMINARIES: "Alle armaturen weergeven",
            DS_ALL_CIRCUITS: "Alle circuits"
        },
        LOGBOOK_DETAILS: {
            LABEL_EVENT_AGO: "geleden",
            ADD_COMMENTS: "+ Opmerkingen toevoegen...",
            REQUIRES_FIRMWARE_UPDATE: "1  FIRMWARE UPDATE NODIG",
            ACKNOWLEDGE: "Erkennen",
            ACKNOWLEDGED: "Erkend",
            ACKNOWLEDGED_BY: "Erkend door",
            PREVIOUS_ACKNOWLEDGED_BY: "Erkend door:",
            ACTIVE: "Actief",
            ACTIVE_ACKNOWLEDGED: "Actief. Erkend",
            AT: "Op",
            LABEL_CLOSED: "gesloten",
            CLOSED: "Gesloten",
            COMMENTS: "Opmerkingen",
            DESCRIPTION: "Beschrijving",
            DEVICE: "Apparaat",
            EDIT: "Bewerking",
            EVENT: "Gebeurtenis",
            LABEL_EVENT_BEGAN: "Gebeurtenis begon:",
            LABEL_EVENT_CLOSE: "Gebeurtenis gesloten:",
            LOGBOOKDETAIL: "LogBoekDetail",
            NO_PREVIOUS_LOG_TITLE: "Geen vorig logitem op dit systeem",
            PREVIOUS_LOG_ITEM: "Vorig logitem op dit systeem",
            PREVIOUS_LOG_TITLE: "Vorig logitem op dit systeem",
            STATUS: "Status",
            SYSTEM: "Systeem",
            TIMESTAMP: "Tijdstempel",
            SYSTEM_TYPE: "Type:",
            NO_PREVIOUS_LOG: "Geen vorig logboek",
        },
        ORGANIZATION_MANAGE: {
            BUILDING_COUNT: "Gebouw",
            BUILDING_COUNT_S: "Gebouwen",
            ORGANIZATION_MANAGE: "Gebouwen",
            ADMIN_COUNT: "Organisatie Admin",
            ADMIN_COUNT_S: "Organisatie Admins",
            VIEWER_COUNT: " Organisatie gebruikers",
            VIEWER_COUNT_S: " Organisatie gebruikers",
            SYSTEM_COUNT: "Systeem",
            SYSTEM_COUNT_S: "Systemen",
            ADD_NEW_BUILDING: "+ Nieuw gebouw toevoegen",
            CREATE_ORGANIZATION: "+ Organisatie creëren",
            ERROR_ADD_NEW_SYSTEM_ACTION: "Voeg nieuwe systemen toe",
            ALL: "Alle",
            SORT_TYPE_NAME: "Alfabet",
            SORT_TYPE_CITY: "Stad",
            COMMENTS_HELPER: "Opmerkingen om technici te helpen ter plaatse te komen.",
            ORGANIZATION_NAME_HELPER: "Alleen letters, cijfers, onderstrepingstekens en streepjes",
            MARK_AS_FAV_API_FAILURE_MESSAGE: "Markeer als mislukt",
            ERROR_NO_BUILDING_FOUND: "Geen gebouw gevonden",
            ERROR_NO_GATEWAY_FOUND: "Geen gateway gevonden",
            ERROR_NO_LOGS_TITLE: "Geen logs gedurende deze periode",
            ERROR_NO_LUMINARY_FOUND: "Geen Luminaries gevonden",
            ERROR_NO_ORG_FOUND: "Geen organisatie gevonden",
            ERROR_NO_REPORT_FOUND: "Geen rapporten gevonden",
            ERROR_NO_SYSTEM_FOUND: "Geen systeem gevonden",
            ERROR_NO_USER_FOUND: "Geen gebruiker gevonden",
            SORT_TYPE_NUMBER_OF_SYSTEMS: "Aantal systemen",
            QUIT_EDIT_USER_DETAILS: "Stop met bewerken",
            QUIT_TITLE: "Stoppen met het bewerken van “{{orgName}}”?",
            ERROR_READ_INSTALLATION_MANUALS_ACTION: "Lees de installatiehandleidingen",
            SEARCH: "Zoeken",
            SEARCH_BUILDINGS: "Zoeken...",
            SEARCH_BUILDINGS_DASHBOARD: "Zoeken in  gebouwen",
            SEARCH_SYSTEM_DASHBOARD: "Zoeken systemen",
            SORT_BY_HEADER: "SORTEER OP",
            STARRED_ORGANIZATIONS: "Organisaties met sterren",
            VIEW_ORGANIZATION: "Organisatie bekijken",
            ERROR_NO_DEVICE_TITLE: "U heeft nog geen activa in deze organisatie.",
            ERROR_NO_DEVICE_DESCRIPTION: "U ziet statusinformatie over uw noodverlichting zodra u activa (systemen) aan deze organisatie gaat toevoegen.",
            QUIT_MESSAGE: "Uw niet-opgeslagen wijzigingen gaan verloren.",
        },
        ADD_BUILDING: {
            BLDG_ORG_CONTACT: "contacten",
            BLDG_ADDITIONAL_DESC: "Optionele extra opmerkingen toevoegen om uw serviceteam te helpen",
            BLDG_ADD_DESCRIPTION: "Aanvullende beschrijvingen",
            BLDG_ADDRESS: "adres",
            BLDG_CREATTION: "Gebouw gemaakt",
            BUILD_CREATE_SUCESS: "Gebouw succesvol aangemaakt",
            BLDG_HEADER: "Nieuw gebouw maken voor ",
            BLDG_LOCATION_MESSAGE: "Sleep de kaart om de pin te plaatsen in de buurt van waar het gebouw zich bevindt. Dit helpt monteurs om in de toekomst snel ter plaatse te zijn.",
            BLDG_EDIT_BTN: "Contactgegevens bewerken",
            BLDG_NAMELENGTH: "“Ex., hoofdkantoor, magazijn”.",
            BLDG_INITILIZING_NETWORK: "Netwerk initialiseren...",
            BLDG_INSIDE: "binnen",
            BLDG_LOCAL_CONTACT: "Contact Plaatselijk Gebouw",
            BLDG_CONTACT_TITLE: "Details contactpersoon lokaal gebouw",
            BLDG_LOCATE_ON_MAP: "Lokaliseren op een kaart in plaats van",
            BLDG_LOCATION: "Locatie",
            BLDG_ADDTIONAL_DETAILS: "Laten we nu wat extra details toevoegen om de installatie te voltooien",
            ORG_CREATE_SUCESS: "Organisatie succesvol aangemaakt",
            BLDG_ADDITION_ERROR: "Voer een geldig adres in.",
            BLDG_PRIMARYCONTACT: "Primaire contactpersoon",
            BLDG_PRIMARY_LOCAL_CONTACT: "Primaire lokale contactpersoon",
            BLDG_SECONDARYCONTACT: "Secundair contact (optioneel)",
            BLDG_SECONDARY_LOCAL_CONTACT: "Secundaire lokale contactpersoon",
            BLDG_NO_POSTAL_ADDRESS: "Selecteer deze optie als er geen postadres beschikbaar is",
            BLDG_CREATED_MESSAGE: "Succesvol aangemaakt",
            BLDG_ORGANIZATION_FOR: "Gebruik organisatie",
            BLDG_ADD_CONTACT: "Met wie moeten elektriciens contact opnemen over Hoofdkantoor",
            SAVE_CHANGES_MSG: "Uw wijzigingen zijn opgeslagen",
            BLDG_ORG_CONTACTS: "Contacten",
            ADD_BUILDING_INTERNET_CONNECTION: "Kan geen gebouw toevoegen. Maak verbinding met internet en probeer het opnieuw",
        },
        USER_SETTINGS: {
            AUTOMATIC_LOGOUT_SUBTITLE: "Schakel het automatisch verlopen van een sessie van 15 minuten uit",
            ALARMS: "FT is mislukt, DT is mislukt, Verbinding verbroken, Batterij defect, Lamp defect, ATSD defect",
            PHONE_NO_TEXT: "Een mobiel nummer is nodig om sms notificaties te ontvangen",
            ACCOUNT: "Rekening",
            ACCOUNT_CREATED_DATE: "Account aangemaakt",
            ADDRESS: "Adres",
            ALARMS_TITLE: "Alleen kritieke alarmen",
            APPLICATION_THEME_COLOR: "Kleur toepassingsthema",
            AUTOMATIC_LOGOUT: "Automatisch uitloggen",
            UNITS_DESCRIPTION: "Britse imperiale eenheden",
            BUILDING_NAME: "Naam gebouw",
            TIMEZONE_DESCRIPTION: "Midden-Europese tijd (GMT-1:00)",
            CHANGE_PASSWORD: "Wachtwoord wijzigen",
            COMPANY_ADDRESS: "Adres bedrijf",
            COMPANY_NAME: "Bedrijfsnaam",
            COMPANY_PHONE_NUMBER: "Telefoonnummer bedrijf",
            DATE_FORMAT: "Datumformaat",
            DATEFORMAT_DESCRIPTION: "DD/MM/JJJJ",
            DELETE_ACCOUNT: "Account verwijderen",
            STATUS_UPDATES: "Apparaat bevindt zich in blokkeermodus, noodmodus, onderhoud aangevraagd",
            AUTOMATIC_LOGOUT_TITLE: "Automatisch afmelden uitschakelen",
            EMAIL: "E-mailadres",
            EMAIL_NOTIFICATION: "E-mailmeldingen",
            TEXT_NOTIFICATION_TITLE: "Tekstmeldingen (SMS) inschakelen",
            ENABLED: "Ingeschakeld",
            TEXT_NOTIFICATION_BODY: "Als u sms-meldingen inschakelt, kunnen er bij uw mobiele serviceprovider extra sms-kosten in rekening worden gebracht. Deze kosten zijn niet inbegrepen in de Eaton Serviceovereenkomst.",
            LANGUAGE_DESCRIPTION: "Dutch",
            HEALTH_REPORT_TITLE: "Gezondheidsrapport",
            LANGUAGE: "Taal",
            HEALTH_REPORT: "Maandelijkse rapportage",
            PRODUCT_UPDATES: "Nieuwe releases, firmware-update beschikbaar",
            NOTIFICATIONS_HEADER: "Meldingen",
            APP_THEME_DESCRIPTION: "Thema van het besturingssysteem",
            ORGANIZATION: "Organisatie",
            ORGANIZATION_NAME: "Organisatienaam",
            PASSWORD: "Wachtwoord",
            PHONE_NUMBER: "Telefoonnummer",
            PREFERENCES_HEADER: "Voorkeuren",
            PRODUCT_UPDATES_TITLE: "Productupdates",
            STATUS_UPDATES_TITLE: "Statusupdates",
            TEXT_NOTIFICATION: "Tekstmeldingen (SMS)",
            AUTOMATIC_LOGOUT_BODY: "Hiermee wordt een standaard beveiligingsfunctie van de applicatie overschreven om toegang tot een verlaten sessie te voorkomen. Houd er rekening mee dat de gebruiker verantwoordelijk is voor het beschermen van ongeautoriseerde toegang tot dit systeem en dat hij deze applicatie nooit onbeheerd open mag laten staan.",
            TIME_ZONE: "Tijdzone",
            UNITS: "Eenheden",
            ORG_ADDRESS: "Gebruik het adres van de organisatie",
            ORG_CONTACT_DETAILS: "Gebruik de contactgegevens van de organisatie",
            EDIT_USER_DETAILS: "Gebruikersgegevens",
            NAME: "Gebruikersnaam",
            USER_NAME: "Gebruikersnaam",
            WARNING: "WAARSCHUWING",
            WARNING_TITLE: "Waarschuwings",
            WARNING_SUBTITLE: "Firmware-updates, herinneringen voor levenscyclusbeheer",
        },
        EDITUSER: {
            PROMOTE_CONFIRMATION: "Indien dit de bedoeling was, dient u uw wijziging door te geven.",
            DEMOTE_CONFIRMATION: "Als dit de bedoeling was, breng dan hieronder wijzigingen aan in het gedeelte Rol/Locatie van dit formulier.",
            DEMOTE: "U heeft de rol van deze organisatiebeheerder gewijzigd. Als dit niet de bedoeling was, selecteert u Annuleren.",
            PROMOTE: "U heeft deze gebruiker gepromoveerd tot organisatiebeheerder. Als dit niet de bedoeling was, selecteert u Annuleren.",
        },
        ADDUSER: {
            INVITEUSER: "Nodig een gebruiker uit",
            TITLE: "Gebruiker toevoegen",
            ASTERIKSINFO: "Velden gemarkeerd met een asterisk(*) zijn verplichte velden die nodig zijn om een ​​gebruiker uit te nodigen.",
            INVITESUCCESS: "Uitnodiging succesvol!",
            SELECTROLE: "Selecteer een rol voor locatie(s)",
            ACCOUNTCREATED: "De uitnodiging om een ​​account aan te maken is succesvol gestart.",
            EMAILRECEIVE: "De gebruiker zal binnen 5-10 minuten een uitnodiging per e-mail ontvangen om een account aan te maken. Je zult niet in staat zijn om hun status te zien totdat ze de uitnodiging hebben geaccepteerd.",
            ADDUSERINFORMATION: "Profielinformatie gebruikersaccount",
        },
        GATEWAY: {
            MANAGE_CELLULAR_CONNECTION: "Beheer mobiele verbinding",
            TRANSFER_SYSTEM: {
                TRANSFER_SYSTEM_SELECTION_PAGE_TITLE: "{{gatewayName}} Gatewaysystemen ({{systemCount}})",
                TRANSFER_SYSTEM_USERCONFIRMATION_TITLE: "{{gatewayName}} systemen worden overgedragen aan de volgende gebruikers:",
                ADD_ANOTHER_USER: "Een andere gebruiker toevoegen",
                ADMIN_RIGHT_REQUIRED: "Beheerdersrechten vereist om gebruiker uit te nodigen",
                REGISTER_USER_REQUIRED: "Ten minste één geregistreerde gebruiker vereist voor overdracht",
                EMAIL_ID_DUPLICATE: "EmailId is een dubbele of ongeldige invoer",
                ADMIN_RIGHT_REQUIRED_FOR_SYSTEM_TRANSFER: "Beheerdersrechten vereist om gebruikersentiteiten over te dragen",
                DUPLICATE_ENTITY_ID: "EntityId is een dubbele of ongeldige invoer",
                TRANSFER_SYSTEM_EXISTING_USER: "Bestaande gebruikers",
                INVALID_ENTITY_TYPE: "Ongeldig entiteitstype. Geef een geldig entiteitstype op",
                TRANSFER_SYSTEM_LOGED_IN_USER_MSG: "Ongeldige gebruiker. Voeg nog een gebruiker toe.",
                INVITE_AS_COLLEAGUE: "Uitnodigen als collega",
                TRANSFER_SYSTEM_NEW_USER: "Nieuwe gebruikers",
                TRANSFER_SYSTEM_ADD_EXISTING_USER: "Voeg ten minste één bestaande gebruiker toe om entiteiten over te dragen.",
                INVALID_EMAIL_ADDRESS: "Geef een geldig e-mailadres op",
                INVALID_GATEWAY_ID: "Geef een geldige gateway-ID op",
                TRANSFER_SYSTEM_INFO: "Selecteer een bestaande gebruiker of voeg een nieuwe toe.",
                TRANSFER_SYSTEM_SYSTEM_SELECTION_HEADER: "Selecteer de systemen die u wilt overzetten.",
                NO_DATA_FOUND: "Opgevraagde gegevens niet gevonden",
                TRANSFER_SYSTEM_SYSTEM_TRANSFER: "Systeemoverdracht",
                TRANSFER_SYSTEM_CONFIRMATION_NEW_USER: "Deze gebruiker kan geen systemen monitoren totdat hij/zij een uitnodiging accepteert via het opgegeven e-mailadres.",
                TRANSFER_SYSTEM_PRIVILEGES: "Systeemrechten overdragen",
                TRANSFER_TO: "Overbrengen naar",
                TRANSFER_USER_ALREADY_ADDED: "Gebruiker al toegevoegd",
                TRANSFER_SYSTEM_ALREADY_ADDED_USER: "Gebruiker is al toegevoegd aan de lijst. Voeg nog een gebruiker toe.",
                TRANSFER_SYSTEM_USER_SELECTION_HEADER: "Aan wie wilt u deze systemen overdragen?",
                ADD_USERS: "Gebruikers toevoegen",
            },
            ENTRY_PASSWORD_TITLE: "Toegang voor",
            ADD_GATEWAYS: "Apparaat toevoegen",
            ADDING_GATEWAY_TITLE: "{{ gatewayName }} toevoegen aan {{orgName}}",
            CONNECT_TO_ELSYSTEM_FAILED_UREACHABLE_MSG: "Gateway probeert verbinding te maken met het systeem en kan meer tijd in beslag nemen. Controleer de status op het tabblad Systeem",
            RESET_GATEWAY_PASSWORD_SUCCESS: "Gateway-wachtwoord opnieuw ingesteld.",
            BLE: {
                ERROR: {
                    INVALID_IP_AADRESS: "Ongeldig IP-adres",
                    CHANGE_FAILURE_MESSAGE: "Er is een fout opgetreden bij het wijzigen van parameters",
                    NOT_FETCHING_SYSTEM_DETAILS: "Niet in staat om systeemdetails op te halen",
                    BUILDING_ALREADY_EXISTS: "Naam gebouw bestaat al",
                    RESET_PASSWORD_FAILED: "Wachtwoord opnieuw instellen is mislukt. Probeer het opnieuw",
                    INVALID_CONNECTION_STRING: "Ongeldige verbindingsreeks",
                    INVALID_UUID: "Ongeldige UUID",
                    ORGANIZATION_ALREADY_EXISTS: "Organisatienaam bestaat al",
                    REQUEST_FAILED_TITLE: "Verzoek mislukt",
                    REQUEST_FAILED_GATEWAY_ADD: "Verzoek Kan gateway niet toevoegen.",
                    REQUEST_FAILED_MESSAGE: "De operatie kon niet worden voltooid. Wacht een paar minuten en probeer het opnieuw.",
                    UNAUTHORIZED_ACCESS: "Ongeautoriseerde toegang Meld u opnieuw aan",
                    INVALID_DEVICE: "Ongeldig apparaat",
                    GATEWAY_UNRECHABLE: "Systeem onbereikbaar",
                    REQUEST_FAILED_WIRELESS_GATEWAY_ADD: "Verzoek mislukt. Voeg draadloze gateway toe.",
                    REQUEST_FAILED_LP_SMART_ADD: "Verzoek Kan Dualsmart niet toevoegen.",
                    DUPLICATE_SYSTEM_TITLE: "Dubbel systeem",
                    CONNECTION_TYPE: "Verbindingssoort"
                },
                DEVICE_STATUS: {
                    ALARM: "Alarm",
                    BLOCKED: "Geblokkeerd",
                    NOT_PROVISIONED: "Niet ingericht",
                    OFFLINE: "Offline",
                    ONLINE: "Online",
                    PROVISIONED: "Voorzien",
                    READY: "Gereed",
                    READY_FOR_COMMISSION: "Klaar voor inbedrijfstelling",
                    WARNING: "Waarschuwing",
                },
                DEVICE_TYPE: {
                    ATPLUS_CONTROLLER: "AT+-controller",
                    COMMON_GATEWAY: "Gemeenschappelijke gateway",
                    DGS: "DGS",
                    LPSMART: "LPSmart",
                    WIRELESS_GATEWAY: "Draadloze gateway",
                },
                SET_PASSWORD_STATUS: {
                    INVALID_LENGTH: "Ongeldige lengte",
                    INVALID_PASSWORD: "Ongeldig wachtwoord",
                    PASSWORD_CHANGE_FAILURE: "Mislukt wachtwoord wijzigen",
                    PASSWORD_CHANGE_SUCCESS: "Succes met het wijzigen van het wachtwoord",
                    PASSWORD_COMPARISON_FAIL: "Wachtwoordvergelijking mislukt",
                },
                DEFAULT_LOGIN_STATUS: {
                    LOGIN_DEFAULT_SUCCESS: "Standaard succesvol inloggen",
                    LOGIN_FAILURE: "Inloggen mislukt",
                    LOGIN_MAX_ATTEMPTS_EXCEEDED: "Login max pogingen overschreden",
                    LOGIN_SUCCESS_ADMIN: "Inloggen gelukt beheerder",
                    LOGIN_SUCCESS_SERVICE: "Service voor succesvol inloggen",
                    LOGIN_SUCCESS_USER: "Inloggen succesvol gebruiker",
                    LOGOUT: "Uitloggen",
                },
                NULL_VALUE: "Geen reactie",
                TURN_ON_BLE_MSG: "Schakel Bluetooth in om 'Building Safety Manager' toegang te geven tot lokale systemen.",
                DISCONNECT_ALERT_SUBTITILE: "U bent niet langer verbonden met Bluetooth { { gatewayName } }. Zorg ervoor dat u zich binnen het bereik van Bluetooth bevindt om door te gaan.,",
                SUCCESS: {
                    REQUEST_SUCCESS_GATEWAY_ADD: "Gateway succesvol toegevoegd",
                    REQUEST_SUCCESS_WIRELESS_GATEWAY_ADD: "Draadloze gateway succesvol toegevoegd",
                    REQUEST_SUCCESS_LP_SMART_ADD: "Dualsmart is succesvol toegevoegd",
                    REQUEST_SUCCESS_BLE_DEVICE_ADD: "Apparaat succesvol toegevoegd",
                },
            },
            INVALID_SYSTEM_NUMBER: "Ongeldig systeemnummer",
            INVALID_USER_ACCESS_SYSTEM_UNLINK: "Ongeldige gebruiker. U heeft geen toegang tot het ontkoppelsysteem.",
            GATEWAY_DISCONNECT_ALERT: "Weet je zeker dat je de verbinding wilt verbreken?",
            DISCARD_CHANGES_ALERT: "Weet u zeker dat u de wijzigingen wilt negeren?",
            UNLINKEXISTING_SYSTEM_ALERT: "Weet u zeker dat u het bestaande systeem wilt ontkoppelen?",
            GATEWAY_UNREGISTER_ALERT: "Weet u zeker dat u de registratie van Gateway wilt opheffen?",
            AUTOMATICALLY_CONFIG_IP: "Configureer automatisch het IP-adres",
            BACKUP_CONNECTION: "Back-up verbinding",
            TIMELINE_VIEW: {
                BUILDING: "Gebouw",
                OPTINAL: "Optioneel",
                ORGANIZATION: "Organisatie",
                SELECT_BUILDING: "Selecteer een gebouw",
                SELECT_ORGANIZATION: "Selecteer een organisatie",
                SUB_LOCATION: "Sublocatie",
                SET_BACKUP_INTERNET_TITLE: "Stel Back-up-internettoegang in",
                SET_PRIMARY_INTERNET_TITLE: "Primaire internettoegang instellen",
                INTERNET_CONNECTION_LABLE: "Selecteer alstublieft…",
                SET_INTERNET_CONNECTION_MSG: "Maak eerst verbinding met internet",
                SUB_LOCATION_LABLE: "Naam van sublocatie…",
                DESCRIPTION_LABLE: "Schrijf notities voor uw team...",
            },
            BLUETOOTH_SCAN_ERROR: "Kunt u uw toegangspoort niet vinden? Rekening",
            CARRIER_NAME: "Naam vervoerder",
            CELLULAR: "Mobiel",
            CELLULAR_PROCESS_FAILED_MSG: "Mobiel configuratieproces mislukt. Probeer het opnieuw.",
            CELLULAR_PROCESS_SUCCESS_MSG: "Mobiel succesvol geconfigureerd.",
            CELLULAR_CONNECTION: "Mobiele verbinding",
            NO_BLUETOOTH_SUPPORT: "Bluetooth wordt niet ondersteund op dit apparaat",
            CHANGE_CONNECTION_METHOD: "Wijzig de verbindingsmethode",
            CHECK_FOR_UPDATES: "Controleer op updates",
            CONFIGURE_WI_FI_CONNECTION: "Configureer Ethernet-instellingen",
            CONFIGURE_CELLEULAR_CONNECTION: "Configureer deze mobiele verbinding",
            COMMISSION_NEW_GATEWAY: "Maak verbinding met een Eaton-noodgeval Verlichtingsapparaat.",
            CONNECT_TO_ELSYSTEM_FAILED_MSG: "Verbinding maken met EL-systeemproces mislukt. Probeer het opnieuw.",
            CONNECTED: "VERBONDEN",
            CONNECTED_TO: "verbonden op",
            CONNECTION_METHOD: "Verbindingsmethode",
            GATEWAY_CONNECTION_PRIORITY: "Verbindingsprioriteit",
            CONNECTIONS: "Verbindingen",
            GATEWAY_ADD_BUILDING_VALUE: "Nieuw gebouw maken",
            GATEWAY_ADD_ORGANIZATION_VALUE: "Nieuwe organisatie aanmaken",
            SET_DATE_TIME_SUCCESS: "Datum en tijd zijn succesvol ingesteld",
            DEFAULT_PASSWORD_ADMIN_CHANGED: "STANDAARD_WACHTWOORD_ADMIN_GEWIJZIGD",
            DEFAULT_PASSWORD_USER_CHANGED: "STANDAARD_WACHTWOORD_GEBRUIKER_GEWIJZIGD",
            DISCONNECTED: "Apparaat is losgekoppeld of kan geen verbinding maken, probeer het opnieuw",
            DISCONNECTED_SUCCESS: "De verbinding met het apparaat is verbroken",
            GATEWAY_UNREGISTER_SUCCESS: "Registratie-info apparaat succesvol verwijderd",
            GATEWAY_UNREGISTER_FAILURE: "Registratie-info apparaat succesvol verwijderd",
            DGS_NOT_COMMUNICATING: "DGS communiceert niet",
            DGS_UNREACHABLE: "DGS onbereikbaar",
            DHCP: "DHCP",
            DISABLE_WIFI_RATIO_STATUS: "Wifi uitschakelen voor Gateway",
            DNS: "DNS",
            CONNECT_TO_ELSYSTEM_SUCCESS_MSG: "EL-systeem succesvol gekoppeld.",
            ENABLE_LOCATION_FOR_MAP: "Schakel dit in om uw huidige locatie te vinden, schakel het in om de kaartweergave te laden",
            ENABLE_WIFI_RATIO_STATUS: "Wifi inschakelen voor Gateway",
            WIFI_CREDENTIALS_MESSAGE: "Voer het juiste wachtwoord in",
            ENTER_WIFI_CREDENTIALS: "Voer Wi-Fi-gegevens in",
            RESET_GATEWAY_PASSWORD: "Weet u zeker dat u het gatewaywachtwoord opnieuw wilt instellen?",
            INVALID_EPAS_SERIAL_NUMBER: "EPAS-serienummer is ongeldig",
            ETHERNET: "Ethernet",
            ETHERNET_CONFIGURATION: "Ethernet-configuratie",
            ETHERNET_PROCESS_FAILED_MSG: "Het ethernetconfiguratieproces is mislukt. Probeer het opnieuw.",
            ETHERNET_CONNECTION: "Ethernet-verbinding",
            FAIL_LINK_SYSTEM: "Systeem niet gekoppeld van gateway",
            FAIL_UNLINK_SYSTEM: "Kan het systeem niet ontkoppelen van de gateway",
            FAIL_UNREGISTER_GATEWAY: "Kan de registratie van de gateway niet ongedaan maken",
            FINISH: "Voltooien",
            CHANGE_PASSWORD_INFO: "Om veiligheidsredenen verzoeken wij u het standaardwachtwoord te wijzigen.",
            GATEWAY_ACTIVATED: "Gateway geactiveerd",
            GATEWAY_ADDED: "Gateway toegevoegd",
            GATEWAY_COMMISSIONING: "Gateway-inbedrijfstelling",
            GATEWAY_CONNECTED: "Gateway verbonden",
            GATEWAY_DETAILS: "Gatewaydetails",
            GATEWAY_NAME: "Gatewaynaam *",
            GATEWAY_PASSWORD: "Gateway-wachtwoord",
            GATEWAY_PASSWORD_INCORRECT: "Gatewaywachtwoord onjuist",
            GATEWAY_NAME_DESCRIPTION: "Geef deze gateway een betere naam en beschrijving.",
            SUCCESSFULLY_ADDED: "is succesvol toegevoegd.",
            INCOMPLETE_SETUP: "Onvolledige Setup",
            INTERNET_SETTINGS: "Internet-instellingen",
            INVALID_GUID: "Ongeldige apparaat-ID. Voer een geldige GUID in",
            FACTORY_RESET: "Fabrieksreset",
            FACTORY_RESET_SUCCESS: "Fabrieksresetopdracht succesvol uitgevoerd",
            FACTORY_RESET_FAILURE: "Opdracht voor fabrieksreset mislukt. Probeer het opnieuw",
            GATEWAY_FACTORY_RESET_ALERT: "Weet u zeker dat u Factory Reset voor Gateway wilt uitvoeren?",
            LAST_CONNECTED: "Laatst verbonden",
            CELLULAR_CONNECTION_TYPE_LTE: "LTE",
            CELLULAR_CONNECTION_TYPE_NON_LTE: "NIET-LTE",
            INVALID_LATITUDE: "Ongeldige breedtegraad. Geef een geldige breedtegraad op",
            INVALID_LONGITUDE: "Ongeldige lengtegraad. Geef een geldige lengtegraad op",
            INVALID_USER: "Ongeldige gebruiker",
            SUBLOCATION_NAME_LENGTH: "Alleen letters, streepjes, cijfers",
            LINK_NEW_DEVICE: "Koppel een nieuw apparaat",
            LINK_NEW_SYSTEM: "Koppel een nieuw systeem",
            LINK_SYSTEM: "KOPPEL EEN SYSTEEM",
            LINK_ANOTHER_SYSTEM: "Koppel een ander systeem",
            LINK_MORE_SYSTEM: "Koppel meer systemen",
            LINK_SYSTEM_MSG: "Systeem koppelen aan '{{gatewayName}}' Wordt uitgevoerd",
            LINK_SYSTEMS: "Koppel systemen",
            LOCATION: "Locatie",
            DENIED_LOCATION_PERMISSION: "Locatietoestemming geweigerd. Schakel het in om een ​​Bluetooth-scan te krijgen voor een apparaat in de buurt",
            DENIED_LOCATION_PERMISSION_FOR_MAP: "Locatietoestemming geweigerd. Schakel deze in om de kaartweergave te laden",
            CONNECTION_TYPE_VALUE: "LTE/WCDMA/GSM",
            MANAGE_ETHERNET_CONNECTION: "Beheer Ethernet-verbinding",
            MANAGE_WIFI_CONNECTION: "Beheer de wifi-verbinding",
            MANUALLY_CONFIG_IP: "Voer het IP-adres handmatig in",
            SET_NAME_DESCRIPTION_SUCCESS: "Naam en beschrijving succesvol ingesteld",
            NO_DEVICE_FOUND: "Geen apparaten gevonden",
            UNLINK_SYSTEM_ERROR: "Geen gateway om u af te melden",
            NO_GATEWAY_NAME_FOUND: "Geen naam gevonden",
            NO_SYSTEM_YET: "Nog geen systemen",
            WIFI_NETWORK_NOT_AVAILABLE: "Geen wifi-netwerk beschikbaar",
            DHCP_OFF: "Uit",
            DHCP_ON: "Op",
            NO_SYSTEM_YET_DESCRIPTION: "Zodra u uw systemen aan deze gateway koppelt, ziet u hier een lijst met systemen. Herformuleer mij.",
            ONLINE_TEXT: "online.",
            ORGANIZATION_TREE: "Organisatieboom",
            OTHER_NETWORK: "Ander netwerk..",
            BLUETOOTH_INSTRUCTIONS: "onze instructies",
            CHOOSE_GATEWAY_CONNECTION_METHOD: "Kies uw Gateway-verbindingsmethode",
            CONFIRM_SELECTION: "Bevestig selectie",
            ENTER_ADMIN_CHANGE_PASSWORD: "Voer het door de beheerder gewijzigde wachtwoord in",
            ENTRY_GATEWAY_CHANGED_PASSORD: "Voer het door de gateway gewijzigde wachtwoord in",
            ENTRY_GATEWAY_DEFAULT_PASSORD: "Voer het standaardwachtwoord van de gateway in",
            ENTRY_PASSWORD: "Voer het gatewaywachtwoord in voor",
            PLEASE_ENTER_NEW_PASSWORD_AGAIN_RECONNECT: "Voer het nieuwe wachtwoord nogmaals in maak opnieuw verbinding met de gateway.",
            MOVE_CAMERA_OVER_QR_CODE: "Beweeg uw camera\n over de QR-code",
            INVALID_BUILDING_ID: "Geef een geldig gebouw-ID op",
            INVALID_DEVICE_ID: "Geef een geldige apparaat-ID op",
            INVALID_DEVICE_NAME: "Geef een geldige apparaatnaam op",
            INVALID_DEVICE_STATUS: "Geef een geldige apparaatstatus op",
            INVALID_DEVICE_TYPE: "Geef een geldig apparaattype op",
            INVALID_PROJECT_ID: "Geef een geldige project-ID op",
            INVALID_SYSTEM_ID: "Geef een geldige systeem-ID op",
            PLEASE_WAIT: "Even wachten",
            PRIMARY_CONNECTION: "Primaire verbinding",
            GATEWAY_PRIORITY: "Prioriteit",
            PROXY: "Proxy (optioneel)",
            PULL_REFRESH_TEXT: "Trek omlaag om te vernieuwen",
            QUATERNARY_CONNECTION: "Kwartaire verbinding",
            REMOVE_CONNECTION: "Verbinding verwijderen",
            REMOVE_PRIMARY_CONNECTION: "Primaire verbinding verwijderen",
            REQUIRE_GATEWAY_CONNECTED_TO_INTERNET: "Vereist een gateway die verbonden is met internet",
            SAVE_WI_FI_CREDENTIALS: "Bewaar Wi-Fi-inloggegevens voor extra apparaten",
            SCAN_QR_CODE: "QR-code scannen",
            QR_CODE_SCAN: "QR-code scannen",
            SCANNING_FOR_NEAR_BY_BLE: "Scannen naar Ble-apparaten in de buurt..",
            SCANNING_FOR_NEAR_BY_WIFI: "Scannen naar WIFI in de buurt..",
            SEARCH_ALL_LUMINARIES: "Alle armaturen zoeken",
            SEARCH_VIA_BLUETOOTH: "Zoeken via Bluetooth",
            SEARCHING_FOR_NEARBY_WIFI: "Zoeken naar wifi in de buurt...",
            SEARCH_VIA_BLUETOOTH_EllIPSE: "Zoeken via Bluetooth...",
            SECONDARY_CONNECTION: "Secundaire verbinding",
            SELECT_PRIMARY_CONNECTION: "Selecteer een primaire verbindingsmethode",
            SERIAL_NUMBER_NULL_OR_EMPTY: "Serienummer mag niet nul of leeg zijn",
            SET_DATE_TIME_CONFIG: "Datum en tijd instellen Onjuiste configuratie",
            SET_DATE_TIME_FAILURE: "Datum en tijd instellen is een configuratiefout",
            SET_NAME_DESCRIPTION_INCORRECT_CONFIG: "Naam en beschrijving instellen Onjuiste configuratie",
            SET_NAME_DESCRIPTION_FAILURE: "Naam en beschrijving instellen is een configuratiefout",
            SET_EL_SYSTEM_PORT: "Stel de EL-systeempoort in",
            SET_GATEWAY_PORT: "Stel de gatewaypoort in",
            STATIC: "Statisch",
            STATUS: "Status",
            STEP_THREE_OF_THREE: "Stap 3 van 3",
            SYNC_DATE_TIME: "Datum en tijd synchroniseren",
            SYSTEM_UNLINK_SUCCESS: "Systeem ontkoppeld",
            SYSTEM_UNLINKED: "Systeem ontkoppeld",
            SYSTEMS: "Systemen",
            UNLINK_SYSTEM_SUCCESS: "Systemen zijn succesvol uitgeschreven.",
            TERTIARY_CONNECTION: "Tertiaire verbinding",
            GATEWAY_NOT_EXISTS: "De poort bestaat niet",
            ADDING_GATEWAY_SUBTITITLE: "Dit proces kan maximaal 2 minuten duren.",
            UNLINK_ANOTHER_SYSTEM: "Ontkoppel een ander systeem",
            UNLINK_EXISTING_SYSTEM: "Ontkoppel het bestaande systeem",
            UNLINK_EXIST_SYSTEM: "Gateway afmelden",
            USE_WI_FI_PASSWORD: "Gebruik Wi-Fi-wachtwoord",
            USE_WPA2_KEY: "Gebruik WPA2-sleutel",
            SCANNING_FAILED_TRY_AGAIN: "Apparaat verifiëren...",
            CARRIER_NAME_VALUE: "Vodafone NL3G",
            WI_FI: "Wifi",
            WIFI_PROCESS_FAILED_MSG: "Wifi-configuratieproces mislukt. Probeer het opnieuw.",
            GATEWAY_WIFI_CONFIG: "Wifi-configuraties",
            WI_FI_NETWORK: "Wi-Fi-netwerk",
            WI_FI_NETWORK_NAME: "Wi-Fi-netwerknaam",
            WI_FI_PASSWORD: "Wi-Fi-wachtwoord",
            GATEWY_INTERNET_SETTING_OPTIONAL_FIELD_MSG: "U kunt deze stappen overslaan, maar ze moeten later worden uitgevoerd om de installatie te voltooien.",
            GATEWAY_OF: "Toegangspoort van",
            LOCATION_PERMISSION_TITLE: "Locatietoestemming",
            LOCATION_REQUIRED_MESSAGE: "Deze app heeft toegang nodig tot uw locatie",
            PERMISSION_DENIED_TITLE: "Toestemming geweigerd",
            PERMISSION_DENIED_MULTIPLE_MSG: "U heeft de locatietoestemming meerdere keren geweigerd. Zonder deze app werkt de app mogelijk niet correct.",
            UNREGISTER_GATEWAY: "Gateway afmelden",
            CHOOSE_CONNECTION_TYPE: "Welk soort verbindingstype gaat u gebruiken voor \n het DGS-systeem?",
            REACHED_MAXIMUM_SUPPORTED_SYSTEM_ERROR_MSG: "Kan niet meer systemen toevoegen. Limiet bereikt voor het maximale aantal systemen dat op Gateway wordt ondersteund",
            DUALSMART_NAME: "Dualsmart-naam *",
            WIRELESS_GATEWAY_NAME: "Naam draadloze gateway *",
            DUPLICATE_SYSTEM_ERROR_MSG: "Systeem met dit IP-adres is al gekoppeld aan Gateway.",
            DIRECT_CONNECT_OPTION_SELECT_MSG: "Zorg ervoor dat het IP-adres van het systeem is ingesteld op IP-adres en dat DHCP is uitgeschakeld",
            SUB_LOCATION: "Sublocatie",
            ATPLUS_NAME: "TLU AT+ Naam *",
            VERIFYING_DEVICE: "Apparaat verifiëren",
            SYSTEM_LOCATION: "Systeemlocatie",
            DESCRIPTION: "Beschrijving",
            MAINTAINED_MODE: "Onderhouden modus",
            NON_MAINTAINED_MODE: "Niet-onderhouden modus",
        },
        ERROR_MESSAGES: {
            GENERIC_ERROR_CONTACT_DETAILS: "of bel naar",
            GENERIC_ERROR: "Er is een onbekende fout opgetreden. Als dit probleem zich blijft voordoen, neem dan contact op met Eaton Support via",
            9003: "Aangevraagde bewerking kan niet worden uitgevoerd, neem contact op met uw beheerder",
            2002: "De link voor gebruikersregistratie is verlopen of al ingewisseld.",
            2018: "Wij kunnen uw registratie niet voltooien. Uw organisatie heeft het aantal toegewezen gebruikers voor uw abonnement overschreden. Als uw organisatie extra gebruikers nodig heeft, neem dan contact op met CST Support via e-mail op",
            9044: "Het wachtwoord van de gebruiker is niet geldig of de lengte moet tussen de 8 en 16 tekens zijn"
        },
        FORGOT_PASSWORD: {
            INSTRUCTIONS: "Voer het e-mailadres van het account in dat aan het account is gekoppeld. <br/><br/>'+'Als deze e-mail een account heeft bij Safety Management System, ontvangt u binnen <3>één werkdag</3> een reactie.<br/><br/>' + 'Voor dringende accountproblemen kunt u bellen'",
            ERROR: "Uw wachtwoord kon op dit moment niet opnieuw worden ingesteld.",
            RESET_CODE_ERROR: "Er is een fout opgetreden met uw resetcode.",
            EATON_EMAIL_ALERT: "Het BSMS-wachtwoord is hetzelfde als het JOE-wachtwoord. Wilt u uw wachtwoord wijzigen? Gebruik dan de accountvoorkeuren op uw Eaton Asset.",
        },
        ACCOUNT_SETTING: {
            UPDATES_AVAILABLE: "UPDATES BESCHIKBAAR",
            ACCOUNT_CREATED: "Account aangemaakt",
            ACCOUNT_PREFERENCES: "Account voorkeuren",
            ADDRESS_LINE2: "Adresregel 2 (optioneel)",
            ALARAM: "Alarmen",
            ALL_BUILDINGS: "Alle gebouwen",
            ALL_SYSTEM_FIRMWARE: "Alle systeemfirmware",
            ALL_SYSTEMS: "Alle systemen",
            APPLICATION_THEME_COLOR: " Kleur Toepassingsthema",
            AUTOMATIC_LOG_OUT: "Automatisch afmelden",
            AUTOMATIC_UPDATES: "Automatische updates",
            AUTOMATIC_UPDATES_INFO: "Download automatisch de laatste versie van de firmware naar je apparaat.",
            CHANGE_PASSWORD: "Wijzig wachtwoord",
            STORAGE_FIRMWAREFILE_INFO: "Kies hoe u firmwarebestanden op uw apparaat wilt opslaan",
            CITY: "Stad",
            COMPANY_ADDRESS: "Adres bedrijf",
            COMP_ADDRESS: "Adres bedrijf",
            COMPANY_DETAILS: "Bedrijfsgegevens",
            COMPANY_NAME: "Bedrijfsnaam",
            COMP_NAME: "Bedrijfsnaam",
            COMPANY_PHONE_NUMBER: "Telefoonnummer bedrijf",
            CODE: "Land code",
            DATE_FORMAT: "Datum formaat",
            DELETE_ACCOUNT: "Account verwijderen",
            DELETE_CUSTOMER: "Klant verwijderen",
            DEVICE_BLOCKING: "Apparaat bevindt zich in blokkeermodus, noodmodus, onderhoud aangevraagd",
            EDIT_CUSTOMER_INFO: "Klantinformatie bewerken",
            EMAIL: "E-mail",
            EMAIL_ADDRESS: "E-mailadres",
            REQUIRED_FIELD: "Velden met een asterisk(*) zijn verplicht om door te gaan.",
            FIRMWARE_FILE: "Firmware-bestanden",
            FIRMWARE_UPDATES: "Firmware-updates",
            FIRST_NAME: "Voornaam",
            FT_DT_FAIL: "FT mislukt, DT mislukt, Verbinding verbroken, batterijstoring, Lampstoring, ATSD-storing",
            HEALTH_REPORT: "Gezondheidsrapport",
            LANGUAGE: "Taal",
            LAST_NAME: "Laatste naam",
            MONTHLY_REPORTING: "Maandelijkse rapportage",
            NEW_RELEASE_FIRMWARE_UPDATE: "Nieuwe releases, firmware-update beschikbaar",
            NOTIFICATIONS: "Kennisgevingen",
            ORGAN_UPDATED_SUCCESSFULLY: "Organisatie succesvol bijgewerkt",
            PASSWORD: "Wachtwoord",
            PERSONAL_DETAILS: "Persoonlijke gegevens",
            PHONE_NUMBER: "Telefoonnummer",
            POSTAL_CODE: "Postcode",
            PREFERENCES: "Voorkeuren",
            PRIMARY_CONTACT: "Primaire contactpersoon",
            PRIMARY_CONTACT_EMAIL_ADDRESS: "E-mailadres van primaire contactpersoon",
            PRIMARY_CONTACT_PHONE_NUMBER: "Telefoonnummer  primaire contactpersoon",
            PRIMARY_EMAIL_ADDRESS: "Primair e-mailadres",
            PRIMARY_PHONE_NUMBER: "Primair telefoonnummer",
            PRODUCT_UPDATE: "Product updates",
            SAVE_CHANGES: "Wijzigingen opslaan",
            SECONDARY_CONTACT: "Secundaire contactpersoon",
            SECONDARY_CONTACT_EMAIL_ADDRESS: "Secundair e-mailadres voor contactpersoon",
            SECONDARY_CONTACT_PHONE_NUMBER: "Secundair telefoonnummer",
            SECONDARY_EMAIL_ADDRESS: "Secundair e-mailadres",
            SECONDARY_PHONE_NUMBER: "Secundair telefoonnummer",
            SLA_DETAILS: "SLA-details",
            STATUS_UPDATE: "Status updates",
            STORAGE: "Opslag",
            TIME_ZONE: "Tijdzone",
            UNITS: "Eenheden",
            USER_NAME: "Gebruikersnaam",
            USER_UPDATED_SUCCESSFULLY: "Gebruiker is succesvol bijgewerkt",
            VERSION: "Versie",
            EST: "EST",
            OPERATING_SYSTEM_THEME: 'Besturingssysteemthema',
            AUTO_LOGOUT_ENABLED: "Ingeschakeld (aanbevolen)",
            CRITICAL_ALARAM: 'Alleen kritieke alarmen',
            WARNINGS: 'Waarschuwingen',
            FIRMWARE_UPDATE_REMIDERS: 'Firmware-updates, herinneringen voor levenscyclusbeheer',
            OFFLINE_MODE_DISABLED: 'Uitgeschakeld (aanbevolen)',
            OFFLINE_MODE: 'Offline-modus'
        },
        CHANGE_PASSWORD: {
            EMAIL_CONFIRM_MESSAGE: "We hebben een bevestigingsmail gestuurd naar {{email}}",
            PROBLEM_OCCURRED: "Er heeft zich een probleem voorgedaan:",
            PASSWORD: "Wachtwoord wijzigen",
            OLD_PASSWORD: "Oud wachtwoord",
            PASSWORD_CHANGED: "Wachtwoord gewijzigd",
            PASSWORD_INFO: "Wachtwoord moet minstens 8 tekens lang zijn, minstens één hoofdletter, één kleine letter, één cijfer en één speciaal teken bevatten.",
            ERROR_MESSAGR: "Uw gegevens komen niet overeen met onze gegevens. Voer uw gegevens opnieuw in om het opnieuw te proberen.",
            SUCCESS_MESSAGE: "Uw wachtwoord is succesvol bijgewerkt! Om de veiligheid van uw account te garanderen, moet u zich bij de applicatie aanmelden met uw bijgewerkte inloggegevens.",
        },
        SYSTEM_DETAIL: {
            GUIDE: "(Gids)",
            USERS_DATA: "5 admins, 1 viewer",
            ACTIVATE_CONNECTIONS: "Activeer verbindingen in de cloud",
            ADD_ANOTHER_CELLULAR: "Back-up mobiele verbinding toevoegen",
            ADD_SLA: "SLA toevoegen",
            SYSTEM_DETAILS_TITLE: "Systeem details",
            ALL_CONTACTS: "Alle contacten",
            ALL_PEOPLE_IN_THIS_BUILDING: "Alle mensen in dit gebouw",
            ALL_SYSTEMS_IN_THIS_BUILDING: "Alle systemen in dit gebouw",
            BOTH_PORTS_CANNOT_BE_ON_SAME_SUBNET: "Beide poorten kunnen zich niet op hetzelfde subnet bevinden",
            BUILDING: "Gebouw",
            BUILDING_INFO: "Gebouw info",
            BUILDING_TYPE: "Gebouwtype",
            BUYER: "Koper",
            CONNECTION_TYPE: "Verbinding type",
            CONTACT_PERSON_Onsite: "Contactpersoon ter plaatse",
            CONTACT_TYPE: "Contacttype",
            CUSTOMER_DETAILS: "Klantgegevens",
            CUSTOMER_INFO: "Klant info",
            CUSTOMER_NUMBER: "Klantnummer",
            DATE_COMMISSIONED: "Datum ingebruikname",
            DISABLE: "Uitzetten",
            DURATION_TEST: "Duur Test",
            DURATION_TEST_FAILED: "Duur Test mislukt",
            DURATION_TEST_PASSED: "Duur Test geslaagd",
            ENABLED: "Ingeschakeld",
            ENTER_VALID_GATEWAY_ADDRESS: "Voer een geldig gatewayadres in",
            ENTER_VALID_IP_ADDRESS: "Voer een geldig IP-adres in",
            ENTER_VALID_SUBNET_MASK: "Voer een geldig subnetmasker in",
            ETHERNET_PORT_ONE: "Ethernet-poort A",
            ETHERNET_PORT_TWO: "Ethernet-poort B",
            EXPIRY_DATE: "Vervaldatum",
            FIRMWARE_VERSION: "Firmwareversie",
            FOR_BUILDINGS: "Voor Gebouwen",
            FOR_SYSTEMS: "Voor systemen",
            FUNCTIONAL_TEST: "Functionele test",
            FUNCTIONAL_TEST_FAILED: "Functionele test mislukt",
            FUNCTIONAL_TEST_PASSED: "Functionele test geslaagd",
            GATEWAY: "Gateway",
            GATEWAY_ADDRESS: "Gateway-adres",
            GATEWAY_ADDRESS_REQUIRED: "Gateway-adres*",
            GATEWAY_NAME: "Gateway-naam",
            SYSTEM_UNLINKED_GATEWAY: "is geweest losgekoppeld van",
            SYSTEM_LINKED_GATEWAY: "is gekoppeld naar",
            HOST_NAME: "Host naam",
            INTIALIZE_CONNECTION: "Initialiseer de verbinding",
            INTIALIZE_NETWORK: "Netwerk initialiseren...",
            IP_ADDRESS: "IP-adres",
            IP_ADDRESS_REQUIRED: "IP-adres*",
            IP_GATEWAY_NOT_IN_SAME_SUBNET: "IP en gateway niet in hetzelfde subnetmasker",
            ETHERNET_CONNECTED: "is nu verbonden met internet",
            SYSTEM_LINKING_TITLE: "Is dit het systeem dat jij bent? koppelen ? ",
            SYSTEM_UNLINKING_TITLE: "Is dit het systeem dat jij bent? ontkoppelen ? ",
            SYSTEM_LINK_TITLE: "Koppel een systeem aan",
            LUMINAIRES: "Armaturen",
            LUMINARIES_LIST: "Lijst met armaturen",
            MAC_ADDRESS: "Mac-adres",
            MAIN_CONTACT: "Hoofdcontact",
            NETWORK_INFORMATION: "Netwerkinformatie",
            NO_SYSTEM_FOUND: "Geen systeem beschikbaar",
            OFFICE: "Kantoor",
            ORGANIZATION: "Organisatie",
            OTHER_STEPS: "Andere stappen, indien nodig",
            OTHER_SYSTEMS: "Andere systemen",
            PART_NUMBER: "Onderdeelnummer",
            SETPORT_SYSTEM_DETAILS_DESCRIPTION: "Voltooi de Ethernet-configuratie details.",
            SYSTEM_DETAILS_DESCRIPTION: "U vindt deze details op het HMI-scherm van uw systeemkast.",
            PORT_NUMBER: "Poortnummer",
            PREV: "Prev",
            PROJECT_LEAD: "Projectleider",
            REGISTER_ACTIVATE_GATEWAY: "Registreer en activeer de gateway",
            SERIALNO_VALUE: "S3ri4l-Num63r",
            SERIAL_NUMBER: "Serienummer",
            SETPORT_SYSTEM_LINK_TITLE: "Stel de poort in waaraan een systeem moet worden gekoppeld",
            SLA_NUMBER_TITLE: "SLA#",
            SLAVE_NUMBER: "Slavennummer",
            SUBNET_MASK: "Subnetmasker",
            SUBNET_MASK_REQUIRED: "Subnetmasker",
            SYN_DATE_TIME: "Datum en tijd synchroniseren",
            SYSTEM: "Systeem",
            SYSTEM_NAME: "Systeemnaam",
            SYSTEM_TYPE: "Systeem type",
            TECHNICAL_PERSON: "Technisch persoon",
            STATUS_DESCRIPTION: "Dit is een lange beschrijving. Het kan de locatie van het apparaat beschrijven en met wie u moet praten.",
            TOTAL_SLA: "Totale SLA",
            TRANSFER_ORGANIZATION: "Draag deze organisatie en haar activa over \n naar een andere gebruiker (optioneel)",
            SYSTEM_UNLINK_TITLE: "Systeem ontkoppelen van",
            UPDATE_REQUIRED: "bijwerken vereist",
            UPLOAD_DETAILS: "Gegevens uploaden via Bluetooth",
            FIRMWARE_VERSION_VALUE: "v12.34-56",
            VERSION_AVAILABLE: "v123.457 Beschikbaar",
            VIEW_ALL: "Alles weergeven",
            VIEW_ALL_LUMINARIES: "Alle armaturen weergeven",
            PARTNO_VALUE: "xx xx xx xx",
            ETHERNET_SUBTITLE: "U heeft nu toegang tot uw gateway via de web.Herformuleer mij.",
            LUMINARY_FIRMWARE_VERSION: "Firmwareversie armatuur",
            FIRMWARE_UPDATE_MSG: "Zend het firmware-updatecommando naar alle armaturen en modules"
        },
        USER_INVITATION_MANAGEMENT: {
            YOU: "(U)",
            INVITATION_MESSAGE_UPDATE_COUNT: "{{updatedInvitationCount}} uitnodigingen waren {{inviteStatus}} succesvol, {{rejectedInvitationCount}} uitnodigingen waren niet {{inviteStatus}}.",
            SUCCESS_COUNT: "{{updatedInvitationCount}} uitnodigingen zijn {{inviteStatus}} succesvol uitgevoerd.",
            INVITE_ACCEPT: "Accepteren",
            INVITE_ACCEPT_INVITATION: "Accepteer de uitnodiging",
            INVITE_ACCEPTED: "geaccepteerd",
            INVITE_ACCEPTED_BUTTON: "Geaccepteerd",
            INVITE_ACCEPT_INVITATION_DESCRIPTION_1: "Als u deze uitnodiging accepteert, wordt het volgende item aan uw profiel toegevoegd:",
            ADMIN_APPROVE: "Verzoek goedkeuren",
            COMPANY: "Bedrijf",
            DECLINE_INVITATION: "Uitnodiging afwijzen",
            TABLE_HEADER_DENIED_TITLE: "Door mij geweigerd ({{count}})",
            INVITE_DENIED: "geweigerd",
            INVITE_DENY: "Weigeren",
            ADMIN_DECLINE_INVITATION: "Verzoek weigeren",
            TABLE_HEADER_EXPIRED_AT: "Verval",
            TABLE_HEADER_EXPIRED_TITLE: "Verlopen uitnodigingen ({{count}})",
            INVITE_HISTORY: "Uitnodigingsgeschiedenis",
            INVITATION_SUCCESS_MESSAGE: "Uitnodiging succesvol {{inviteStatus}}.",
            JOIN: "Word lid ",
            JOINALL: "Word lid van alle",
            TABLE_HEADER_NAME: "Naam",
            INVITE_PENDING: "In afwachting van",
            INVITE_REQUEST_ACCESS_DESCRIPTION_2: "Vraag de beheerder om toegang om dit item toe te voegen aan je profiel",
            TABLE_HEADER_INVITE_DATE: "Ontvangen",
            REMOVE_USER: "Gebruiker verwijderen",
            INVITE_REQUEST: "Verzoek",
            INVITE_REQUEST_ACCESS: "Toegang aanvragen",
            REQUESTEDBY: "Opgevraagd door",
            INSTRUCTIONS: "Selecteer of u items aan uw profiel wilt toevoegen of dat u de uitnodiging om deze aan uw profiel toe te voegen wilt weigeren.",
            ADMIN_INSTRUCTIONS: "Selecteer of u hun verzoek om toegang wilt goedkeuren of weigeren:",
            SENTBY: "Verzonden door",
            TABLE_HEADER_INVITE_BY: "Verzonden door",
            TABLE_HEADER_TOTAL_ACCEPTED_NO_DATA_FOUND: "Er zijn momenteel geen geaccepteerde uitnodigingen.",
            TABLE_HEADER_DENIED_NO_DATA_FOUND: "Er zijn momenteel geen geweigerde uitnodigingen.",
            TABLE_HEADER_EXPIRED_NO_DATA_FOUND: "Er zijn momenteel geen verlopen uitnodigingen.",
            INVITATION_TEXT: "Ze hebben een uitnodiging nodig om opnieuw deel te nemen.",
            INVITE_REQUEST_ACCESS_DESCRIPTION_1: "Deze uitnodiging is verlopen en kan niet meer aan uw profiel worden toegevoegd.",
            TABLE_HEADER_TOTAL_COUNT: "Totaal aantal geaccepteerde uitnodigingen ({{count}})",
            TABLE_HEADER_TOTAL_ACCEPTED_COUNT: "Totaal aantal geaccepteerde uitnodigingen ({{count}})",
            SUCCESS_MESSAGE: "Uitnodiging gebruiker succes {{count}}",
            ERROR_MESSAGE: "Verzoek van gebruiker om uitnodiging bij te werken is mislukt",
            VIEW_ALL_ACCESS_RIGHTS: "Alle toegangsrechten weergeven",
            TITLE: "Welkom, {{gebruikersnaam}}",
            SUBTITLE: "Je bent uitgenodigd voor de volgende projecten:",
            ADMIN_SUBTITLE: "Je hebt verzoeken om toegang tot verlopen uitnodigingen:",
            LEAVE_ORGANIZATION: "Verlaat de organisatie",
            REMOVE_SERVICE_USER_TITLE: "{{userName}}' verwijderen uit '{{companyName}}'?",
            ARCHIVE_USER_DIALOG: "Weet u zeker dat u gebruiker {{userName}} wilt archiveren?",
            ARCHIVE_USER_TITLE: "Gebruiker archiveren",
            ARCHIVE_USER_SUCCESS: "Gebruiker succesvol gearchiveerd",
            ARCHIVE_USER_ERROR_9260: "Gebruiker is al gearchiveerd",
            RESTORE_USER_DIALOG: "Weet u zeker dat u gebruiker {{userName}} wilt herstellen?",
            RESTORE_USER_TITLE: "Gebruiker herstellen",
            RESTORE_USER_SUCCESS: "Gebruiker succesvol hersteld",
            RESTORE_USER_ERROR_9261: "Gebruiker is al hersteld vanuit archief",
        },
        INACTIVITY: {
            LOGOUT: ", wordt u uitgelogd.",
            INACTIVE_LOGOUT: "Uitgelogd vanwege inactiviteit",
            TITLE: "Sessie time-out",
            WARNING: "We hebben al 15 minuten geen activiteit gezien. Tenzij u actie onderneemt, wordt u uitgelogd",
        },
        ATPLUS: {
            ATPLUS_FAILURE_COUNT: "{{count}} Fout",
            ATPLUS_DATETIME_TWENTYFOUR_HOUR: "24-uurs tijd",
            ATPLUS_TWO_MINUTE_AGO: "2 minuten geleden",
            ATPLUS_ACTIVATION: "Activering",
            ADMIN: "Beheerder",
            ADMINVIEWER: "Beheerder en kijker",
            ATPLUS_ADMIN_ACCESS: "Admin-toegang",
            ATPLUS_ALERT_LEVEL: "Waarschuwingsniveau",
            ATPLUS_ALERTSETTING_HEADER: "Instellingen waarschuwingsniveau",
            ATPLUS_SEARCHLUMINAIRE_WARNING: "Alle armaturen krijgen een nieuw adres toegewezen en creëren een nieuwe configuratie.",
            ATPLUS_LOGIN_FAILURE: "Er is een fout opgetreden bij het wijzigen van parameters",
            ATPLUS_DATETIME_AUTO_DATE_TIME_HEADER: "Automatische datum en tijd",
            ATPLUS_AUTOMATIC_RESET: "Automatische rustmodus",
            ATPLUS_AUTOMATIC_REST_MODE_MSG: "De automatische rustmodus zorgt ervoor dat de armaturen in rust gaan als de lokale netspanning wordt uitgeschakeld.",
            ATPLUS_BATTERYFAILURE: "Batterij defect",
            ATPLUS_CHANGE_ADMIN_PASSWORD: "Admin-wachtwoord wijzigen",
            ATPLUS_CHANGE_PASSWORD_FAILURE: "Wachtwoord wijzigen mislukt",
            ATPLUS_CHANGE_PASSWORD_SUCCESS: "Wachtwoord wijzigen Succes",
            ATPLUS_CHANGE_SERVICE_PARTNER_PASSWORD: "Wachtwoord servicepartner wijzigen",
            ATPLUS_CHANGE_PASSWORD: "Systeemwachtwoord wijzigen",
            SYSTEMPASSWORD: "Systeemwachtwoorden wijzigen",
            ATPLUS_CHANGE_VIEWER_PASSWORD: "Wachtwoord kijker wijzigen",
            ATPLUS_SYNC_TEST_SCHEDULE_INFO: "Klik op Testschema synchroniseren om de functionele tests in te stellen op precies 7 dagen vanaf nu en de duurtests op 10 weken vanaf nu.",
            ATPLUS_INFO_TAG_CLOSED: "GESLOTEN",
            ATPLUS_COMISSIONING: "Inbedrijfstelling",
            ATPLUS_COMMANDS: "Opdrachten",
            ATPLUS_COMMSFAILURE: "Communicatiestoring",
            ATPLUS_CONFIGRATION_CREATED: "Configuratie gemaakt",
            ATPLUS_CONFIGRATION_DETAIL: "Details configuratie ",
            ATPLUS_CONFIGRATION_NAME: "Configuratienaam",
            ATPLUS_CREATE_CONFIGRATION: "Configuratie maken",
            ATPLUS_DATETIME_CURRENT_TIME: "Huidige datum en tijd",
            ATPLUS_DEVICE_DATETIME_CURRENT_TIME: "Huidige datum en tijd van mobiel apparaat",
            ATPLUS_CURRENT_TEST_SCHEDULE: "Huidig ​​testschema",
            ATPLUS_REFRESH_LUMINAIRES: "Momenteel wordt de meest recente status opgehaald van alle armaturen in het {{atplus}} gebouw.",
            ATPLUS_DATETIME: "Datum en tijd",
            ATPLUS_DRYCONTACT_DEFAULT_SETTINGS: "Standaardinstellingen",
            ATPLUS_DETAILS: "Details",
            ATPLUS_DRY_CONTACT: "Droog contacts",
            ATPLUS_DRYCONTACT_INPUT: "Ingang droog contact",
            ATPLUS_ALERTSETTING_DRY_CONTACT_INPUT: "Droge contactingang geactiveerd",
            ATPLUS_DRYCONTACT_OUTPUT: "Droge contactuitgang",
            ATPLUS_ALERTSETTING_DRY_CONTACT_OUTPUT: "Droge contactuitgang geactiveerd",
            ATPLUS_DRYCONTACT_HEADER: "Instellingen droog contact",
            ATPLUS_DRYCONTACT_STATUS: "Status droog contact",
            ATPLUS_DURATION_TEST_TITLE: "Duur  Test",
            ATPLUS_DTSUCCESS: "Duur test voltooid",
            ATPLUS_DTFAILEDTITLE: "Duur test mislukt",
            ATPLUS_DTINPROGRESS: "Duurtest wordt uitgevoerd...",
            SERVICE: "Eaton-service",
            ATPLUS_ELSYSTEM_SYSTEM_TIME: "EL-systeem Lokale tijd",
            ATPLUS_EMC_HEADER: "EMC-test",
            ATPLUS_EMERGENCY: "Noodgeval",
            ATPLUS_FW_UPDATE_EROOR: "Fout bij het upgraden van de firmware. Probeer het opnieuw",
            ATPLUS_EXPORT_CONFIG: "Configuratie exporteren",
            ATPLUS_EXPORT_CONFIGRATION_FAIL: "Het exportconfiguratieproces is mislukt",
            ATPLUS_FAILED_LUMINAIRE: "Mislukte armaturen",
            ATPLUS_DRYCONTACT_FAILURE_THRESHOLD: "Drempel voor mislukking overschreden",
            ATPLUS_FAILURETYPE: "Type storing",
            ATPLUS_FIRMWARE_FILE_FOR: "Firmwarebestand voor versie",
            ATPLUS_FIRMWARE_UPDATE: "Firmware-update",
            ATPLUS_FW_UPDATE_COMPLETE: "Firmware-update voltooid",
            ATPLUS_FW_UPDATE_INPROGRESS: "Firmware-update in uitvoering",
            ATPLUS_FUNCTIONAL_TEST_TITLE: "Functionele test",
            ATPLUS_FTSUCCESS: "Functionele test voltooid",
            ATPLUS_FTINPROGRESS: "Functionele test wordt uitgevoerd...",
            CHANGEPASSWORDFOR: "Ik moet het wachtwoord wijzigen voor",
            ATPLUS_IMPORT_CONFIG: "Configuratie importeren",
            ATPLUS_INEMERGENCYMODE: "In noodmodus",
            ATPLUS_INFAILURE: "Bij mislukking",
            ATPLUS_INRESTMODE: "In rustmodus",
            ATPLUS_INTESTMODE: "In testmodus",
            ATPLUS_REFRESH_INCOMPLETE: "Onvolledige gegevens",
            ATPLUS_CHANGE_PASSWORD_INCORRECT_PASSWORD: "Onjuist huidig ​​wachtwoord",
            ATPLUS_DRYCONTACT_STATUS_INPUT: "Invoer",
            GWCDATPLUSHEADER: "Is dit het EL-apparaat dat u in gebruik neemt?",
            ATPLUS_LAMPFAILURE: "Lamp defect",
            ATPLUS_CONFIGRATION_FILE_TITLE_INFO: "Alleen letters, cijfers, onderstrepingstekens en streepjes",
            ATPLUS_ALERTSETTING_LOCAL_MAIN_FAILURE: "Lokale hoofdstoring",
            ATPLUS_LOAST_CONNECTION: "Verbinding verbroken. Probeer het opnieuw",
            ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS: "Armatuurwaarschuwingen",
            ATPLUS_DTFAILEDDESCRIPTION: "Armatuur defect",
            ATPLUS_LUMINAIRE: "Armaturen",
            ATPLUS_FOUNDLUMINAIRE: "Armaturen gevonden...",
            ATPLUS_FOUNDWERELUMINAIRE: "Er zijn armaturen gevonden.",
            ATPLUS_MAIN_OFFICE: "Hoofdkantoor",
            ATPLUS_DRYCONTACT_SUBHEADER: "Hoofdkantoor",
            ATPLUS_MANAGE_CONFIG: "Configuraties beheren",
            ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED: "Maximum aantal pogingen is bereikt",
            ATPLUS_MINIMIZE: "Minimaliseer",
            ATPLUS_MULTIPLE_FAILURES: "Meerdere mislukkingen",
            ATPLUS_FOUNDNEWLUMINAIRE: "er zijn nieuwe armaturen gevonden.",
            ATPLUS_NEW_TEST_SCHEDULE: "Nieuw testschema",
            ATPLUS_DATETIME_SELECTED_TZ_PLACEHOLDER: "Nieuw York",
            ATPLUS_NEXT_SCHEDULES_DTTEST: "Volgende geplande duurtest",
            ATPLUS_NEXT_SCHEDULES_FTTEST: "Volgende geplande functionele test",
            ATPLUS_NO_FW_FILES: "Geen firmwarebestand aanwezig voor versie",
            ATPLUS_NO_LUMINAIRES_INSTALLED: "Geen armaturen geïnstalleerd",
            ATPLUS_NO_LUMINAIRES_YET: "Nog geen armaturen",
            ATPLUS_DRYCONTACT_RADIO_CLOSED: "Normaal gesloten",
            ATPLUS_DRYCONTACT_RADIO_OPEN: "Normaal geopend",
            ATPLUS_NEWLUMINAIRES_HEADLINE: "Zoek alleen naar nieuw toegevoegde of vervangen armaturen in het “Hoofdkantoor” om er automatisch adressen aan toe te wijzen.",
            ATPLUS_OPENSNACK: "Open",
            ATPLUS_OPERATIONS: "Bediening",
            ATPLUS_ALERTSETTING_OTHER_ALERTS: "Andere waarschuwingen",
            ATPLUS_DRYCONTACT_STATUS_OUTPUT: "Uitvoer",
            ATPLUS_DRYCONTACT_OUTPUT_DEFAULT_SETTINGS: "Standaardinstellingen uitvoer",
            ATPLUS_ALERTSETTING_CHOOSE_NUMBER: "Kies tussen 1 en 10 armaturen",
            ATPLUS_ADDITIONALPASSWORDINSTRUCTION: "Maak nieuwe wachtwoorden aan voor gebruikers met toegang op service-, beheerders- en kijkersniveau tot deze telecommand.",
            ATPLUS_DONT_MOVE: "Ga alsjeblieft niet weg",
            ATPLUS_DOWNLOAD_FW_FILES: "Download het bestand opnieuw en probeer...",
            ATPLUS_BLE_DISCONNECT_SUBTITILE: "Zorg ervoor dat u zich binnen het bereik van Bluetooth bevindt en probeer het opnieuw.",
            ATPLUS_RELOGINPASSWORDINSTRUCTION: "Voer het nieuwe wachtwoord opnieuw in om opnieuw verbinding te maken met de",
            ATPLUS_RELOGIN_MESSAGE: "Voer het nieuwe wachtwoord opnieuw in om opnieuw verbinding te maken met de.",
            ATPLUS_ENTRY_MESSAGE: "Voer uw inloggegevens in om de volgende wachtwoorden te wijzigen.",
            ATPLUS_EXPORT_CONFIGRATION_INFO: "Geef het bestand een naam om uw meest recent gemaakte configuratie op te slaan en te exporteren.",
            ATPLUS_STAY_WHERE: "Blijf alsjeblieft waar je bent",
            ATPLUS_ALERTSETTING_NOTIFY: "Gebruik de volgende instellingen om uw waarschuwingsvoorkeuren aan te passen.",
            ATPLUS_REFRESH_COMPLETE: "Vernieuwen voltooid",
            ATPLUS_REFRESHLUMINAIRE_TEST: "Vernieuw armaturen",
            ATPLUS_REFRESH_LUMINAIRES_PAGETITLE: "Vernieuw armaturen",
            ATPLUS_REFRESH_LUMINAIRES_PROGRESS: "Armaturen vernieuwen in uitvoering...",
            ATPLUS_USE_RELIGHT: "Relight is alleen beschikbaar voor armaturen die zich momenteel in de Rust-modus bevinden.",
            ATPLUS_DRYCONTACT_INPUT_RELIGHT: "Relight JOUR",
            ATPLUS_RELIGHT_SUCCESS: "De Relight-modus is succesvol geactiveerd.",
            ATPLUS_RESTMODE: "Rest",
            ATPLUS_REST_SUCCESS: "De Rustmodus is succesvol geactiveerd.",
            ATPLUS_DURATION_TEST: "Duurtest uitvoeren",
            ATPLUS_FUNCTIONAL_TEST: "Functionele test uitvoeren",
            ATPLUS_SEARCHALL_LUMINAIRE: "Zoek in alle armaturen",
            ATPLUS_SEARCH_ALL_LUMINAIRES: "Zoek naar alle armaturen",
            ATPLUS_SEARCH_NEWLUMINAIRES: "Zoek naar nieuwe armaturen",
            ATPLUS_SEARCHNEW_LUMINAIRE: "Zoek naar nieuwe armaturen",
            ATPLUS_SERVICE_ACCESS: "Servicetoegang",
            ATPLUS_SERVICEPARTNERPASSWORD: "Servicepartner",
            ATPLUS_CHANGEPASSWORD_INSTRUCTION: "Stel een wachtwoord in voor gebruikers met",
            ATPLUS_ADDITIONALPASSWORD: "Stel extra wachtwoorden in",
            ATPLUS_DATE_TIME: "Datum en tijd instellen",
            ATPLUS_DATETIME_HEADER: "Datum en tijd instellen",
            ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS_INFO: "Stel het aantal defecte armaturen in dat een systeem moet bereiken voordat een waarschuwing wordt geactiveerd.",
            ATPLUS_SHOW_CONNECTED_LUMINAIRE: "Toon connected armaturen",
            ATPLUS_SHOW_REGISTERED_LUMINAIRE: "Toon geregistreerde armaturen",
            SIGN_IN: "Log in",
            SIGN_IN_AS: "Meld u aan als...",
            ATPLUS_RELIGHT: "Start de Relight-modus",
            ATPLUS_REST: "Start de rustmodus",
            ATPLUS_STARTSEARCH: "Zoekopdracht starten",
            ATPLUS_START_TEST: "Test starten",
            ATPLUS_VISIBILITY_TEST: "Start Zichtbaarheid Plus",
            ATPLUS_DRYCONTACT_INPUT_VISIBILITY: "Zichtbaarheid+ starten",
            ATPLUS_STARTDT: "Duurtest starten...",
            ATPLUS_STARTFT: "Functionele test starten...",
            ATPLUS_STARTDTSNACK: "Stop met testen",
            ATPLUS_EMC: "Schakel over naar EMC-test",
            ATPLUS_SYNCH_TEST: "Synchronisatietestschema",
            ATPLUS_SYNC_TEST_SCHEDULE: "Synchronisatietestschema",
            ATPLUS_SYNC_TEST_SCHEDULED_INFO: "Synchroniseer het testschema voor de Functioneel- & Duurtest voor alle armaturen in het gebouw",
            TELECOMMANDPASSWORD: "Telecomwachtwoord",
            ATPLUS_TEST: "Test",
            ATPLUS_SYNC_TEST_TIME: "Testtijd:",
            ATPLUS_DRYCONTACT_INPUT_READONLY: "De droge contactingang is alleen-lezen, maar kan handmatig worden geconfigureerd via de dipswitch.",
            ATPLUS_DRYCONTACT_STATUS_READONLY: "De status is alleen-lezen, maar kan handmatig worden geconfigureerd op de dipswitch.",
            ATPLUS_LUMINAIRE_INSTALL: "Door deze actie gaan alle armaturen in een installatie knipperen.",
            ATPLUS_SHOW_CONNECTED_LUMINAIRE_INFO: "Deze actie zal elk armatuur laten knipperen dat correct is aangesloten en op de controller is aangesloten.",
            ATPLUS_SEARCHLUMINAIRE_HEADLINE: "Met deze actie wordt een nieuwe configuratie gecreëerd met alle aangesloten armaturen.",
            ATPLUS_SHOW_REGISTERED_LUMINAIRE_INFO: "Met deze actie knipperen alleen armaturen die in uw verlichtingsconfiguratie zijn opgenomen.",
            ATPLUSSYNC_TEST_SCHEDULED_TIME_INFO: "Met deze actie wordt de volgende functionele test gesynchroniseerd met exact 1 week en duurtests met 10 weken.",
            ATPLUS_AUTOMATIC_REST_MODE_INFO: "Deze informatie is alleen-lezen, maar kan handmatig worden geconfigureerd op de dipswitch.",
            ATPLUS_LOAST_CONNECTION_INFO: "Dit mobiele apparaat moet tijdens de functionele test binnen Bluetooth-bereik blijven en verbonden zijn met het AT+-systeem.",
            ATPLUS_DEVICE_RANGE: "Voor deze operatie moet dit mobiele apparaat binnen het Bluetooth-bereik van de TLAT+ blijven. \nDit proces kan enkele minuten duren.",
            ATPLUS_TOMANYLUMINAIREHEADER: "Dit systeem ondersteunt maximaal 64 armaturen. Alleen de eerste 64 gedetecteerde apparaten zullen deel uitmaken van uw configuratie.Gebruik de functie “Zoek geregistreerde armaturen” in het inbedrijfstellingsvenster om de armaturen te vinden die niet in uw configuratie zijn opgenomen.",
            ATPLUS_CURRENT_LUMINAIRES_CONFIGURATION: "Deze vervangt uw huidige armatuurconfiguratie",
            ATPLUS_TIMEREMAINS: "Tijdschatting,",
            ATPLUS_TIMEREMAINING: "Resterende tijd,",
            ATPLUS_DATETIME_TIMEZONE: "Tijdzone",
            ATPLUS_TIMEZONE_HEADER: "Tijdzone",
            TLU_ATPLUS_PASSWORD_INCORRECT: "TLU AT+ wachtwoord onjuist",
            ATPLUS_TOMANYLUMINAIRE: "Er zijn te veel armaturen gevonden",
            ATPLUS_FIRMWARE_UPDATING: "Firmware bijwerken...",
            ATPLUS_USE_REST: "Gebruik Rest voor armaturen die niet meer op het elektriciteitsnet zijn aangesloten.",
            ATPLUS_FINISHSEARCH: "Gebruik deze resultaten om een ​​nieuwe configuratie te maken en te delen met behulp van 'Exporteren'.",
            ATPLUS_DATETIME_AUTO_DATE_TIME_SUBTEXT: "Gebruik de datum, tijd en tijdzone van uw mobiele apparaat om automatisch te synchroniseren met het TLAT+-systeem. Schakel deze functie uit om de datum, tijd en tijdzone handmatig in te stellen.",
            ATPLUS_VIEWLOGBOOK: "Bekijk logboek",
            VIEWER: "Kijker",
            ATPLUS_VIEWER_ACCESS: "Toegang voor kijkers",
            ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED_BODY: "U kunt proberen zich hierop aan te melden",
            ATPLUS_DT_DIALOG: "U kunt gegevens kwijtraken als u tijdens de duurtest te ver weg van het AT+-systeem gaat.Geschatte resterende tijd, 01:00:00",
            ATPLUS_FT_DIALOG: "U kunt gegevens kwijtraken als u zich tijdens de functionele test te ver van het AT+-systeem verwijdert.Geschatte resterende tijd, 00:02:00",
            ATPLUS_NO_LUMINAIRES_YET_DESCRIPTION: "U moet de functie “Zoek alle armaturen” gebruiken en uw TLAT+ activeren om uw armaturen hier te zien.",
            ATPLUS_CONFIGRATION_CREATED_MESSAGE: "Uw configuratie is succesvol aangemaakt.",
            ATPLUS_RELOGIN_SUCCESS_MESSAGE: "Uw nieuwe wachtwoorden zijn opgeslagen.",
            ATPLUS_DEVICE_UNREGISTERED: "Dit apparaat is niet geregistreerd",
            ATPLUS_DEVICE_NEEDCOMMISSIONIG: "Dit apparaat is niet meer geregistreerd bij de cloud en moet opnieuw in gebruik worden genomen",
            ATPLUS_EXPORT_CONFIGRATION_INVALID_NAME: "Ongeldige configuratienaam",
            SAVE_TO_CLOUD: "Opslaan in de cloud",
            EXPORT: "Exporteren",
            ATPLUS_IMPORT_CONFIG_SETTING_DEVICE_NAME: "De apparaatnaam instellen",
            TPLUS_IMPORT_CONFIG_LOADING_LUM_CONFIGRATION: "Armatuurconfiguratie laden...",
            ATPLUS_IMPORT_CONFIG_SETTING_DRY_CONTACT_CONFIGURATION: "De droogcontactconfiguratie instellen",
            ATPLUS_IMPORT_CONFIG_PROGRESS_ALERT_TITLE: "Stoppen en de voortgang verliezen?",
            TPLUS_IMPORT_CONFIG_PROGRESS_ALERT_SUBTITLE: "Als u dit scherm verlaat, wordt het importproces geannuleerd en moet u het proces opnieuw starten.",
            ATPLUS_START_VISIBILITY_PLUS: "Start Zichtbaarheid Plus",
            ATPLUS_VISIBILITY_PLUS: "Zichtbaarheid Plus",
            ATPLUS_VISIBILITY_PLUS_FAILED: "Zichtbaarheid Plus mislukt",
            DRY_CONTACT_SETTINGS_DESCRIPTION: "Info is alleen configureerbaar op de afstandsbediening of via de mobiele applicatie.",
            ATPLUS_ALERTSETTING_ZONE_ALERTS_INFO: "Stel het aantal defecte armaturen in dat nodig is om een waarschuwing te activeren.",
            ATPLUS_ALERTSETTING_ZONE_CHOOSE_NUMBER: "Kies tussen 1 en 10 zones",
            ATPLUS_IMPORT_CONFIG_PAGE_INFO: "Kies de configuratie die u wilt importeren naar deze telecommand.",
            ATPLUS_IMPORT_CONFIG_INTERNET_CONNECTION: "Voor bepaalde opties is mogelijk een internetverbinding vereist.",
            ATPLUS_IMPORT_CONFIG_SELECT_FILE_LABEL: "Selecteer alstublieft",
            ATPLUS_XMLFILES_ONLY: "* Selecteer alleen '.xml'-bestanden",
            ATPLUS_REPLACE_TLUAT: "Ik vervang een TLU AT+",
            ATPLUS_ACTIVATION_INPROGRESS: "Activering bezig",
            ATPLUS_ACTIVATION_48HUORS: "48 uur om de activering te voltooien",
            ATPLUS_ACTIVATION_PAGE_INFO: "Volg de onderstaande instructies om de monitoringfuncties op dit TLU AT+ systeem te registreren en te activeren.",
            ATPLUS_ACTIVATION_PROGRESS_PAGEINFO_SUBTITLE: "Volg de onderstaande instructies om de monitoringfuncties op dit TLU AT+ systeem te registreren en te activeren.",
            ATPLUS_ACTIVATION_STEP: "Activeringsstappen",
            ATPLUS_INSURE_ALL_LUMINARIES_REGISTERED: "Zorg ervoor dat alle armaturen zijn geregistreerd op het TLU AT+ systeem",
            ATPLUS_ACTIVATION_IF_NOT_COMPLETED_THIS_STEPS: "Als u deze stap nog niet heeft voltooid, klik dan hier voor meer informatie",
            ATPLUS_ACTIVATION_REGISTER_SYSTEM_TO_CLOUD: 'Klik op "Systeem registreren in de cloud en het systeem activeren."',
            ATPLUS_ACTIVATION_MUST_HAVE_BLUETOOTH: "(Bluetooth en internetverbinding met het TLU AT+ systeem vereist)",
            ATPLUS_ACTIVATION_REGISTER_AND_ACTIVATE: "Registreer & activeer TLU AT+",
            ATPLUS_IMPORT_CONFIG_BROWSE_FILES: "Bladeren door bestanden...",
            ATPLUS_IMPORT_CONFIG_BROWSE_FROM_CLOUD: "Importeren uit de cloud..."
        },
        USERLIST: {
            DELETECONFIRMATION: "{{email}} Account en alle bijbehorende gegevens worden permanent verwijderd. Het verwijderen van dit account heeft geen invloed op de organisatie, apparaten of gerelateerde historische gegevens.",
            ACCOUNT_DELETE: "Account verwijderd",
            ALL_LOCATION: "Alle locaties",
            DELETEACCOUNT: "Dit account verwijderen?",
            COL_EMAIL: "E-mail",
            COL_LOCATION: "Locatie",
            COL_ROLE: "Rol",
            COL_STATUS: "Status",
            DELETE_SUCCESS: "Het gebruikersaccount voor {{email}} is succesvol verwijderd.",
            COL_USERNAME: "Gebruikersnaam",
        },
        REPORTS: {
            ISSUES: "{{issueCount}} problemen",
            MONTHLY_REPORT: "Maandelijks rapport",
            NO_ISSUES: "Geen problemen tijdens deze periode",
            REPORT_DOWNLOAD_FAILED: "Downloaden van rapportbestand mislukt",
            REPORT_DOWNLOAD_SUCCESSFULLY: "Rapportbestand succesvol gedownload",
        },
        INSTALLATION_MANUAL: {
            DOWNLOAD_SUCCESSFULLY: "Downloaden voltooid",
            DOWNLOAD_FAILED: "Downloaden mislukt. Probeer het opnieuw.",
        },
        MAP: {
            MAP_COORDINATES: "{{latitude}} N, {{longitude}} E",
            MAP_COORDINATES_LABEL: "Coördinaten",
            MAP_ADDRESS_DISPLAY: "Adres weergeven op kaart",
            MAP_DRAG_MARKER: "Sleep op de kaart om de pin te plaatsen",
            MAP_ENABLE_ON_COUNTRY: "Selecteer een land om de kaart in te schakelen",
            WARNING: "WARNING",
            BLOCKED: "GEBLOKKEERD",
            ERROR: "FOUT",
            OFFLINE: "OFFLINE",
            READY: "KLAAR",
            SYSTEM: "Systeem",
            SYSTEMS: "Systemen",
        },
        MAINTENANCE_DETAILS: {
            ADD_DOC: "+ Document toevoegen",
            ADD_NOTES: "+ Voeg notities toe",
            ADD_DOCUMENT_BUTTON: "+ Document of foto toevoegen",
            NEW_MAINTENANCE: "Nieuw onderhoud",
            CREATE_MAINTAINENCE_BUTTON: "Toewijzen en melden",
            TECHNICIAN_INPUT_LABEL: "Toegewezen aan",
            STATUS_COMPLETED: "Ingevuld",
            CUSTOMER_CONTACT: "Klant contacten",
            DATE_CREATED: "Datum gemaakt",
            DELETE_REQ: "Verzoek verwijderen",
            COMMENTS_LABEL: "Beschrijving (optioneel)",
            DOCUMENTATION: "Documentatie",
            STATUS_DUE: "Vanwege",
            EMERGENCY: "Noodgeval",
            STATUS_EXPIRED: "Verlopen",
            HIGH: "Hoog",
            IN_DUE: "IN {{differenceInDays}} DAYS",
            UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_TYPE: "Ongeldig bestandstype. Alleen PDF, JPEG en PNG zijn toegestaan.",
            SUPPORT_TYPE_INPUT_LABEL: "Probleem type",
            LIFECYCLE_MAINTAINANCE: "Levenscyclusonderhoud",
            LIFECYCLE_MAINTENANCE: "Levenscyclusonderhoud",
            LOCATION: "Locatie(s)",
            LOW: "Laag",
            MAINTENANCE_HISTORY: "Onderhoud Geschiedenis",
            MAINTENANCE_REQUEST: "Onderhoudsverzoek",
            MEDIUM: "Medium",
            NO_CUSTOMER_LINKED: "Geen klant gekoppeld",
            NO_DOC_ADDED: "Geen documentatie toegevoegd",
            NO_MAINTENACE_FOUND: "Geen onderhoud gevonden",
            NO_NOTES_ADDED: "Geen notities toegevoegd",
            NOTES: "Opmerkingen",
            UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_FILE_SIZE: "Een of meer bestanden overschrijden de limiet van 2 MB.",
            PAST_DUE: "Verleden tijd",
            PRIORITY: "Prioriteit",
            STATUS_REJECTED: "Afgewezen",
            REOPEN_SERVICE_TICKET: "Serviceticket opnieuw openen",
            REQUEST_PRIORITY_INPUT_LABEL: "Prioriteit aanvragen",
            REQ_MAINTENANCE: "Aangevraagd onderhoud",
            REQUESTED_MAINTAINANCE: "Aangevraagd onderhoud",
            SCHEDULED: "Gepland",
            STATUS_SCHEDULED: "Gepland",
            SCH_SERVICE_DATE: "Geplande servicedatum",
            SEARCH: "Zoek op ticketnummer",
            SERVICE_DATE: "Service datum",
            SERVICE_TICKET_NO: "Serviceticketnummer",
            SERVICE_TYPE: "Diensttype",
            SUPPORT_TECHNICIAN: "Ondersteunende technicus",
            SYS_FAILURE: "Systeem Storing",
            SYSTEM_FAILURE: "Systeem Storing",
            TICKET_CLOSED: "Ticket gesloten",
            TICKET_NO: "Ticketnummer",
            STATUS: "Ticketstatus:Alles",
            TODAY: "VANDAAG",
            UPLOAD_DOCUMENT_ERROR_MESSAGE_MAX_3_FILES: "U kunt maximaal 3 bestanden selecteren.",
            EDIT_SERVICE_TICKET: "Serviceticket bewerken",
            MAINTENANCE_OPERATIONS: "Onderhoudswerkzaamheden",
            SCHEDULED_MAINTENANCE: "Gepland onderhoud",
            RECENT_MAINTENANCE: "Recent onderhoud",
            CLOSE_SERVICE_TICKET: "Serviceticket sluiten",
            CLOSE_TICKET: "Kaartje sluiten",
            DESCRIBE_ACTION: "Beschrijf de acties die zijn ondernomen om het probleem op te lossen",
            TICKET_RESOLUTION: "Ticketresolutie",
            CLOSED_BY: "Gesloten door",
            TIME_RANGE_All: "Tijdbereik: Alles",
            MAINTENANCE_TYPE_ALL: "Onderhoudstype: Alles",
            ORGANIZATION_ALL: "Organisatie: allemaal",
            CUSTOMER_All: "Klant: allemaal",
            TICKET_NUMBER_ALL: "Ticketnummer: Alles",
            SLA_ALL: "SLA: Allemaal",
            TECHNICIAN_ALL: "Technicus: allemaal",
            COMPLETED_7_DAYS: "Voltooid in de afgelopen 7 dagen",
            COMPLETED_30_DAYS: "Voltooid in de afgelopen 30 dagen",
            TECHNICAN: "Technicus:",
            TICKET_NO_: "Ticketnr.",
            NO_RECORD_FOUND: "Geen record gevonden",
            ADD_NOTES_TITLE: 'Voeg notities toe',
            NOTE_HELPER_TEXT: 'Er kunnen geen notities worden toegevoegd aan gesloten tickets',
            NOTE_255_CHAR: 'Opmerking mag niet langer zijn dan 255 tekens',
            NOTE_SPECIAL_CHAR: 'Notitie mag geen speciale tekens bevatten',
            NOTES_PLACEHOLDER: 'Voer notities in',
            UPLOAD_DOCUMENT_ERROR_MESSAGE_EXCEEDS_FILE_SIZE: "De totale grootte van de geselecteerde bestanden overschrijdt de limiet van 2 MB.",
        },
        ASSETS_DETAILS: {
            ADD_BUILDINGS: "+ Gebouw toevoegen",
            ADD_SYSTEMS: "| Systeem toevoegen",
            NEW_MAINTAINENCE: "Systeem toevoegen",
            BUILDINGS: "Gebouwen",
            CUSTOMER_MAINTAINENCE_HEADER: "Klantgegevens",
            CUSTOMER_INFO_HEADER: "Klant informatie",
            DOWNLOAD_AS: "Downloaden als…",
            FIRMWARE: "Firmware",
            GATEWAYS: "Gateways",
            LINK_TO_CUSTOMER_BUTTON: "Koppeling naar klant",
            MAIN_CONTACT: "Hoofdcontact",
            RIGHT_MAINTAINENCE_HEADER: "Details onderhouds ",
            MOST_RECENT_STATUS: "Meest recente status",
            NOTIFY_USERS_MAINTAINENCE_HEADER: "Gebruikers op de hoogte stellen:",
            SUBHEADER_TEXT_MAINTAINENCE: "Controleer de informatie, wijs een technicus toe en vermeld eventuele nuttige details om het probleem op te lossen.",
            PREVIOUS_SYSTEM_STATUS: "Vorige systeemstatus",
            CREATE_MAINTAINENCE_HEADER: "Een nieuwe onderhoudsoperatie plannen",
            ADD_BUILDING_ASSET: "Selecteer een organisatie om een ​​gebouw aan te maken",
            SELECT_ORGANIZATION_LABEL: "Selecteer organisatie",
            SHOW_FAVORITE_BUILDINGS: "Alleen gebouwen met ster ",
            SHOW_FAVORITE_GATEWAYS: "Alleen gateways met ster ",
            SHOW_FAVORITE_SYSTEMS: "Alleen systemen met ster ",
            SLA_SUBTITLE: "SLA#",
            LEFT_MAINTAINENCE_HEADER: "Systeemdetails",
            SYSTEM_NAME_TYPE_SUBTITLE: "Systeemnaam en -type",
            SYSTEMS: "Systemen",
            HELPER_TEXT_MAINTAINENCE: "Dit verzoek zal {{customName}} primaire en secundaire contacten waarschuwen. Het bevat standaard relevante locatie-, apparaat-, alarm- en gebeurtenisinformatie.",
            NO_CUSTOMER_TEXT: "Dit systeem is niet gekoppeld aan een klant",
            SLA: "SLA's",
            ADD_SLAS: "SLA toevoegen",
            MAINTENANCE_TICKETS: "Onderhoudstickets",
            SCHEDULE_MAINTENANCE: "Plan onderhoud",
            SHOW_FAVORITE_SLAS: "Alleen SLA's met ster weergeven",
            LINK_CUSTOMER_DIALOG_SEARCH: "Zoek klant op naam",
            LINK_TO_CUSTOMER_DIALOG_HEADER: "Van wie is dit systeem?",
            LINK_TO_CUSTOMER_DIALOG_SECOND_HEADER: "Wat zijn de SLA-details voor dit systeem?",
            BUILDING_INFO_HEADER: "Gebouw informatie",
            BUILDING_ADDRESS: "Adres",
            BUILDING_OFFICE: "Kantoor",
            BUILDING_OTHER_SYSTEMS: "Andere systemen",
            ALL_SYSTEMS_IN_BUILDING: "Alle systemen in dit gebouw",
            ALL_CONTACTS_IN_BUILDING: "Alle mensen in dit gebouw",
            DOWNLOAD_TOOLTIP: "Selecteer gebouw of systeem",
            TOTAL_SLA: "Totale SLA",
            FOR_SYSTEM: "Voor systemen",
            FOR_BUILDING: "Voor Gebouwen",
            ADD_SLA: '+ New SLA',
            CREATE_NEW_CUSTOMER_BUTTON: '+Nieuwe klant aanmaken',
            FIRE_PANELS: 'Brandpanelen',
            NO_FIRE_PANELS_FOUND: 'Geen brandpanelen gevonden',
        },
        COMMON: {
            SYNC_NOW_TIME: "=--min geleden",
            REQUIRES_FIRMWARE_UPDATE: "1  firmware update nodig",
            NOTIFICATION_REPORT_MESSAGE_BODY: "Een nieuw maandrapport voor:{{bodytext}} is beschikbaar om te bekijken",
            ACCESS: "Toegang",
            ACTIVE: "Actief",
            ALERT: "Waarschuw",
            DOWNLOAD_PERMISSION: "Sta de machtigingen toe om het bestand op uw apparaat op te slaan",
            GO_BACK: "GA TERUG",
            NOTIFICATION_EVENT_OCCURED: "Er is een {{logType}} opgetreden met het volgende systeem",
            ASSETS: "Activa",
            BACK: "Terug",
            BLOCKED: "GEBLOKKEERD",
            CANCEL: "Annuleren",
            CANNOT_REFRESH_TOKEN: "Kan token niet vernieuwen",
            CLOSE: "Sluit",
            SET_ETHERNET: "Configureer poortinstellingen",
            CONFIRM: "Bevestigen",
            CONNECT: "Maak verbinding",
            CONNECTION: "Aansluiting",
            CSV: "CSV",
            DASHBOARD: "Dashboard",
            DISCARD: "Verwerpen",
            DISCARD_UNSAVED_CHANGE: "Niet-opgeslagen wijzigingen verwijderen?",
            DONE: "Gedaan",
            DOWNLOAD: "Downloaden",
            DOWNLOAD_FAILED: "Downloaden mislukt. Probeer het opnieuw",
            COMPANY: "Eaton",
            EDIT: "Bewerking",
            APP_NAME: "Building Safety Manager",
            EMPTY: "LEEG",
            INTERVAL_SEVENDAYS: "Elke 7 dagen",
            INTERVAL_90DAYS: "Elke 90 dagen",
            EXCEL: "Excel-bestand",
            EXIT: "Verlaten",
            EXTEND: "Verllengen",
            DOWNLOAD_SUCCESS: "Bestand met succes gedownload.",
            ANOMALY: "IN ANOMALIE",
            INACTIVE: "Inactief",
            INCOMPLETE: "Onvolledig",
            INFO: "Informatie",
            INTERVAL: "Interval",
            KEEP_EDITING: "Blijf bewerken",
            LAST_RETRIEVED: "Laatst opgehaald: -- min geleden",
            LINK: "Koppeling",
            LOCATE: "Lokaliseren",
            LOGBOOK: "Logboek",
            LOGGED_IN_SUCCESSFULLY: "Succesvol ingelogd",
            NOTIFICATION_NEW_REPORT_AVAILABLE: "Nieuw rapport beschikbaar",
            NEWUSER: "Nieuwe gebruiker",
            NODATA: "Geen gegevens",
            OFF: "uit",
            OFFLINE: "Offline",
            OK: "OK",
            ON: "op",
            PASSWORD: "Wachtwoord",
            PDF: "Pdf",
            SELECT_PREFERRED_LANGUAGE: "Selecteer uw \nVoorkeurstaal",
            POWERED_BY_BRIGHTLAYER: "Aangedreven door Brightlayer",
            READY: "GEREED",
            RECOONECTTOGATWAY: "Opnieuw verbinden met gateway",
            REFRESH: "Vernieuwen",
            REMOVE: "Verwijderen",
            RETURNTODASHBOARD: "Keer terug naar het dashboard",
            NAVIGATION_HEADER: "Veiligheidsbeheersysteem",
            SAVE: "Redden",
            REFRESH_TOKEN_ERROR: "Beveiligingstoken mag niet null of leeg zijn",
            SESSION_ALERT_TITLE: "Sessietime-out",
            SET: "Set",
            SETTINGS: "Instellingen",
            VIEW_ALL_SYSTEM: "Toon alles",
            SKIP: "Overslaan",
            STOP: "Stop",
            PERMISSION_ERROR: "Opslagtoestemming niet verleend",
            SYNC: "Synchroniseren",
            SYNCH_OFFLINE_DATABASE: "Synchroniseer offline database",
            SYSTEM: "Systeem",
            SESSION_ALERT_SUBTITLE: "Dit venster is 15 minuten inactief geweest. Als er geen actie wordt ondernomen in {{extendTime}}, wordt u uitgelogd.",
            TIME: "Tijd",
            TRYAGAIN: "Opnieuw proberen",
            DOWNLOAD_FAIL: "Kan niet downloaden, probeer het opnieuw.",
            UNAUTHORIZED_ACCESS: "Ongeautoriseerde toegang",
            UNLINK: "Ontkoppelen",
            USERS: "Gebruikers",
            VIEW: "Bekijk",
            YES: "Ja",
            EMPTY_SYSTEM_TITLE: "Je hebt nog geen middelen in deze organisatie.",
            EMPTY_SYSTEM_SUBTITLE: "U ziet statusinformatie over uw noodverlichting zodra u activa (systemen) aan deze organisatie gaat toevoegen.",
            ERROR_OCCURED: "Fout opgetreden in",
            OOPS: "Oeps!'",
            THERE_IS_ERROR: "Er is een fout",
            NEW_VERSION_AVAILABLE: "Nieuwe versie van de app beschikbaar in",
            UNDER_MAINTENANCE: "De app is momenteel in onderhoud.",
            UNDER_MAINTENANCE_TITLE: "App in onderhoud",
            UPDATE_AVAILABLE_TITLE: "Update beschikbaar",
            UPDATE_REQUIRED_TITLE: "Update vereist",
            UPDATE_NOW: "Nu bijwerken",
            ASK_ME_LATER: "Vraag het mij later",
            OKTA_LOGOUT_ALERT: "Weet je zeker dat je wilt uitloggen bij okta?",
            OKTA_LOGIN_BUTTON: "Meld u aan met Okta",
            CANNOT_PROCCED_LOGIN: "U bent een ongeautoriseerde gebruiker. Meld u alstublieft aan.",
            UNAUTHORIZED_ACCESS_OKTA: "Autorisatiefout",
            SCAN: "Scannen",
            NO: "Nee",
            ACKNOWLEDGE: "Erkennen",
            HOURS: "uur",
            MINUTES: "notulen",
            SECONDS: "seconden",
            AGO: "geleden",
            ALL: "Alles",
            NEXT: "Volgende",
            NAME: "Naam",
            DESCRIPTION: "Beschrijving (optioneel)",
            LAST_RETREIVED: "Laatst opgehaald",
            SAVE_UPDATES: "Wijzigingen opslaan",
            VALID_EMAIL_ERROR: "Voer een geldig e-mailadres in",
        },
        PASSWORD_REQUIREMENTS: {
            LENGTH: "8-16 tekens",
            LOWER: "Eén kleine letter",
            NUMBERS: "Eén nummer",
            SPECIAL: "Eén speciaal karakter",
            UPPER: "Eén hoofdletter",
        },
        AUTH_TRANSLATION: {
            FORGOT_PASSWORD: {
                LINK_SENT_ALT: "Een link om uw wachtwoord te resetten is verzonden naar <1>{email}}</1>.",
                LINK_SENT: "Een link om uw wachtwoord te resetten is verzonden naar <1>{email}}</1>.",
                ERROR: "Kan uw wachtwoord op dit moment niet opnieuw instellen.",
                INSTRUCTIONS_ALT: "Voer het e-mailadres van het account in dat aan het account is gekoppeld",
                INSTRUCTIONS: "Voer het e-mailadres van het account in dat aan het account is gekoppeld.Als deze e - mail een account bij Eaton heeft, ontvangt u binnen<b> één werkdag</ b > een reactie.Voor dringende accountproblemen kunt u bellen { { telefoon } }.",
                RESET_CODE_ERROR: "Er is een fout opgetreden met uw resetcode.",
            },
            MESSAGES: {
                USER_PHONE_NUMBER_INVALID: "Een telefoonnummer is ongeldig",
                CONGRATS: "Gefeliciteerd!",
                CONTACT: "Neem contact op met een Eaton-ondersteuningsvertegenwoordiger",
                EMAIL_SENT: "Verzonden e-mail",
                ERROR: "Fout!",
                FAILURE: "Mislukking",
                INVALID_VERIFICATION_CODE: "Verificatiecode is niet geldig of de lengte moet minder dan 6 tekens zijn",
                LOADING: "Bezig met laden...",
                GENERIC_ERROR_MESSAGE: "Neem contact op met uw beheerder als de gevraagde bewerking niet kan worden voltooid.",
                EMAIL_ENTRY_ERROR: "Voer een geldig e-mailadres in",
                USER_EMAIL_INVALID: "Geef een geldig e-mailadres op.",
                REQUEST_ERROR: "Sorry, er is een probleem opgetreden bij het verzenden van uw verzoek.",
                SUCCESS: "Succes",
                WELCOME: "Welkom",
                LOGIN_MESSAGE: "U bent 'ingelogd'",
            },
            CHANGE_PASSWORD: {
                PROBLEM_OCCURRED: "Er heeft zich een probleem voorgedaan:",
                CANCEL: "Annuleren",
                PASSWORD: "Wachtwoord wijzigen",
                CONFIRM_NEW_PASSWORD: "Nieuw wachtwoord bevestigen",
                OLD_PASSWORD: "Oud wachtwoord",
                PASSWORD_CHANGED: "Wachtwoord gewijzigd",
                PASSWORD_INFO: "Het wachtwoord moet minimaal 8 tekens lang zijn en minimaal één hoofdletter, één kleine letter, één cijfer en één speciaal teken bevatten.",
                UPDATE: "Update",
                EMAIL_CONFIRM_MESSAGE: "We hebben een bevestigingsmail gestuurd naar <b>{{email}}</b>",
                ERROR_MESSAGE: "Uw gegevens komen niet overeen met onze gegevens. Voer uw gegevens opnieuw in om het opnieuw te proberen.",
                SUCCESS_MESSAGE: "Uw wachtwoord is succesvol bijgewerkt! Om de veiligheid van uw account te garanderen, moet u zich bij de applicatie aanmelden met uw bijgewerkte inloggegevens.",
            },
            SELF_REGISTRATION: {
                VERIFY_EMAIL: {
                    MESSAGE: "Er is een verificatiecode naar het door u opgegeven e-mailadres verzonden. Klik op de link of voer de onderstaande code in om door te gaan. Deze code is 30 minuten geldig.",
                    VERIFICATION_CODE_PROMPT: "Geen code ontvangen?",
                    RESEND: "Verificatie-e-mail opnieuw verzenden",
                    VERIFICATION: "Verificatiecode",
                },
                ALREADY_REGISTERED_USER: "Reeds geregistreerde gebruiker",
                INSTRUCTIONS: "Om u te registreren voor een Eaton-account, voert u hieronder de vereiste informatie in. U moet uw e-mailadres verifiëren om door te gaan.",
            },
            REGISTRATION: {
                STEPS: {
                    COMPLETE: "Account aangemaakt!",
                    ACCOUNT_DETAILS: "Accountgegevens",
                    COMPANY_ADDRESS: "Bedrijfsadres",
                    COMPANY_DETAILS: "Adres bedrijf",
                    CREATE_ACCOUNT: "Een account aanmaken",
                    PASSWORD: "Wachtwoord aanmaken",
                    LICENSE: "Licentieovereenkomst",
                    VERIFY_EMAIL: "E-mail verifiëren",
                },
                INSTRUCTIONS: {
                    ACCOUNT_DETAILS: "Vul hieronder uw gegevens in om het aanmaken van een account te voltooien.",
                    COMPANY_DETAILS: "Hierdoor kan Eaton de serviceondersteuning bieden voor uw noodverlichtingsoplossing. Als u een project voor uw klant initieert, voer dan de informatie in voor uw eigen bedrijf, niet voor die van uw klant.",
                    COMPANY_ADDRESS: "Hierdoor kan Eaton de serviceondersteuning bieden voor uw noodverlichtingsoplossing. Als u een project voor uw klant initieert, voer dan de informatie in voor uw eigen bedrijf, niet voor die van uw klant.",
                },
                EULA: {
                    AGREE_TERMS: "Ik heb de Algemene Voorwaarden gelezen en ga ermee akkoord",
                    LOADING: "Licentieovereenkomst voor eindgebruikers laden...",
                    LANGUAGE: 'Selecteer uw voorkeurstaal',
                    LANGUAGE_SUCCESS: 'Taal succesvol bijgewerkt',
                    ENGLISH: 'English',
                    DEUTSCH: 'Deutsch',
                    FRENCH: 'Français',
                    POLISH: 'Polish',
                    CZECH: 'Czech',
                    NORWEGIAN: 'Norwegian',
                    SPANISH: 'Spanish',
                    DUTCH: 'Dutch',
                },
                UNKNOWN_EMAIL: "Onbekend e-mailadres",
                FAILURE_MESSAGE: "We konden uw registratie niet voltooien. Druk hieronder op doorgaan om te voltooien.",
                SUCCESS_MESSAGE_ALT: "Je account is succesvol aangemaakt met het e-mailadres <1>{{email}}</1>.Je account is al toegevoegd aan de organisatie< 3 > {{ organization }} </3>.Druk hieronder op doorgaan om te voltooien.",
                SUCCESS_MESSAGE: "Uw account is succesvol {{state}} met de e-mail {{email}}.\n\nU bent toegevoegd aan {{organization}} .',",
                SUCCESS_EXISTING: "Uw account is succesvol aangemaakt. Meld u aan met het e-mailadres en wachtwoord van uw Eaton-account.",
                SUCCESS_SYNCED_MESSAGE: "Uw EL Digital-account is succesvol gesynchroniseerd met de Bright Layer Cloud-informatie die is gekoppeld aan de e-mail <b>{{email}}</b>.",
                SUCCESS_FINISH: "Klik op Voltooien om in te loggen en toegang te krijgen tot uw account.",
                SUCCESS_DASHBOARD: "Klik op Ga naar mijn dashboard om door te gaan met uw account.",
            },
            ACTIONS: {
                BACK: "Terug",
                CANCEL: "Annuleren",
                CHANGE_LANGUAGE: "Wijzig taal hier!",
                CLICK_BUTTON: "Klik op de knop",
                UPDATE_REDUX: "Klik op de knop om de redux winkelwaarde bij te werken!",
                CONTINUE: "Doorgaan",
                DONE: "Gedaan",
                FINISH: "Voltooien",
                GO_HOME: "Ga naar Home",
                GO_DASHBOARD: "Ga naar Mijn Dashboard",
                GO_TEST: "Ga naar de testpagina",
                LOG_IN: "Log in ",
                LOG_OUT: "Afmelden",
                NEXT: "Volgende",
                OKAY: "Oké",
                REMEMBER: "Onthoud mij",
                RESEND: "Opnieuw verzenden",
                SEND_AGAIN: "Opnieuw verzenden",
                SEND_EMAIL: "E-mail verzenden",
                CREATE_ACCOUNT: "Aanmelden",
                UPDATE: "Update",
                LINK_SYSTEM: "Link-systeem",
            },
            FORMS: {
                COMPANY_NAME: "Bedrijfsnaam",
                CONFIRM_PASSWORD: "Bevestig wachtwoord",
                COUNTRY: "Land",
                CURRENT_PASSWORD_ERROR: "Huidig ​​wachtwoord komt niet overeen",
                FIRST_NAME: "Voornaam",
                RESET_PASSWORD: "Wachtwoord vergeten",
                LAST_NAME: "Laatste naam",
                ORGANAIZATION_ADRESS: "Organisatieadresregel 1*",
                PASSWORD: "Wachtwoord",
                PASS_MATCH_ERROR: "Wachtwoorden komen niet overeen",
                PHONE_NUMBER: "Telefoonnummer",
                TOGGLE_PASSWORD_VISIBILITY: "Schakel de zichtbaarheid van wachtwoorden in",
            },
            LABELS: {
                CURRENT_PASSWORD: "Huidig wachtwoord",
                EMAIL: "E-mailadres",
                FORGOT_PASSWORD: "Wachtwoord vergeten?",
                NEED_ACCOUNT: "Een account nodig?",
                NEW_PASSWORD: "Nieuw wachtwoord",
                OPTIONAL: "Optioneel",
                PASSWORD: "Wachtwoord",
                USERNAME: "Gebruikersnaam",
            },
            LOGIN: {
                INCORRECT_CREDENTIALS: "Onjuist e-mailadres of wachtwoord",
                GENERIC_ERROR: "Uw verzoek kan op dit moment niet worden verwerkt.",
                INVALID_CREDENTIALS: "Uw gebruikersnaam/wachtwoord-combinatie wordt niet herkend.",
            },
            BLEDEVICE_COMMISSION_STEP: {
                STEP_NUMBER: 'Stap {{stepNo}} van {{totalSteps}}',
            },
        },
        REGISTRATION: {
            STEPS_MESSAGE: {
                CREATE_ACCOUNT_VERIFY_EMAIL: "Er is een verificatiecode naar het door u opgegeven e-mailadres verzonden. Klik op de link of voer de onderstaande code in om door te gaan. Deze code is 30 minuten geldig.",
                CREATE_ACCOUNT_USER_DETAILS: "Vul hieronder uw gegevens in om het aanmaken van een account te voltooien.",
                CREATE_ACCOUNT_COMPANY_DETAILS: "Dit helpt Eaton bij de serviceondersteuning voor uw noodverlichtingsoplossing. Als u een project voor uw klant initieert, voer dan de informatie in voor uw eigen bedrijf en niet voor dat van uw klant.",
                CREATE_ACCOUNT_ENTER_EMAIL: "Om u te registreren voor een account voor het Safety Management System, voert u hieronder de vereiste gegevens in. U moet uw e-mailadres verifiëren om door te gaan.",
            },
            STEPS: {
                COMPLETE_OTHER_ADOPTER: "Account bevestigd!",
                COMPLETE: "Account aangemaakt!",
                ACCOUNT_DETAILS: "Accountgegevens",
                COMPANY_ADDRESS: "Adres bedrijf",
                COMPANY_DETAILS: "Bedrijfsgegevens",
                CREATE_ACCOUNT: "Een account aanmaken",
                PASSWORD: "Wachtwoord aanmaken",
                FORGOT_PASSWORD: "Wachtwoord vergeten",
                LICENSE: "Licentieovereenkomst",
                VERIFY_EMAIL: "E-mail verifiëren",
            },
            STEPS_ERROR_MESSAGE: {
                USER_ALREADY_EXIST_MESSAGE: "Reeds geregistreerde gebruiker",
                USER_INVALID_ENTRY: "Invoerparameters mogen niet null of leeg zijn.",
                GENERIC_ERROR_MESSAGE: "Neem contact op met uw beheerder als de gevraagde bewerking niet kan worden voltooid.",
                USER_EMAIL_INVALID: "Geef een geldig e-mailadres op.",
                VERIFICATION_CODE_EXPIRED_MESSAGE: "De code is verlopen. Klik op de onderstaande knop om een ​​nieuwe verificatie-e-mail aan te vragen.",
                USER_PHONE_NUMBER_INVALID: 'Een telefoonnummer is ongeldig',
            },
            EULA: {
                AGREE_TERMS: 'Ik heb de Algemene Voorwaarden gelezen en ga ermee akkoord',
                LOADING: 'Licentieovereenkomst voor eindgebruikers laden...',
                LANGUAGE: 'Selecteer uw voorkeurstaal',
                LANGUAGE_SUCCESS: 'Taal succesvol bijgewerkt',
                ENGLISH: 'English',
                DEUTSCH: 'Deutsch',
                FRENCH: 'Français',
                POLISH: 'Polish',
                CZECH: 'Czech',
                NORWEGIAN: 'Norwegian',
                SPANISH: 'Spanish',
                DUTCH: 'Dutch',
            },
            FAILURE_MESSAGE: "We konden uw registratie niet voltooien. Druk hieronder op Doorgaan om door te gaan naar de Eaton ELDigital-suite",
            SUCCESS_MESSAGE: "Uw account is succesvol aangemaakt met het e-mailadres {{email}}.",
            SUCCESS_MESSAGE_OTHER_ADOPTER: "Uw EL Digital-account is succesvol gesynchroniseerd met de Bright Layer Cloud-informatie die is gekoppeld aan de e-mail <2>{{email}}</2>.",
        },
        VERIFY_EMAIL: {
            EMAIL_INFO:
                'Er is een verificatiecode verzonden naar het opgegeven e-mailadres. Klik op de link of voer de onderstaande code in om door te gaan. Deze code is 30 minuten geldig.',
        },
        USER_INVITATION_REGISTRATION: {
            ACCEPT: "Accepteren",
            DENY: "Weigeren",
            INSTRUCTIONS: "Als deze e-mail een account bij Eaton heeft, ontvangt u binnen <3>één werkdag</3> een reactie.<br/><br/>Voor dringende accountproblemen kunt u bellen",
            TITLE: "Veiligheidsbeheersysteem - Gebruikersuitnodiging",
            INVITATION_VALIDATION_ERROR: "Er is een fout opgetreden met uw uitnodigingscode.",
        },
        DASHBORAD: {
            ACCEPT_BUTTON: "Uitnodiging accepteren",
            ACCEPT_HEADER: "Uitnodiging accepteren?",
            ACCEPTED_INVITATION: "Aanvaarde uitnodigingen",
            ACCEPT_TITLE: "Het accepteren van de uitnodiging voegt het volgende item toe aan je profiel:",
            ADD_NEW_ORGANIZATION: "Een nieuwe organisatie toevoegen...",
            ADD_ANOTHER_ORGANIZATION: "Voeg nog een organisatie toe",
            ALL_BUILDINGS: "Alle gebouwen",
            ALL_CITIES: "Alle steden",
            ALL_COMPANIES: "Alle bedrijven",
            ALL_COUNTRIES: "Alle landen",
            ALL_CUSTOMER_ID: "Alle klant-ID",
            ALL_ORGANIZATIONS: "Alle organisaties",
            ALL_GATEWAYS: "Alle gateways",
            ALL_STATUSES: "Alle status",
            ALL_STATUS: "Alle statussen",
            ALL_TYPES: "Alle soorten",
            BLOCKED: "Geblokkeerd",
            BUILD_DETAILS: "Gebouwdetails",
            BUILDINGS: "Gebouwen",
            CUSTOMERS: "Klanten",
            DECLINE: "Weigeren",
            DECLINED_INVITATION: "Afgewezen uitnodigingen",
            DISPLAY_ADDRESS_ON_MAP: "Adres weergeven op kaart",
            MAP_DRAG_TITLE: "Sleep op de kaart om de pin te plaatsen",
            REQUEST_ACCESS_SENT: "Uitnodiging voor toegang per e-mail verzonden naar gebruiker",
            ERROR: "Fout",
            EVENT: "Gebeurtenis",
            EXPIRED_INVITATION: "Verlopen uitnodigingen",
            EXPORT_REPORT: "Rapport exporteren",
            GATEWAY: "Gateways",
            IN_ANOMALY: "Bij anomalie",
            INFORMATION: "Informatie",
            INVITATION_HISTORY: "Uitnodigings Geschiedenis",
            ISSUES: "problemen",
            JOIN: "Word jid",
            LIST_VIEW: "Lijstweergave",
            MAP_VIEW: "Kaartweergave",
            MONTHLY_REPORT: "Maandelijks rapport",
            NO_ISSUES_DURING_THIS_PERIOD: "Geen problemen tijdens deze periode",
            ORG_DETAILS: "Organisatie Details",
            PENDING_INVITATION: "Openstaande uitnodigingen",
            CHOOSE_REPORT_YOU_WOULD_LIKE_TO_SAVE_SHARE: "Kies het gewenste rapport opslaan of delen.",
            PLEASE_MAKE_A_SELECTIONS: "Maak een selectie",
            REQUEST_SUBTITLE: "Vraag toegang aan de persoon die de uitnodiging heeft verzonden om dit item aan uw profiel toe te voegen.",
            INVITATION_BODY: "Selecteer items om aan uw profiel toe te voegen of om een ​​uitnodiging te weigeren.",
            READY: "Gereed",
            NO_CONTENT: "Vervang deze pagina door uw eigen inhoud",
            REPORTS: "Rapporten",
            REQUEST_BUTTON: "Toegang aanvragen",
            REQUEST_HEADER: "Toegang aanvragen?",
            CHECK_INVITATIONS: "Scannen naar uitnodigingen...",
            SELECT_ALL: "Selecteer Alles",
            SELECTIONS_CONFIRMED: "Selecties bevestigd",
            SERVICE_MANAGERS: "Servicemanagers",
            SYSTEMS: "Systemen",
            TECHNICIANS: "Technici",
            EMPTY_ACCEPTED_INVITATION: "Er zijn momenteel geen geaccepteerde uitnodigingen",
            EMPTY_DECLINED_INVITATION: "Er zijn momenteel geen geweigerde uitnodigingen",
            EMPTY_EXPIRED_INVITATION: "Er zijn momenteel geen verlopen uitnodigingen",
            EMPTY_REQUESTED_INVITATION: "Er zijn op dit moment geen gevraagde uitnodigingen",
            REQUEST_TITLE: "Deze uitnodiging is verlopen en kan niet meer aan uw profiel worden toegevoegd.",
            TOTAL_ACCEPTED_INVITATIONS: "Totaal aantal geaccepteerde uitnodigingen",
            TOTAL_LUMINAIRES: "Totaal armaturen",
            TOTAL_SYSTEMS: "Totaal systemen",
            UPDATING_PROFILE: "Je profiel bijwerken...",
            VIEW_ALL: "Alles weergeven",
            VIEW_ALL_ACCESS_RIGHTS: "Alle toegangsrechten weergeven",
            VIEW_ALL_BUIDINGS: "Alle gebouwen weergeven",
            VIEW_ALL_SYSTEM: "Alle systemen weergeven",
            WARNING: "Waarschuwing",
            INVITATION_SUB_HEADING: "Je bent uitgenodigd voor de volgende projecten:",
            REPORTS_BUILDINGS: "Gebouwen",
            REPORTS_SYSTEMS: "Systemen",
        },
        TRANSFER_BUILDINGS: {
            PASSWORD: "Account wachtwoord",
            ERRORMESSAGE: "Inloglimieten overschreden. Probeer het over enige tijd opnieuw",
            HEADER: "Draag alle {{buildingCount}} gebouwen, inclusief alle X-gateways en {{systemCount}} systemen daaronder, definitief over aan een andere organisatie. U moet organisatiebeheerder zijn voor beide organisaties om de actie uit te voeren.",
            ACTION: "Typ uw accountwachtwoord om de actie te bevestigen.",
            TRANSFER_TO: "Overbrengen naar...",
        },
        DRAWER: {
            ACCOUNTPREFERENCES: "Account Voorkeuren",
            RIGHTS_RESERVED: "Alle rechten voorbehouden",
            ASSETS: "Activa",
            COPYRIGHT: "Auteursrecht © Eaton",
            DASHBOARD: "Dashboard",
            OVERVIEW: "Dashboard",
            DEVICES: "Apparaten",
            HELP: "Hulp",
            HELPANDFEEDBACK: "Hulp en feedback",
            LEGAL: "Juridisch",
            LOCATIONS: "Locaties",
            LOGBOOK: "Logboek",
            MAINTENANCE: "Onderhoud",
            MANAGELOCATION: "Locaties en sites beheren",
            MANAGEUSER: "Gebruikers beheren",
            ORGSETTINGS: "Mijn organisaties",
            MYPROFILE: "Mijn profiel",
            EMERGENCY_LIGHT: "Powered by Brightlayer",
            REPORTS: "Rapporten",
            ELDIGITAL: "Veiligheidsbeheersysteem",
            SELECT_ACCOUNT: "Selecteer Account",
            SETTINGS: "Instellingen",
            TIMELINE: "Tijdlijn",
            USERS: "Gebruikers",
        },
        SETTINGS: {
            TITLE: "Account Voorkeuren",
            SUBTITLE: "Admin-niveau - Gebruikers",
        },
        USER_MENU: {
            ACCOUNT_SETTING: "Accountinstellingen",
            CONTACT_US: "Neem contact met ons op",
            LOG_OUT: "Uitloggen",
        },
        USER_DETAIL: {
            ACTIVE: "ACTIEF",
            COMPANY_ADRESS: "Adres bedrijf",
            COMPANY_DETAIL: "Bedrijfsgegevens",
            COMPANY_NAME: "Bedrijfsnaam",
            COMPANY_PHONE_NUMBER: "Telefoonnummer bedrijf",
            EMAIL_ID: "E-mailadres",
            INACTIVE: "INACTIEF",
            PERSONAL_ADRESS: "functie titel",
            LEAVE_ORGANISATION: "Verlaat de organisatie",
            JOB_TITLE: "Persoonlijk adres",
            PERSONAL_PHONE_NUMBER: "Persoonlijk telefoonnummer",
            PHONE_NUMBER: "Telefoonnummer",
            REMOVE_USER: "Gebruiker verwijderen",
            USER_NAME: "Gebruikersnaam",
        },
        FILTER: {
            ACTIVE_LOGS_ONLY: "Alleen actieve logboeken",
            ALL: "Alle",
            ALL_LOG_TYPES: "Alle logtypen",
            CUSTOM: "Aangepast...",
            PAST_TWELVE_MONTHS: "Afgelopen 12 maanden",
            PAST_SIX_MONTHS: "Afgelopen 6 maanden",
            SINCE_THE_BEGINNING_OF_YEAR: "Sinds begin van {{currentyear}}",
        },
        LOGBOOK: {
            LOGBOOK_ACTIVELOG: "Alleen actieve logboeken",
            LOGBOOK_ALL: "Alle",
            LOGBOOK_ALLLOG: "Alle log typen",
            CUSTOM_LOGBOOK_RANGE: "Aangepast logboekbereik",
            CUSTOM: "Aangepast...",
            END_DATE: "Einddatum",
            LOGBOOK_GROUPBY: "Groeperen op:",
            PAST_TWELVE_MONTHS: "Afgelopen 12 maanden",
            PAST_SIX_MONTHS: "Afgelopen 6 maanden",
            FILTER_DOWNLOAD_TEXT: "Pas een filter toe om het logboek te downloaden.",
            LOGBOOK_SHOW: "Show :",
            SINCE_THE_BEGINNING_OF_YEAR: "Sinds begin van {{currentyear}}",
            START_DATE: "Startdatum",
            LOGBOOK_TIME_RANGE: "Tijdbereik:",
        },
        BUILDING_DETAILS: {
            ADD_BUILDING: "Voeg gebouw toe aan",
            ALL_SYSTEMS: "Alle systemen",
            VIEW_ALL_GATEWAYS: "Alle gateways weergeven",
        },
        ADD_ORGANIZATION: {
            ORG_ADD_DESCRIPTION: "Optionele extra opmerkingen toevoegen om uw serviceteam te helpen.",
            ADDITIONAL_DESC: "Aanvullende beschrijving",
            ORG_ADD_BLDG_BELONGS: "behoort.",
            CREATE_ORGANIZATION_TITLE: "Organisatie creëren",
            ORG_SUBTITLE: "Door een organisatie te creëren, kunt u gebouwen groeperen en het toezicht op EL Systems coördineren.",
            DETAILS_FOR: "Details voor",
            ORG_FOR: "voor",
            INVALID_CHARACTER: "Ongeldig karakter",
            ORG_NAMELENGTH: "Alleen letters, cijfers, onderstrepingstekens en streepjes",
            ORG_ADD_BLDG: "Laten we nu het gebouw toevoegen waar de",
            ORGANIZATION_CREATED: "Organisatie gecreëerd",
            VALID_EMAIL_ERROR: "Voer een geldig e-mailadres in",
            ORG_PRIMARYCONTACT: "Primaire contactpersoon",
            ORG_PROVIDED_DETAILS: "Geef details op voor het geval xxx nodig is.",
            ORG_SECONDARYCONTACT: "Secundair contact (optioneel)",
            ORG_SKIPBUTTON: "Voor nu overslaan",
            ORG_SKIPMESSAGE: "Overslaan om de contactgegevens voor elk gebouw afzonderlijk in te vullen.",
            ORG_SUCCESS: "Met succes aangemaakte organisatie",
            ALPHABET_INPUT: "Neemt alfabet als invoer",
            ALPHANUMERIC_INPUT: "Neemt alfanumeriek als invoer",
            ALPHANUMERIC_DASH_UNDERSCORE_INPUT: "Neemt alfanumeriek, streepje en onderstrepingsteken als invoer",
            ORG_HELPTEXT: "Hierdoor kunnen elektriciens van Eaton en anderen buiten uw bedrijf snel ter plaatse zijn.",
            ORGANIZATION_DETAILS: "Met wie moeten elektriciens contact opnemen?",
        },
        MANAGE_USERS: {
            ADVANCED_INVITE_USER_ORGANIZATION_SELECTION: "Toevoegen aan organisatie:",
            INVITE_USER_ORGANIZATION_LABEL: "Toevoegen aan organisatie... *",
            USER_ROLE_ADMIN: "Admin",
            ADVANCED_INVITE_ADMIN: "Admin",
            ADVANCED_INVITE: "Geavanceerde uitnodiging",
            INVITE_USER_ADVANCE: "Geavanceerd…",
            INVITE_USER_AS: "Als",
            ADVANCED_INVITE_USER_SELECTION: "Kies een nieuwe of bestaande gebruiker:",
            INVITE_USER_EMAIL_NAME: "E-mail *",
            INVITE_USER_EMAIL: "E-mail *",
            INVITE_USER_EMAIL_USER_NAME: "E-mail of gebruikersnaam *",
            INVITE_USER_SUBTITLE: "Toegang verlenen aan nieuwe of bestaande gebruikers",
            ADVANCED_INVITE_SUBTITLE: "Toegang verlenen tot specifieke organisaties, gebouwen en systemen.",
            ADVANCED_INVITE_ADMIN_DESCRIPTION: "volledige toegang verlenen tot alles binnen het toegewezen niveau.",
            ADVANCED_INVITE_LIMITED_DESCRIPTION: "Minimale kijkrechten toekennen zodat een gebruiker alleen basisinformatie ziet voor wat cruciaal is voor zijn rol. Dit is handig als iemand maar één systeem binnen een gebouw hoeft te monitoren.",
            ADVANCED_INVITE_VIEWER_DESCRIPTION: "geef kijkrechten voor alles binnen een toegewezen niveau.",
            INVITATION_FAIL_HEADER: "Uitnodiging verlopen",
            INVITE_USER_AS_COLLEAGUE: "Uitnodigen als collega",
            INVITE_USER: "Gebruiker uitnodigen",
            INVITE_SUCCESS_MESSAGE_SINGLE: "Uitgenodigd {{email}} voor {{organisatie}}.",
            INVITE_SUCCESS_MESSAGE_MULTIPLE: "Uitgenodigd {{email}} voor {{organizationCount}} organisaties.",
            USER_ROLE_LIMITED: "Beperkt",
            ADVANCED_INVITE_LIMITED: "Beperkt:",
            MY_DETAILS_HEADER: "Mijn gegevens",
            OTHER_USER_LIST_HEADER: "Andere gebruikers",
            ADVANCED_INVITE_PLEASE_ASSIGN_ROLES: "Wijs rollen toe voor {{email}} toegang tot organisaties, gebouwen en systemen.",
            REMOVE_USER: "Verwijder {{name}} uit { { title } } ?",
            INVITATION_REQUEST_ACTION: "Andere uitnodiging aanvragen",
            INVITE_USER_ORGANIZATION_SELECT_ALL: "Selecteer Alles",
            INVITE_USER_SEND_INVITE: "Uitnodiging verzenden",
            INVITATION_FAIL_BODY: "Deze e-mailuitnodigingslink is verlopen. Neem contact op met uw systeembeheerder voor een nieuwe e-mailuitnodiging.",
            USERS_IN_HEADER: "Gebruikers binnen",
            USER_ROLE_VIEWER: "Kijker",
            ADVANCED_INVITE_VIEWER: "Kijker:",
            INVITE_USER_DO_NOT_ASSIGN: "Op dit moment niet toewijzen",
        },
        ORGANIZATION_DETAILS: {
            ADDRESS: "Adres",
            BUILDING_DETAILS: "Gebouw details",
            DELETE_FOREVER: "Voor altijd verwijderen",
            EDIT_BUILDING: "Gebouw bewerken",
            EDIT_ORGANIZATION: "Organisatie bewerken",
            EMAIL_ADDRESS: "E-mailadres",
            MERGE_ASSETS: "Voeg activa samen met een ander gebouw",
            ORGANIZATION: "Organisatie",
            ORGANIZATION_DETAILS: "Organisatie details",
            PHONE_NUMBER: "Telefoonnummer",
            PRIMARY_CONTACT: "Primair contact",
            PRIMARY_CONTACT_EMAIL_ADDRESS: "E-mailadres van primaire contactpersoon",
            PRIMARY_CONTACT_PHONE_NUMBER: "Telefoonnummer van primaire contactpersoon",
            SECONDARY_CONTACT: "Secundair contact",
            SECONDARY_CONTACT_EMAIL_ADDRESS: "Secundair e-mailadres voor contactpersoon",
            SECONDARY_CONTACT_PHONE_NUMBER: "Secundair telefoonnummer",
            TRANSFER_BUILDINGS: "Gebouwen overdragen aan een andere organisatie",
            USERS: "Gebruikers",
        },
        COMMON_INPUT: {
            COMMON_ADDRESS: "Adres",
            COMMON_ADDRESSLINE2: "Adresregel 2 (optioneel)",
            COMMON_BUILDINGNAME: "Naam gebouw",
            COMMON_CITY: "Stad",
            COMMON_COUNTRY: "Land",
            COMMON_OPTIONALDESC: "Beschrijving (optioneel)",
            COMMON_EMAIL_ADDRESS: "E-mailadres",
            COMMON_NAME: "Organisatie naam",
            COMMON_PHONENUMBER: "Telefoonnummer",
            VALID_ADDRESS: "Voer een geldig adres in",
            VALID_PHONE_ERROR: "Voer een geldig telefoonnummer in",
            VALID_POSTAL_CODE: "Voer een geldige postcode in",
            VALID_FIRSTNAME_ERROR: "Voer een geldige voornaam in",
            VALID_LASTNAME_ERROR: "Voer een geldige achternaam in",
            VALID_VERIFICATION_CODE: "Voer een geldige verificatiecode in",
            COMMON_POSTALCODE: "Postcode",
            VALID_CITY_ERROR: "Voer een geldige stad in",
            VALID_COMPANY_ERROR: "Voer een geldig bedrijf in",
        },
        TOAST_MSG: {
            CREATE_CUSTOMER_ERROR_CODE_9069: "Adres is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 250 tekens",
            CREATE_CUSTOMER_ERROR_CODE_9070: "Adres2 is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 250 tekens",
            INVITE_TECHNICIAN_ERROR_CODE_9130: "Beheerdersrechten vereist om gebruiker uit te nodigen",
            INVITE_USER_ERROR_CODE_9130: "Beheerdersrechten vereist om gebruiker uit te nodigen.",
            TOAST_ERROR_MERGE_ASSET_9213: "Beheerdersrechten vereist om assets samen te voegen",
            TOAST_SUCCESS_BUILDING_CREATE: "Gebouw met succes gemaakt",
            BUILDING_LIST_API_FAILURE: "Gebouwvermelding mislukt",
            BUILDING_TRANSFER_FAILURE: "Er is een fout opgetreden bij de gebouwoverdracht",
            BUILDING_TRANSFER_SUCCESS: "De overdracht van gebouwen is succesvol verlopen",
            TOAST_SUCCESS_BUILDING_UPDATE: "Gebouw bijgewerkt",
            INVITE_USER_ERROR_CODE_9143: "Kan de gebruikersrol niet degraderen.",
            CREATE_CUSTOMER_ERROR_CODE_9072: "Plaats is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 50 tekens",
            CREATE_CUSTOMER_ERROR_CODE_9164: "Bedrijfscommentaar is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 255 tekens.",
            CREATE_CUSTOMER_ERROR_CODE_9040: "De landcode van het bedrijf is niet geldig",
            CREATE_CUSTOMER_ERROR_CODE_9170: "Bedrijfsnaam al beschikbaar.",
            CREATE_CUSTOMER_ERROR_CODE_9023: "Het telefoonnummer van het bedrijf is niet geldig of de lengte moet tussen 8 en 10 liggen",
            CREATE_CUSTOMER_ERROR_CODE_9073: "De landcode is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 4 tekens",
            CREATE_CUSTOMER_ERROR_CODE_9068: "Land is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 50 tekens",
            CREATE_MAINTAINANCE_API_FAILURE: "Onderhouds-API maken is mislukt",
            TOAST_SUCCESS_CUSTOMER_CREATED: "Klant is succesvol aangemaakt",
            CUSTOMER_DETAIL_SUCCESS: "Klantgegevens succesvol opgehaald",
            TOAST_ERROR_GET_CUSTOMER_INFO: "Ophalen van klantgegevens mislukt",
            CREATE_CUSTOMER_ERROR_CODE_9225: "Klantnummer al beschikbaar.",
            CREATE_CUSTOMER_ERROR_CODE_9172: "Klantnummer is niet geldig of de lengte moet tussen 8 en 16 tekens liggen.",
            CREATE_MAINTAINANCE_ERROR_CODE_9078: "Beschrijving is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 255 tekens",
            DEVICE_LIST_API_FAILURE: "Apparaatvermelding mislukt",
            ACKNOWLEDGE_LOG_SUCCESS: "Apparaatloggegevens zijn succesvol bevestigd",
            CREATE_CUSTOMER_ERROR_CODE_9043: "Het e-mailadres is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 75 tekens",
            INVITE_TECHNICIAN_ERROR_CODE_9043: "Het e-mailadres is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 75 tekens",
            INVITE_USER_ERROR_CODE_9043: "Het e-mailadres is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 75 tekens",
            INVITE_TECHNICIAN_ERROR_CODE_9136: "Entiteits- of roltype is geen geldige invoer of komt niet overeen tussen entiteitstype en roltype",
            INVITE_USER_ERROR_CODE_9136: "Entiteits- of roltype is geen geldige invoer of komt niet overeen tussen entiteitstype en roltype.",
            INVITE_TECHNICIAN_ERROR_CODE_9127: "EntityId is een dubbele of ongeldige invoer",
            INVITE_USER_ERROR_CODE_9127: "EntityId is een dubbele of ongeldige invoer",
            TOAST_ERROR_BUILDING_UPDATE: "Kan gebouwupdate niet uitvoeren",
            CREATE_MAINTAINANCE_ERROR_CODE_9219: "Bestandsnaam is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 50 tekens",
            TOAST_ERROR_GET_PASS_DETAILS: "API voor PAAS-details ophalen mislukt",
            REMOVE_ACCESS_ERROR_CODE_3057: "Ongeldige entiteits-ID. Geef een geldige entiteits-ID op",
            REMOVE_ACCESS_ERROR_CODE_3059: "Ongeldig entiteitstype. Geef een geldig entiteitstype op",
            TOAST_ERROR_LINK_CUSTOMER_9203: "Ongeldig SLA-TYPE Enum.",
            REMOVE_ACCESS_ERROR_CODE_2007: "Ongeldige gebruikers-ID. Geef een geldige GUID op",
            INVITE_TECHNICIAN_ERROR_CODE_9159: "Uitnodigen en uitgenodigd door gebruiker mogen niet hetzelfde zijn",
            INVITE_USER_ERROR_CODE_9159: "Uitnodigen en uitgenodigd door gebruiker mogen niet hetzelfde zijn",
            UPDATE_LOG_COMMENTS_SUCCESS: "Logboekopmerkingen zijn succesvol bijgewerkt",
            ACKNOWLEDGE_LOG_API_FAILURE: "Bevestiging van logboeken mislukt",
            CREATE_MAINTAINANCE_SUCCESS: "Onderhoudsactiviteit is succesvol aangemaakt",
            TOAST_ERROR_MERGE_ASSET_9214: "Geen activa om samen te voegen",
            CREATE_MAINTAINANCE_ERROR_CODE_9221: "Het aantal documenten moet kleiner dan of gelijk zijn aan 3",
            TOAST_SUCCESS_ORG_CREATE: "Organisatie succesvol aangemaakt",
            TOAST_ERROR_ORG_UPDATE: "Organisatie mislukt",
            TOAST_SUCCESS_ORG_UPDATE: "Organisatie succesvol bijgewerkt",
            CREATE_CUSTOMER_ERROR_CODE_9074: "Telefoonnummer is ongeldig of de lengte moet tussen 8 en 10 liggen.",
            TOAST_ERROR_MESSAGE: "Vul alle gegevens correct in voordat u deze verzendt",
            CREATE_MAINTAINANCE_ERROR_CODE_9220: "Geef een geldige 'AssignedTo'-gebruikers-ID voor de technicus op",
            TOAST_ERROR_MERGE_ASSET_9048: "Geef een geldig gebouw-ID op.",
            CREATE_CUSTOMER_ERROR_CODE_9167: "Geef een geldig contacttype op.",
            CREATE_MAINTAINANCE_ERROR_CODE_9185: "Geef een geldige klant-ID op",
            TOAST_ERROR_MERGE_ASSET_9210: "Geef een geldige ID van het bestemmingsgebouw op.",
            CREATE_MAINTAINANCE_ERROR_CODE_9217: "Geef een geldige link op",
            CREATE_CUSTOMER_ERROR_CODE_9163: "Geef een geldige naam op of de lengte moet kleiner zijn dan of gelijk zijn aan 24 tekens",
            CREATE_MAINTAINANCE_ERROR_CODE_9215: "Geef een geldig verzoektype op",
            CREATE_MAINTAINANCE_ERROR_CODE_9228: "Geef een geldige servicedatum op",
            CREATE_MAINTAINANCE_ERROR_CODE_9216: "Geef een geldig servicetype op",
            CREATE_MAINTAINANCE_ERROR_CODE_9050: "Geef een geldige systeem-ID op",
            CREATE_CUSTOMER_ERROR_CODE_9071: "De postcode is niet geldig of de lengte moet tussen 4 en 10 tekens liggen",
            CREATE_CUSTOMER_ERROR_CODE_9165: "Reactie van het primaire contact is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 255 tekens.",
            CREATE_CUSTOMER_ERROR_CODE_9175: "Primaire landcode2 is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 4 tekens",
            CREATE_CUSTOMER_ERROR_CODE_9150: "De primaire voornaam is niet geldig of de lengte moet tussen 1 en 50 tekens liggen",
            CREATE_CUSTOMER_ERROR_CODE_9151: "De primaire achternaam is niet geldig of de lengte moet tussen 1 en 50 tekens liggen",
            CREATE_CUSTOMER_ERROR_CODE_9173: "Primaire telefoon 2 is ongeldig of de lengte moet tussen 8 en 10 liggen.",
            REMOVE_ACCESS_SUCCESS: "Gebruiker verwijderen is succesvol voltooid",
            TOAST_ERROR_MERGE_ASSET_9004: "Opgevraagde gegevens niet gevonden",
            CREATE_CUSTOMER_ERROR_CODE_9166: "Secundaire contactopmerking is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 255 tekens.",
            CREATE_CUSTOMER_ERROR_CODE_9076: "De secundaire landcode is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 4 tekens",
            CREATE_CUSTOMER_ERROR_CODE_9176: "Secundaire landcode2 is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 4 tekens",
            CREATE_CUSTOMER_ERROR_CODE_9077: "Secundair e-mailadres is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 75 tekens",
            CREATE_CUSTOMER_ERROR_CODE_9152: "De secundaire voornaam is niet geldig of de lengte moet tussen 1 en 50 tekens liggen",
            CREATE_CUSTOMER_ERROR_CODE_9153: "De secundaire achternaam is niet geldig of de lengte moet tussen 1 en 50 tekens liggen",
            CREATE_CUSTOMER_ERROR_CODE_9147: "Secundair telefoonnummer is ongeldig of de lengte moet tussen 8 en 10 liggen.",
            CREATE_CUSTOMER_ERROR_CODE_9174: "Secundair telefoon2-nummer is ongeldig of de lengte moet tussen 8 en 10 liggen.",
            CREATE_MAINTAINANCE_ERROR_CODE_9009: "Beveiligingstoken mag niet null of leeg zijn",
            CREATE_MAINTAINANCE_ERROR_CODE_9222: "Service Manager-rechten zijn vereist om onderhoudsactiviteit te creëren",
            CREATE_MAINTAINANCE_ERROR_CODE_9162: "SLA-nummer is niet geldig of de lengte moet tussen 6 en 12 tekens liggen",
            INVITE_TECHNICIAN_ERROR_CODE_9158: "Sommige entiteiten hebben een beperkte rol in de rollen van Invitationby",
            INVITE_USER_ERROR_CODE_9158: "Sommige entiteiten hebben een beperkte rol in de rollen van Invitationby.",
            INVITE_TECHNICIAN_ERROR_CODE_9160: "Sommige entiteiten spelen een beperkte rol bij uitnodigingsverzoeken",
            INVITE_USER_ERROR_CODE_9160: "Sommige entiteiten spelen een beperkte rol bij uitnodigingsverzoeken.",
            TOAST_ERROR_MERGE_ASSET_9211: "De ID's van het bron- en bestemmingsgebouw zijn hetzelfde",
            TOAST_ERROR_MERGE_ASSET_9212: "Brongebouw en bestemmingsgebouw vallen niet onder dezelfde organisatie",
            TOAST_ERROR_LINK_CUSTOMER_9204: "Systeem al gekoppeld aan geldige SLA",
            INVITE_USER_ERROR_CODE_9223: "De huidige gebruiker kan alleen een uitnodiging sturen naar een normale gebruiker.",
            INVITE_USER_ERROR_CODE_9224: "De huidige gebruiker kan geen uitnodiging sturen naar Servicemanager en PAAS Maanger.",
            CREATE_MAINTAINANCE_ERROR_CODE_9218: "Het document is groter dan 2 MB of is een dubbele of ongeldige Base64-gecodeerde PDF, JPEG of PNG",
            REMOVE_ACCESS_ERROR_CODE_9001: "Ongeautoriseerde toegang",
            CREATE_CUSTOMER_ERROR_CODE_9001: "Ongeautoriseerde toegang",
            CREATE_MAINTAINANCE_ERROR_CODE_9001: "Ongeautoriseerde toegang",
            CREATE_CUSTOMER_ERROR_CODE_9000: "Ongeautoriseerde toegang tot functies",
            UPDATE_LOG_COMMENTS_API_FAILURE: "Update logopmerkingen mislukt",
            REMOVE_ACCESS_ERROR_CODE_3060: "Gebruiker kan zelftoegang niet verwijderen",
            TOAST_ERROR_UPDATE_USER_DETAILS: "Update van gebruikersgegevens mislukt",
            INVITE_USER_ERROR_CODE_9142: "Gebruiker is uitgenodigd voor dezelfde rol.",
            INVITE_TECHNICIAN_SUCCESS: "Gebruikersuitnodiging Succesvol verzonden",
            TOAST_ERROR_MERGE_ASSET_9044: "Het gebruikerswachtwoord is niet geldig of de lengte moet tussen 8 en 16 tekens liggen",
            INVITE_TECHNICIAN_ERROR_CODE_9190: "Type gebruikersrol is geen geldige invoer",
            INVITE_USER_ERROR_CODE_9190: "Type gebruikersrol is geen geldige invoer.",
            TOAST_SUCCESS_UPDATE_USER_DETAILS: "Gebruiker is succesvol bijgewerkt",
            UPDATE_MAINTAINANCE_SUCCESS: "Onderhoudsactiviteit is bijgewerkt",
            UPDATE_MAINTAINANCE_ERROR_CODE_9001: "Ongeautoriseerde toegang",
            UPDATE_MAINTAINANCE_ERROR_CODE_9009: "Beveiligingstoken mag niet null of leeg zijn",
            UPDATE_MAINTAINANCE_ERROR_CODE_9078: "Beschrijving is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 255 tekens.",
            UPDATE_MAINTAINANCE_ERROR_CODE_9222: "Om deze bewerking uit te voeren zijn Service Manager- of Technicus-rechten vereist",
            UPDATE_MAINTAINANCE_ERROR_CODE_9227: "Geef een geldige onderhouds-ID op",
            UPDATE_MAINTAINANCE_ERROR_CODE_9245: "Onderhoudsactiviteit heeft al dezelfde huidige ticketstatus als gevraagd voor update",
            UPDATE_MAINTAINANCE_ERROR_CODE_9246: "Heropeningslimiet voor onderhoudsactiviteiten bereikt",
            UPDATE_MAINTAINANCE_API_FAILURE: "Updateonderhoud-API mislukt",
            TICKET_CLOSED_SUCCESS: "Serviceticket succesvol afgesloten",
        },
        MY_ORGANIZATION_DETAILS: {
            ADDRESS_Line1: "Adresregel 1",
            ADMINS: "Beheerders",
            DELETE_FOREVER: "Voor altijd verwijderen",
            DESCRIPTION: "Beschrijving (optioneel)",
            EDIT_BUILDING: "Bewerk gebouw",
            EDIT_ORGANIZATION: "Organisatie bewerken",
            NAME_DESCRIPTION: "Naam & Beschrijving",
            SAVE_ORGANIZATION: "Organisatie opslaan",
            TRANSFER_BULDING_ANOTHER_ORGANIZATION: "Gebouwen overdragen aan een andere organisatie",
            VIEWER: "Viewers",
        },
        INVITE_USER: {
            ADMIN: "Admin",
            ADVANCE_INVITATION: "Geavanceerde uitnodiging",
            ADVANCE_INVITE: "Geavanceerd...",
            ADVANCE_INVITE_CLOSE: "Weet je zeker dat je de geavanceerde uitnodiging wilt afsluiten?",
            AS_ADMIN: "Als beheerder",
            AS_VIEWER: "Als Viewer",
            BUILDING_ACCESS: "Toegang tot gebouwen",
            ENTER_USER_EMAIL: "E-mail of gebruikersnaam",
            GRANT_ACCESS_HEADER: "Toegang verlenen aan nieuwe of bestaande gebruikers.",
            ADVANCE_DES_CONTENT: "Toegang verlenen aan gebruikers voor specifieke toegang tot organisaties, gebouwen en systemen.",
            GRANT_ADMIN_ACCESS: "Verleen volledige toegang tot alles binnen het toegewezen niveau.",
            GRANT_VIEW_ACCESS: "Verleen kijkrechten voor alles binnen een toegewezen niveau.",
            SEND_INVITE_FAILURE: "Uitnodiging verzonden mislukt",
            SEND_INVITE_SUCCESS: "Uitnodiging succesvol verzonden",
            INVITATION_ACCEPTED: "Uitnodiging succesvol geaccepteerd.",
            INVITATION_DENIED: "Uitnodiging succesvol afgewezen.",
            INVITE_AND_ASSIGN: "Uitnodigen en toewijzen",
            INVITE_AS_COLLEGUE: "Uitnodigen als collega",
            INVITE_USER: "Gebruiker uitnodigen",
            LIMITED: "Beperkt",
            GRANT_LIMITED_ACCESS: "Minimale rechten, dit is handig voor een gebruiker die slechts één systeem binnen een gebouw hoeft te monitoren.",
            NOBUILDING_AVAILABLE: "Geen gebouwen beschikbaar",
            NOSYSTEMS_AVAILABLE: "Geen systemen beschikbaar",
            ORGANIZATION_ACCESS: "Toegang tot organisatie",
            SELECT_ORGANIZATION: "Selecteer een organisatie",
            PRIVILEGES: "Voorrechten",
            RECEIVED: "Ontvangen",
            SEND_INVITE: "Uitnodiging verzenden",
            SENT_BY: "Verzonden door",
            SYSTEM_ACCESS: "Systeemtoegang",
            VIEWER: "Kijker",
            ERROR_MESSAGE: "Uw verzoek is mislukt",
        },
        DISCLAMIER: {
            OVERVIEW: "Alarmtelling vertegenwoordigt alle actieve alarmen",
            TIMELINE: "De weergegeven alarmen vertegenwoordigen alle alarmen van de afgelopen 90 dagen",
        },
        LUMINARY_DETAILS: {
            ALL_ATSD: "Alle ATSD",
            ALL_CIRCUIT: "Alle circuits",
            ALL_STATUSES: "Alle statussen",
            ATSD: "ATSD #",
            CIRCUIT: "Circuit",
            LUMINAIRE_ADDRESS: "Armatuur adres",
            MODEL: "Model",
            TYPE: "Type",
        },
        SEARCH: {
            ALL_BUILDINGS: "Alle gebouwen",
            ALL_GATEWAYS: "Alle gateways",
            ALL_ORGANIZATIONS: "Alle organisaties",
            ALL_STATUSES: "Alle statussen",
            ALL_SYSTEMS: "Alle systemen",
            ALL_TYPES: "Alle soorten",
            ALL_CUSTOMER: "Alle klanten",
            ALL_SLA: "Alle SLA's",
            ALL_CITY: "Alle steden",
            ALL_ZIPCODE: "Alle postcodes",
            ALL_SERVICE_TYPES: "Alle servicetypen",
            ALL_PLATFORMS: "Alle platforms",
            ALL_COMPANY: 'Alle bedrijven',
            ALL_COUNTRY: 'Alle landen',
            ALL_PANELS: 'Alle panelen',
            ALL_INPUT_ZONES: 'Alle invoerzones',
            ALL_MODULES: 'Alle Modules',
        },
        NAVIGATION_DRAWER: {
            ALL_RIGHTS_RESERVED: "Alle rechten voorbehouden",
            CHANGE_PASSWORD: "Wachtwoord wijzigen",
            ACCOUNT_PREFERENCES: "Account voorkeuren",
            COPYRIGHT: "Copyright",
            HELP_AND_FEEDBACK: "Hulp en feedback",
            LEGAL: "Juridisch",
            LOGOUT: "Uitloggen",
            PROJECT_SETTINGS: "Mijn organisaties",
            REPORTS: "Rapporten",
            USERS: "Gebruikers",
        },
        CUSTOMER_DETAILS: {
            ALL_USERS: "Alle gebruikers",
            DELETE_SLA: "Weet u zeker dat u SLA wilt verwijderen",
            BACK_UP_PHONE: "Telefoon back-up",
            BUYER_HEADER: "Koper",
            BUYER: "Koper",
            CONTACT_TYPE: "Contacttype",
            CONTACT_PERSON_ON_SITE: "ContactPersoonPlaats",
            CUSTOMER_HEADER_SUBTITLE: "Klant",
            CUSTOMER_ID: "Klant-ID",
            CUSTOMER_NAME: "Klant Naam",
            CUSTOMER_DETAILS_HEADER: "Klantnaam en adres",
            CUSTOMER_NAME_LABEL: "Naam of nummer van de klant",
            CUSTOMER_NUMBER: "Klantnummer",
            DELETE_CUSTOMER: "Klant verwijderen",
            LUMINARY_INFO: "Omvat dit contract armatuurmonitoring?",
            EDIT_CUSTOMER_INFO: "Klantinformatie bewerken",
            CREATE_CUSTOMER_HEADER: "Klantinformatie bewerken",
            EDIT_PLATFORM_INFO: "Bewerk platform",
            EDIT_SLA_DETAILS: "SLA-details bewerken",
            EXPIRES: "Verloopt",
            IMAGES: "Images",
            INCLUDE_LUM_MONITORING: "Inclusief armatuurmonitoring",
            SLA_DETAILS_TEXT: "Armatuurbewaking inbegrepen",
            CALENDAR_HELPER_TEXT: "mm/dd/jjjj",
            MOBILE_NUMBER: "Mobiel nummer",
            LUMINARY_MONITORING_NO: "Geen",
            NO_CUSTOMER_FOUND: "Geen klant gevonden",
            NO_SERVICE_MANAGER_FOUND: "Geen service manager gevonden",
            NO_TECHNICIAN_FOUND: "Geen technicus gevonden",
            CUSTOMER_NUMBER_HELPER_TEXT: "Alleen alfabetten en cijfers",
            SLA_NUMBER_HELPER_TEXT: "Alleen alfabetten en cijfers",
            OFFICE_NUMBER: "Kantoornummer",
            IMAGE_REQUIREMENTS: "PNG, JPG (100x100px), 2 MB Max.",
            PHONE_NUMBERS_HEADER: "Primaire en back-up telefoonnummers",
            PRIMARY_CONTACT_INFO: "Primaire contactgegevens",
            PROJECT_LEAD: "Projectleider",
            REMOVE_IMAGE: "Afbeelding verwijderen",
            SECONDARY_CONTACT_INFO: "Info secundaire contactpersoon",
            FILE_RESOLUTION_ERROR: "Geselecteerd bestand komt niet overeen met de door ons gewenste resolutie",
            FILE_SIZE_ERROR: "Geselecteerde bestandsgrootte overschrijdt maxFileSize",
            SERVICE_MANAGER: "Servicemanager",
            SLA_CUSTOMER_NUMBER: "SLA-klantnummer",
            SLA_DETAILS_HEADER: "SLA-details",
            SLA_EXPIRATION_DATE: "SLA-vervaldatum",
            TECH_LEAD_HEADER: "Technische leiding",
            TECHNICAL_PERSON: "TechnischPersoon",
            UPLOAD_AVATAR_LOGO: "Avatar-logo uploaden",
            LUMINARY_MONITORING_YES: "Ja",
            CREATE_CUSTOMER: "Klant aanmaken",
            SLA_MANAGEMENT_HEADER: "SLA-beheer",
            SLA_NUMBER: 'SLA Nummer',
        },
        USER_MANAGEMENT: {
            ALL_USERS: "Alle gebruikers",
            INVITE_USER: "Gebruiker uitnodigen",
            YOUR_DETAILS: "Uw gegevens",
        },
        USERDETAILS: {
            DELETE_USER_SUBHEADER: "Al je gebruikersgegevens zullen permanent verloren gaan.",
            RESET_PASSWORD_ERROR: "Uw wachtwoord kon momenteel niet opnieuw worden ingesteld.",
            DELETE_USER_BUTTON_TEXT: "Account voor altijd verwijderen",
            DELETE_USER_FAILURE_MSG: "Wissen mislukt, probeer het na enige tijd opnieuw",
            DELETE_USER_POP_UP_HEADER: "Account “{{email}}” definitief verwijderen?",
            RESET_PASSWORD_SUCCESS: "Reset wachtwoord e-mail succesvol verzonden.",
            EDIT_SUCCESS: "Gebruiker is succesvol bijgewerkt",
            DELETE_USER_SUCCESS_MSG: "Uw account is succesvol verwijderd",
        },
        ATPLUS_LOGBOOK_EVENTNAME: {
            MAXIMUM_LOGIN_ATTEMPTS_EXCEDDED: "Toegestane inlogpogingen overschreden",
            BATTERY_CHARGE_FAILURE: "Fout in acculading gedetecteerd",
            BATTERY_DURATION_FAILURE: "Fout in duur batterij gedetecteerd",
            TLAT_PLUS_BATTERY_FAILURE: "Batterij defect",
            TLAT_PLUS_BATTERY_LOW: "Batterij bijna leeg",
            COMMUNICATION_FAILURE: "Communicatiestoring gedetecteerd",
            DRY_CONTACT_INPUT: "Ingang Droog Contact Geactiveerd",
            DRY_CONTACT_OUTPUT: "Droog-contact uitgang geactiveerd",
            MANUAL_DURATION_TEST: "Duur Test Gestart",
            MANUAL_DURATION_TEST_CANCELED: "Duur Test Gestopt",
            FACTORY_RESET: "Fabrieksreset",
            FAILURE_THRESHOLD_EXCEEDED: "Drempel voor mislukking overschreden",
            FIRMWARE_UPDATE_FAILURE: "Firmware-update mislukt",
            FIRMWARE_UPDATE_SUCCESS: "Firmware-update geslaagd",
            MANUAL_FUNCTION_TEST: "Functietest gestart",
            MODBUS_COMMUNICATION_FAILURE: "Gateway-communicatiefout",
            UART_COMMUNICATION_FAILURE: "Interne mislukking",
            LAMP_FAILURE: "Lampstoring gedetecteerd",
            LOCAL_MAIN_FAILURE: "Lokale netstoring",
            PASSWORD_CHANGE: "Wachtwoord wijzigen",
            PASSWORD_RESET: "Wachtwoord opnieuw instellen",
            MANUAL_RELIGHT_COMMAND: "Opnieuw aansteken geactiveerd",
            MANUAL_REST_COMMAND: "Rust geactiveerd",
            SEARCH_ALL_LAMP_COMPLETED: "Zoek alle lampen voltooid",
            SEARCH_NEW_LAMP_COMPLETED: "Nieuwe lamp zoeken voltooid",
            MANUAL_SYNCHRONIZE_TEST_TIME_COMMAND: "Testtijden synchroniseren",
            ACTIVATION: "Systeem activering voltooid",
            SYSTEM_POWER_DOWN: "Systeem uitgeschakeld",
            SYSTEM_POWER_UP: "Systeem ingeschakeld",
            DATALINE_FAILURE: "TLAT+ communicatielijnstoring",
            MANUAL_START_VISIBILITY_PLUS: "Zichtbaarheid + Gestart",
            MANUAL_STOP_VISIBILITY_PLUS: "Zichtbaarheid + Gestopt",
        },
        MY_ORGANIZATION: {
            ALPHABET: "Alfabet",
            CITY: "Stad",
            NUMBER_SYSTEM: "Aantal systemen",
        },
        FIRMWARE_UPDATE: {
            FIRMWARE_UPDATE_ALERT_TITILE: "Weet je zeker dat je Afsluiten wilt?",
            CURRENT_VERSION: "Huidige versie",
            FIRMWARE_ALREADY_UPDATED: "Firmware reeds bijgewerkt",
            FIRMWARE_UPDATE_FAILED_TITLE: "Firmware-update mislukt",
            FIRMWARE_PROGRESS_MSG: "Firmware-update wordt uitgevoerd...",
            FIRMWARE_UPDATE_ALERT_SUB_TITILE: "Firmware-updateproces is mislukt. Probeer het opnieuw.",
            FIRMWARE_UPDATE_FAILED: "Firmware-updateproces is mislukt. Probeer het opnieuw.",
            FIRMWARE_VERSION_UPDATED: "firmware-upgrade is succesvol voltooid",
            FIRMWARE_ALREADY_UPDATED_TEXT: "Firmwareversie is al bijgewerkt naar de nieuwste versie",
            FIRMWARE_NOT_AVAILABLE: "Firmwareversie niet correct opgehaald. Meld u af bij de mobiele app en log in om het opnieuw te proberen.",
            LATEST_VERSION: "Laatste versie",
            LOST_BLUETOOTH_CONNECTION: "Verloren Bluetooth-verbinding",
            ENTRY_PASSWORD: "Voer het systeemwachtwoord in voor",
            RELEASED_ON: "Vrijgegeven op",
            SELECT_FIRMWARE_VERSION: "Selecteer een firmwareversie",
            SELECT_A_VERSION: "Selecteer een versie",
            UPDATE_TO_LATEST: "Update naar nieuwste",
            UPLOAD_FILE: "Bestand uploaden",
            FIRMWARE_UPDATE_TITILE: "Wij raden u aan te updatende firmware naar de nieuwste versie.",
            FIRMWARE_UPDATEPOPUP_MSG: "U bent niet langer verbonden met de",
        },
        ASSETS: {
            ASSETS_DETAILS: "Details activa",
        },
        SYSTEM_TYPE: {
            ATPLUS: "AT+",
            CGLINE: "CGLine+",
            DGS: "DG-S",
            LPSMART: "LPSmart",
            LPSTAR: "LPStar",
            WIRELESS: "Draadloze",
            ZBS: "ZBS",
        },
        DEVICE_TYPE_VALUE: {
            AT: "AT+",
            ATS: "AT-S+",
            CGLINE: "CGLINE",
            DGS: "DG-S",
            LPSMART: "LP-SMART",
            LPSTAR: "LP-STAR",
            WIRELESS: "DRAADLOZE",
            ZBS: "ZB-S",
        },
        CONTROLLER_TYPE_VALUE: {
            AT: "AT+",
            CGLINE_PLUS: "CGLINE+",
            DGS: "DG-S",
            LP_SMART: "LP-SMART",
            LP_STAR: "LP-STAR",
            WIRELESS: "DRAADLOZE",
            ZBS: "ZBS",
        },
        ACTIONS: {
            BACK: "Terug",
            CANCEL: "Annuleren",
            CHANGE_LANGUAGE: "Wijzig hier de taal!",
            CLICK_BUTTON: "Klik op de knop",
            UPDATE_REDUX: "Klik op de knop om de redux winkelwaarde bij te werken!",
            CONFIRM: "Bevestigen",
            CONTINUE: "Doorgaan",
            DELETE: "Verwijderen",
            RESEND_VERIFICATION_EMAIL_LABEL: "Geen e-mail ontvangen?",
            DISABLE: "Uitschakelen",
            DONE: "Gedaan",
            DOWNLOAD_DATA: "Gegevens downloaden",
            EDIT: "Bewerken",
            ENABLE: "Inschakelen",
            EXTEND: "Uitbreiden",
            FINISH: "Voltooien",
            GO_HOME: "Ga naar Home",
            GO_TO_DASHBOARD: "Ga naar Mijn Dashboard",
            GO_TEST: "Ga naar de testpagina",
            LOG_IN: "Aanmelden",
            LOG_OUT: "Afmelden",
            NEXT: "Volgende",
            OKAY: "OK",
            QUIT: "Afsluiten",
            REMEMBER: "Onthoud mij",
            RETRY: "Opnieuw proberen",
            SAVE: "Opslaan",
            SAVE_ADD_ANOTHER: "Opslaan en een andere toevoegen",
            SEND: "Versturen",
            RESEND: "Opnieuw verzenden",
            RESEND_VERIFICATION_EMAIL: "Opnieuw verzenden",
            SUBMIT: "Indienen",
            SUBMITCHANGES: "Wijzigingen indienen",
            TRANSFER: "Overdracht",
            UPDATE: "Bijwerken",
            LINK_SYSTEM: 'Link-systeem',
        },
        NETWORK: {
            BAD_REQUEST_MESSAGE: "Slechte aanvraag",
            INTERNAL_SERVER_ERROR_MESSAGE: "Interne serverfout",
            NO_DATA_FOUND: "Geen gegevens gevonden",
            REQUEST_NOT_FOUND_MESSAGE: "Niet gevonden",
            ERROR_INTERNET_CONNECTION: "Het lijkt erop dat je geen internetverbinding hebt. Probeer het opnieuw.",
            SERVICE_UNAVAILABLE: "Service niet beschikbaar",
            ERROR_NO_RESPONSE: "Er is iets misgegaan",
            ERROR_MESSAGE_SENDING_REQUEST: "Sorry, er is een probleem opgetreden bij het verzenden van uw verzoek.",
            ERROR_INVALID_REQUEST: "Sorry, uw verzoek is ongeldig.",
            NETWORK_ALERT_SUBTITILE: "Het dashboard is niet beschikbaar omdat je geen verbinding meer hebt naar internet",
            ERROR_NOT_FOUND: "De bron is niet gevonden.",
            ERROR_ALERT_TITLTE: "Kan Dashboard niet verbinden",
            UNAUTHORISED_REQUEST_MESSAGE: "Ongeautoriseerd - Autorisatie is geweigerd voor dit verzoek",
            ERROR_RESTRICTED_USER_ACCESS: "Gebruiker heeft geen toegang tot de bron.",
        },
        CONNECTION_TYPE_VALUE: {
            BLE: "BLE",
            BLUETOOTH: "Bluetooth",
            CELLULAR: "Mobiel",
            ETHERNET: "Ethernet",
            MODBUS: "Modbus",
            MQTT: "MQTT",
            RS485: "RS485",
            WIFI: "Wifi",
            WIREPAS: "Draadpas",
        },
        STATUS: {
            STATUS_BLOCK: "Geblokkeerd",
            BLOCKED: "Geblokkeerd",
            STATUS_EMPTY: "Leeg",
            STATUS_ERROR: "Fout",
            ERROR: "Fout",
            EVENT: "Gebeurtenis",
            DT: "In DT",
            STATUS_DT: "Op proef",
            INTEST: "Op proef",
            STATUS_OFFLINE: "Offline",
            STATUS_READY: "Gereed",
            READY: "Gereed",
            TOTAL_LUMINAIRES: "Totaal armaturen",
            TOTAL_SYSTEM: "Totaal systemen",
            STATUS_WARNING: "Warning",
            WARNING: "Warning",
            STATUS_FAILURE: "Bij mislukking",
        },
        UNSUPPORTED_BROWSER: {
            NOT_SUPPORTED: "Browser niet ondersteund",
            INCOMPATIBLE_BROWSER: "Deze webapplicatie is niet compatibel met uw huidige browser.",
            RECOMMENDED_BROWSER: "We raden aan om te upgraden naar de nieuwste versie van Microsoft Edge, Safari, Firefox of Chrome om deze tool te gebruiken.",
        },
        ENTITY_TYPE: {
            BUILDING: "Gebouw",
            DEVICE: "Apparaat",
            DEVICE_TYPE: "Apparaat type",
            GATEWAY: "Gateway",
            LUMINARY: "Lichtgevend",
            MASTER_ROLE: "Meesterrol",
            ORGANIZATION: "Organisatie",
            ORGANIZATION_STATISTIC_DETAIL: "Statistische details van de organisatie",
            PLATFORM: "Platform",
            SYSTEM: "Systeem",
            USER: "Gebruiker",
        },
        LOGSOURSE_DEVICE_TYPE: {
            BUILDING: "Gebouw",
            DEVICE: "Apparaat",
            DEVICETYPE: "Apparaattype",
            GATEWAY: "Gateway",
            LUMINARY: "Lichtgevend",
            MASTERROLE: "Meesterrol",
            ORGANIZATION: "Organisatie",
            ORGANIZATIONSTATISTICALDETAIL: "OrganisatieStatistischeDetail",
            SYSTEM: "Systeem",
            USER: "Gebruiker",
        },
        TECHNICIAN_DETAILS: {
            BUILD_ADMIN: "Gebouw Beheerder",
            BUILD_VIEWER: "Gebouw viewer",
            CUST_VIEWER: "Klantkijker",
            INDIVIDUAL_DETAILS: "Individuele details",
            LIMT_ACCESS: "Beperkte toegang",
            ORG_ADMIN: "Organisatie beheerder",
            ORG_VIEWER: "Organisatieviewer",
            PASS_SERVICE_MANAGER: "Service Manager doorgeven",
            PROJ_OWNER: "Projecteigenaar",
            SERVICE_MANAGER: "Servicemanager",
            SYSTM_ADMIN: "Systeembeheerder",
            SYSTM_VIEWER: "Systeemviewer",
            TECHNICIAN: "Technicus",
            USER_DETAILS: "Gebruikersgegevens",
            COMPANY_DETAILS: "Bedrijfsgegevens",
            COMPANY: "Bedrijf",
        },
        TRANSFER_BUILDING_TO_ORGANIZATION: {
            TRANSFER_SUCCESS: "Gebouw succesvol overgedragen aan andere organisatie",
            CONFIRM_PASSWORD: "Bevestig wachtwoord",
            INSTRUCTIONS: "Draag permanent alle {{buildingCount}} gebouwen over, inclusief alle {{systemCount}} gateways en {{gatewayCount}} systemen.",
            ORG_SELECT: "Selecteer een geldige organisatie",
            INSTRUCTION_TWO: "Typ het wachtwoord van uw organisatiebeheerdersaccount om de actie te bevestigen",
            TRANSFER: "Overdracht",
            HEADER_TITLE: "Gebouw overdragen naar een andere organisatie \n \n Organisatie",
            DROPDOWN_LABEL: "Overbrengen naar...",
        },
        CHANGE_PASSWORD_SCREEN: {
            CHANGE_PASSWORD: "Wachtwoord wijzigen",
            CONFIRM_PASSWORD: "Bevestig wachtwoord",
            NEW_PASSWORD: "Nieuw wachtwoord",
        },
        MESSAGES: {
            CONGRATS: "Gefeliciteerd!",
            CONTACT: "Neem contact op met een Eaton ondersteuningsvertegenwoordiger",
            EMAIL_SENT: "E-mail verzonden",
            ERROR: "Fout!",
            FAILURE: "Fout!",
            LOADING: "Laden...",
            EMAIL_ENTRY_ERROR: "Voer een geldig e-mailadres in",
            SUCCESS: "Succes",
            WELCOME: "Welkom!",
            LOGIN_MESSAGE: "U bent 'ingelogd'",
        },
        LANDING_SCREEN: {
            CONNECT_NOW: "Nu verbinding maken",
            CONNECT_TO_SYSTEM: "Verbinden met systemen",
            CONTINUE_TO_DASHBOARD: "Ga verder naar Dashboard",
            DASHBOARD_UNAVAILABLE: "Dashboard niet beschikbaar",
            NO_INTERNET_CONNECTION: "Geen internetverbinding",
            VIEW_DASHBOARD: "Dashboard bekijken",
            IN_PROGRESS: "Werk in uitvoering...",
        },
        USERS: {
            CREATE_NEW_CUSTOMER: "Nieuwe klant aanmaken",
            EDIT_PLATFORM_HEADER: "Platform bewerken",
            EDIT_PLATFORM_SUCCESS_200: "Platform succesvol bijgewerkt",
            LOADER_HELPER_TEXT: "Wacht alstublieft",
            MANAGE_PLATFORM_ERROR_CODE_3047: "Main Service Manager is niet geregistreerd op BSMS. Kan geen platform creëren",
            LOCATION: "Locatie",
            SLA_MANDATORY_HEADER: "SLA",
            ADD_TECHNICIAN_TITLE: "Voeg een technicus toe",
            STEP1: "Stap 1",
            STEP1_TEXT: "Kies of voeg een gebruiker toe en wijs deze toe aan specifieke organisaties",
            STEP2: "Stap 2",
            ERROR_NO_TECHNICIAN_FOUND: "Geen technicus gevonden",
            PAAS: "PAAS",
            SERVICE_PARTNERS: "Servicepartners",
            ADD_SERVICE_MANAGER_SUCCESS_200: "Service Manager succesvol toegevoegd",
            ERROR_NO_SERVICE_MANAGER_FOUND: "Geen servicemanager gevonden",
            ERROR_NO_SERVICE_PARTNER_FOUND: "Geen servicepartner gevonden",
            ADD_SERVICE_MANAGER_ERROR_CODE_9043: "Het e-mailadres is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 75 tekens",
            ADD_SERVICE_MANAGER_ERROR_CODE_3051: "De gebruiker met het opgegeven e-mailadres is niet geregistreerd in het systeem",
            ADD_SERVICE_MANAGER_ERROR_CODE_3050: "Geef een geldige platform-ID op",
            ADD_SERVICE_MANAGER_ERROR_CODE_9000: "Ongeautoriseerde toegang tot functies",
            ADD_SERVICE_MANAGER_ERROR_CODE_3052: "De gebruiker met het opgegeven e-mailadres is al geregistreerd in het systeem",
            ADD_PAAS_MANAGER_ERROR_CODE_9162: "SLA-nummer is niet geldig of de lengte moet tussen 6 en 12 tekens liggen.",
            ADD_PAAS_MANAGER_ERROR_CODE_9169: "De vervaldatum heeft geen geldig formaat of moet groter zijn dan de huidige datum.",
            ADD_PAAS_MANAGER_ERROR_CODE_9163: "Geef een geldige naam op of de lengte moet kleiner zijn dan of gelijk zijn aan 24 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9068: "Land is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 50 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9069: "Adres is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 250 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9070: "Adres2 is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 250 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9071: "De postcode is niet geldig of de lengte moet tussen 4 en 10 tekens liggen",
            ADD_PAAS_MANAGER_ERROR_CODE_9072: "Plaats is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 50 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9164: "Bedrijfscommentaar is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 255 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9043: "Het e-mailadres is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 75 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9073: "De landcode is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 4 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9074: "Telefoonnummer is niet geldig of de lengte moet tussen 8 en 10 tekens liggen",
            ADD_PAAS_MANAGER_ERROR_CODE_9167: "Geef een geldig contacttype op.",
            ADD_PAAS_MANAGER_ERROR_CODE_9077: "Secundair e-mailadres is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 75 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9147: "Secundair telefoonnummer is ongeldig of de lengte moet tussen 8 en 10 liggen.",
            ADD_PAAS_MANAGER_ERROR_CODE_9076: "De secundaire landcode is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 4 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9001: "Ongeautoriseerde toegang",
            ADD_PAAS_MANAGER_ERROR_CODE_9170: "Bedrijfsnaam al beschikbaar.",
            ADD_PAAS_MANAGER_ERROR_CODE_9171: "SLA-nummer al beschikbaar.",
            ADD_PAAS_MANAGER_ERROR_CODE_9150: "De primaire voornaam is niet geldig of de lengte moet tussen 1 en 50 tekens liggen",
            ADD_PAAS_MANAGER_ERROR_CODE_9151: "De primaire achternaam is niet geldig of de lengte moet tussen 1 en 50 tekens liggen'",
            ADD_PAAS_MANAGER_ERROR_CODE_9152: "De secundaire voornaam is niet geldig of de lengte moet tussen 1 en 50 tekens liggen",
            ADD_PAAS_MANAGER_ERROR_CODE_9153: "De secundaire achternaam is niet geldig of de lengte moet tussen 1 en 50 tekens liggen",
            ADD_PAAS_MANAGER_ERROR_CODE_9165: "Reactie van het primaire contact is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 255 tekens.",
            ADD_PAAS_MANAGER_ERROR_CODE_9166: "Secundaire contactopmerking is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 255 tekens.",
            ADD_PAAS_MANAGER_ERROR_CODE_9004: "Systeemdetails niet gevonden.",
            ADD_PAAS_MANAGER_ERROR_CODE_9050: "Geef een geldige systeem-ID op.",
            ADD_PAAS_MANAGER_ERROR_CODE_9172: "Klantnummer is niet geldig of de lengte moet tussen 8 en 16 tekens liggen.",
            ADD_PAAS_MANAGER_ERROR_CODE_9173: "Primaire telefoon 2 is ongeldig of de lengte moet tussen 8 en 10 liggen.",
            ADD_PAAS_MANAGER_ERROR_CODE_9174: "Secundair telefoon2-nummer is ongeldig of de lengte moet tussen 8 en 10 liggen.",
            ADD_PAAS_MANAGER_ERROR_CODE_9175: "Primaire landcode2 is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 4 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9176: "Secundaire landcode2 is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 4 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9040: "De landcode van het bedrijf is niet geldig",
            ADD_PAAS_MANAGER_ERROR_CODE_9023: "Het telefoonnummer van het bedrijf is niet geldig of de lengte moet tussen 8 en 10 liggen",
            ADD_PAAS_MANAGER_ERROR_CODE_9193: "Het e-mailadres van de servicemanager is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 75 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9194: "De voornaam van de servicemanager is niet geldig of de lengte moet tussen 1 en 50 tekens liggen",
            ADD_PAAS_MANAGER_ERROR_CODE_9195: "De achternaam van de servicemanager is niet geldig of de lengte moet tussen 1 en 50 tekens liggen",
            ADD_PAAS_MANAGER_ERROR_CODE_9196: "De primaire landcode van Service Manager is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 4 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9197: "Het primaire telefoonnummer van de servicemanager is niet geldig of de lengte moet tussen 8 en 10 liggen",
            ADD_PAAS_MANAGER_ERROR_CODE_9198: "De secundaire landcode van Service Manager is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 4 tekens",
            ADD_PAAS_MANAGER_ERROR_CODE_9199: "Het secundaire telefoonnummer van de servicemanager is niet geldig of de lengte moet tussen 8 en 10 liggen",
            ADD_PAAS_MANAGER_ERROR_CODE_9201: "Service Manager-opmerking is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 255 tekens.",
            ADD_PAAS_MANAGER_ERROR_CODE_9000: "Ongeautoriseerde toegang tot functies",
            MANAGE_PLATFORM_LIST_FAILED: "Kan de platformlijst niet laden",
            ADD_SERVICE_MANAGER_DIALOG_HEADER: "Voeg een servicemanager toe",
            ADD_SLA: "+ SLA toevoegen",
            ADD_CUSTOMER: "+ Klant toevoegen",
            ADD_PLATFORM: "+ Platform toevoegen",
            ADD_PLATFORM_DIALOG_HEADER: "Voeg een platform toe",
            SHOW_FAVORITE_CUSTOMERS: "Alleen klanten met ster weergeven",
            SHOW_FAVORITE_TECHNICIANS: "Alleen technici met ster weergeven",
            SHOW_FAVORITE_SERVICE_MANAGERS: "Alleen servicemanagers met ster weergeven",
            SHOW_FAVORITE_SERVICE_PARTNER: "Alleen servicepartners met ster weergeven",
            SHOW_FAVORITE_PLATFORMS: "Alleen platforms met ster weergeven",
            ERROR_NO_PLATFORM_FOUND: "Geen platform gevonden",
            ERROR_NO_CUSTOMER_FOUND: "Geen klant gevonden",
            ADD_TO_PLATFORM_LABEL: "Toevoegen aan platform... *",
            LATFORM_NAME_HEADER: "Platformnaam",
            PLATFORM_HELPER_TEXT: "Bijvoorbeeld het Franse CSU-team",
            SERVICE_PARTNER_HEADER: "Servicepartner",
            CUSTOMER_NAME_SUBHEADER: "Wat is de naam van deze servicepartner?",
            SERVICE_MANAGER_LABEL: "Servicemanager",
            PLATFORM_NAME_SUBHEADER: "Wat is de naam van de regio/gebied voor dit platform?",
            REGION_SELECT_HEADER_SERVICE_MANAGER: "Bij welke PAAS wordt deze persoon ingedeeld?",
            COUNTRY_SUBHEADER: "Wat is het land voor dit platform?",
            MAIN_SERVICE_MANAGER_HEADER: "Hoofdservicemanager",
            MAIN_SERVICE_MANAGER_SUBHEADER: "Wie houdt toezicht op de klanten en technici op dit platform?",
            SERVICE_MANAGER_DIALOG_HEADER: "Kies of voeg een gebruiker toe en wijs deze toe aan een regio en organisaties.",
            PLATFORM_NAME_HEADER: "Platformnaam",
            SERVICE_PARTNER_LABEL: "Naam servicepartner",
            SLA_OPTIONAL_HEADER: "SLA (optioneel)",
            INTERNAL_EATON_SERVICE_TEAM_CHECKBOX_TEXT: "Dit is een intern Eaton-serviceteam",
            DEFINE_ACCESS_LEVEL: "Definieer toegangsniveaus voor",
            DEFINE_ACCESS_LEVEL_NEXT: "organisaties, gebouwen en systemen.",
            ADD_TO_PAAS: "Toevoegen aan PAAS...",
            CUSTOMER_NAME_HEADER: "Klantnaam",
            MANAGE_PLATFORM_ERROR_CODE_3048: "Geef een geldige naam op of de lengte moet kleiner zijn dan of gelijk zijn aan 32 tekens",
            MANAGE_PLATFORM_ERROR_CODE_3049: "Platformnaam bestaat al",
            MANAGE_PLATFORM_ERROR_CODE_3045: "De landnaam van het platform is niet geldig of de lengte moet kleiner zijn dan of gelijk zijn aan 50 tekens",
            MANAGE_PLATFORM_ERROR_CODE_3046: "Geef een geldige klant-ID op",
            MANAGE_PLATFORM_ERROR_CODE_900: "Ongeautoriseerde toegang tot functies",
            MANAGE_PLATFORM_SUCCESS_200: "Platform succesvol gemaakt",
            SECONDARY_CONTACT_INFO_OPTIONAL: "Secundaire contactgegevens (optioneel)",
            ADD_USER: "+ Gebruiker toevoegen",
            COUNTRY: 'Land',
        },
        LABELS: {
            CSV: "CSV",
            EMAIL: "E-mailadres",
            EXCEL: "Excel-bestand",
            FORGOT_PASSWORD: "Wachtwoord vergeten?",
            GROUP_BY: "Groeperen op:",
            ITEMS_PER_PAGE: "Artikelen per pagina",
            LOGGING_IN: "Inloggen",
            NEED_ACCOUNT: "Account nodig?",
            NEW_PASSWORD: "Nieuw wachtwoord",
            PASSWORD: "Wachtwoord",
            PDF: "Pdf",
            SHOW: "Tonen:",
            SIGN_UP: "Aanmelden",
            TIME_RANGE: "Tijdbereik:",
            TO_BE_IMPLEMENTED: "Te implementeren",
            VIEW_ALL_EVENTS: "Bekijk alle {{count}} evenementen",
            VIEW_BUILDING_DETAILS: "Bekijk gebouwdetails",
            SIGN_IN_WITH_OKTA: "Meld u aan met Okta",
            SIGN_IN: "Inloggen",
            FILTER_BY: "Filter op",
            VIEW_DETAILS: "Details bekijken",
            REQUESTED: 'Gevraagd',
            SCHEDULED: 'Gepland',
            CUSTOM_LOGBOOK_RANGE: 'Aangepast logboekbereik',
            START_DATE: 'Startdatum',
            END_DATE: 'Einddatum',
        },
        TIMELINE_EXPORT: {
            DOWNLOAD_TITLE: "Tijdlijngegevens downloaden",
            DOWNLOAD_SUBTITLE_SITE: "Selecteer het datumbereik van de alarmgeschiedenis die u wilt exporteren.",
            DOWNLOAD_SUBTITLE_TIMELINE: "Selecteer de locatie en het datumbereik van de alarmgeschiedenis die u wilt exporteren.",
        },
        AUTO_LOGOUT_ENABLED: {
            AUTO_LOGOUT_ENABLED: "Ingeschakeld (aanbevolen)",
        },
        LEAGAL: {
            END_USER_AGREEMENT: "Eindgebruikersovereenkomst",
            LICENCE_AGREEMENT: "Licentieovereenkomst voor eindgebruikers",
            LEAGAL: "Juridisch",
            MANUALS: "HANDLEIDINGEN",
            OPEN_SOURCE: "Open Source-licenties",
            INSTRUCTION_EATON_BSMS_GATEWAY: "Gebruiksaanwijzing voor Eaton BSMS Gateway",
            QUICK_START_GUIDE: "Snelstartgids",
            REMOTE_MONITORING_GUIDE: "Handleiding voor monitoring op afstand",
            TERMS_CONDITIONS: "Algemene voorwaarden",
        },
        LEGAL: {
            EULA: "Licentieovereenkomst voor eindgebruikers",
            OPENSOURCELICENSES: "Open Source-licenties",
            TERMSANDCONDITIONS: "Algemene voorwaarden",
            REACT_NATIVE: "Reageer inheems",
            EULA_WIRELESS: "EULA - Eaton Wireless Controller",
            OSS: "Open source licensing - Eaton Wireless Controller",
            OPEN_SOURCE_BSM: "Open source licensing - Building Safety Manager",
        },
        EVENT_TIMELINE: {
            ERROR_LOADING_MORE_EVENTS: "Fout bij het laden van meer gebeurtenissen",
            LOAD_MORE_EVENTS: "Laad {{count}} Meer gebeurtenissen",
        },
        ASSETS_SCREEN: {
            FAVORITE_LIMIT_REACHED: "Favorietenlimiet bereikt",
            NOBUILDINGFOUND: "Geen gebouwen gevonden",
            NOGATEWAYFOUND: "Geen gateways gevonden",
            NOORGANIZATIONFOUND: "Geen organisatie gevonden",
            NOREPORTFOUND: "Geen rapporten gevonden",
            NOSYSTEMS: "Geen systemen gevonden",
            OTHERS: "ANDEREN",
            SHOW_ONLY_STARRED_BUILDING: "Alleen gebouwen met ster weergeven",
            STARRED: "STERREN",
            MARK_AS_FAV_API_SUCCESS: "Succesvol toegevoegd aan favoriet",
            REMOVE_MARK_AS_FAV_API_SUCCESS: "Succesvol uit favoriet verwijderd",
            MARK_AS_FAV_API_FAILURE_MESSAGE: "Verwijder enkele van uw bestaande favorieten voordat u nieuwe toevoegt, aangezien de maximale limiet 10 is",
            SHOW_ONLY_STARRED_SYSTEM: "Alleen systemen met ster weergeven",
            SHOW_ONLY_STARRED_GATEWAY: "Alleen gateways met ster weergeven",
            SHOW_ONLY_STARRED_CUSTOMER: "Alleen klant met ster weergeven",
            SHOW_ONLY_STARRED_SLA: "Alleen SLA met ster weergeven",
        },
        ADDLOCATION: {
            ASTERIKSINFO: "Velden gemarkeerd met een asterisk(*) zijn verplichte velden {{entity}}.",
            ADDLOCATIONINFORMATION: "Locatieprofielinformatie",
        },
        HEADER: {
            FORGOT_PASSWORD: "Wachtwoord vergeten",
        },
        LOGIN: {
            INVALID_CREDENTIALS: "Uw gebruikersnaam/wachtwoord-combinatie wordt niet herkend.",
            GENERIC_ERROR: "Uw verzoek kan op dit moment niet worden verwerkt.",
            UNAUTHORIZED_ACCESS: "Ongeautoriseerde toegang",
            UNAUTHORIZED_ACCESS_MESSAGE: "U heeft geen toegang tot deze applicatie. Meld u aan",
        },
        TABS: {
            LIST_VIEW: "Lijstweergave",
            SUMMARY_VIEW: "Samenvatting weergave",
        },
        NAVIGATION_TABS: {
            LOGBOOK: "LOGBOEK",
            STATUS: "STATUS",
        },
        HELPANDFEEDBACK: {
            MANUALS: "Handleidingen",
            TITLE: "Bedieningshandleiding voor Eaton BSMS Gateway",
        },
        MERGE_ASSETS: {
            MERGE_DELETE: "Samenvoegen en verwijderen",
            MERGE_ASSETS_TITLE: "Voeg activa samen met een ander gebouw",
            SUCCESS: "Gebouwmiddelen met succes samengevoegd",
            ACTION: "Typ uw accountwachtwoord om de actie te bevestigen.",
            HEADER: "Draag alle {{gatewayCount}} gateways en {{systemCount}} systemen over naar een ander gebouw en verwijder het huidige gebouw definitief.",
            TRANSFER_TO: "Overbrengen naar...",
        },
        OPERATING_SYSTEM_THEME: {
            OPERATING_SYSTEM_THEME: "Thema besturingssysteem",
        },
        EULA: {
            OTHER_LANGUAGE: "Andere taal EULA",
        },
        LOCATIONS: {
            SITES: "Sites",
        },
        RESPONSE: {
            USER_REGISTERED: "Gebruiker kan worden geregistreerd",
        },
        PASSWORD_RESET: {
            SUCCESS_MESSAGE: "Uw wachtwoord is succesvol gereset.",
            FAILURE_MESSAGE: "Uw wachtwoord kon niet opnieuw worden ingesteld. Probeer het later opnieuw.",
        },
        LICENCE: {
            LICENCE_AGREEMENT: "Licentieovereenkomst",
            OPEN_SOURCE: "Open Source-licenties",
            REACT_NATIVE_LICENCE: {
                MIT_LICENSE: "MIT-licentie",
                COPYRIGHT_TEXT: "Auteursrecht (c) Facebook, Inc. en zijn dochterondernemingen.",
                MIT_LICENSE_TEXT: "Hierbij wordt kosteloos toestemming verleend aan elke persoon die een kopie van deze software en bijbehorende documentatiebestanden (de Software) verkrijgt, om zonder beperking in de Software te handelen, inclusief maar niet beperkt tot de rechten om kopieën van de Software te gebruiken, kopiëren, wijzigen, samenvoegen, publiceren, distribueren, in sublicentie geven en/of verkopen, en om personen aan wie de Software wordt geleverd toe te staan ​​dit te doen, met inachtneming van de volgende voorwaarden:",
                MIT_LICENSE_TEXT_ONE: "De bovenstaande copyrightkennisgeving en deze toestemmingsverklaring zullen worden opgenomen in alle kopieën of substantiële delen van de Software.",
                MIT_LICENSE_TEXT_TWO: "DE SOFTWARE WORDT GELEVERD AS IS, ZONDER ENIGE GARANTIE, EXPLICIET OF IMPLICIET, INCLUSIEF MAAR NIET BEPERKT TOT DE GARANTIES VAN VERKOOPBAARHEID, GESCHIKTHEID VOOR EEN BEPAALD DOEL EN NIET-INBREUK. IN GEEN GEVAL ZULLEN DE AUTEURS OF AUTEURSRECHTHOUDERS AANSPRAKELIJK ZIJN VOOR ENIGE CLAIM, SCHADE OF ANDERE AANSPRAKELIJKHEID, HETZIJ IN EEN CONTRACT-, ONRECHTMATIGE DAAD OF ANDERSZINS, VOORTVLOEIEND UIT, UIT OF IN VERBAND MET DE SOFTWARE OF HET GEBRUIK OF ANDERE HANDELINGEN IN DE SOFTWARE.",
            },
        },
        WIRELESS_GATEWAY: {
            WIRELESS_SEARCHLUMINAIRE_HEADLINE: "Zoeken naar alle armaturen maakt een nieuwe configuratie aan door het volgende te doen:",
            WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_ONE: "Zoek naar alle geïnstalleerde en geadresseerde armaturen",
            WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_TWO: "Als u de zoekopdracht start, worden alle geactiveerde, defecte armaturen uit uw configuratie verwijderd",
            WIRELESS_SEARCH_ALL_LUMINARIES_WARNING: "Wilt u alleen armaturen toevoegen, gebruik dan de optie Zoeken naar nieuwe armaturen.",
            WIRELESS_SEARCH_ALL_LUMINARIES_ACTION_NON_CANCELLABLE: "Deze actie kan niet ongedaan worden gemaakt.",
            WIRELESS_SEARCH_ALL_LUMINARIES_DIALOG_TEXT: "Als u de zoekopdracht start, worden alle geactiveerde armaturen met een defect uit uw configuratie verwijderd",
            WIRELESS_RETRY_SEARCH: "Probeer opnieuw te zoeken",
            WIRELESS_CONFIGURE_LUMINARIES: "Armaturen configureren",
            WIRELESS_VISIBILITY_PLUS_TITLE: "Dit verhoogt de zichtbaarheid van noodverlichting in geval van een noodsituatie."
        },
        STAGE_GROUP: {
            SELECT_STAGE_GROUP: 'Selecteer stagegroep',
            STAGE_GROUP: 'Stagegroep',
        },
        NOTIFICATION_KEYS: {
            NOTIFICATION_ALARM_BODY: "Er is een {{logType}} opgetreden met het volgende systeem",
            NOTIFICATION_HEALTH_REPORT_TITLE: "Nieuw rapport beschikbaar - {{org}}",
            NOTIFICATION_HEALTH_REPORT_BODY: "Er is een nieuw maandrapport voor {{building}} beschikbaar om te bekijken",
        },
        SERVICEPARNTERINFO: {
            SERVICE_INFO_HEADER: "Service-informatie",
            SERVICE_INFO_DETAILS_NOT_AVAILABLE: "Service-informatie niet beschikbaar",
        },
        DRY_CONTACT: {
            TITLE: "Droog contact I/O-status",
            DRY_CONTACT_DETAILS: "Droge contactgegevens",
            DRY_CONTACT_OUTPUT: "Droge contactuitgang",
            DRY_CONTACT_INPUT: "Droge contactingang",
            DRY_CONTACT_SETTINGS_READ_ONLY: "Droge contactinstellingen (alleen lezen)",
            DRY_CONTACT_SETTINGS_DESCRIPTION: "Informatie kan alleen worden geconfigureerd op het systeem of via de mobiele applicatie met Bluetooth-verbinding.",
            DEFAULT_SETTINGS: "Standaardinstellingen",
            NORMALLY_OPEN: "Normaal geopend",
            NORMALLY_CLOSED: "Normaal gesloten",
            IOSTATUS: {
                OPEN: "Open",
                CLOSED: "Gesloten",
                NOT_CONFIGURED: "Niet geconfigureerd",
                CONFIGURED: "Geconfigureerd",
            },
        },
        WIRELESS_ZONE: {
            TEST_RUN : "Waar wordt deze test uitgevoerd?",
            ALL_ZONES: "Alle zones",
            ZONE_SELECTION: "Selecteer alle zones of 1 zone voor de",
            REFERESH_LUM_TEST: "Armaturen verversen",
            VISIBILITY_TEST: "Visibility Plus Test",
            ZONE_LUM_LIST: "Zone armaturenlijst",
            ZONE_NO: "Zone nr."
        },
        LINEZONE_STATUS: {
            TOTAL_FAILED: 'Totaal mislukt',
            BATTERY_FAILURE: 'Batterij storing',
            LAMP_FAILURE: 'Lampstoring',
            READY: 'Gereed',
            COMMUNICATION_FAILURE: 'Communicatie fout',
            BLOCKED: 'Geblokkeerd',
        },
        ACCOUNT_PREFERENCES: {
            LIGHT_THEME: 'Licht thema',
            DARK_THEME: 'Donker thema',
            SYSTEM_THEME: 'Systeemthema',
            GMT: 'Greenwich Mean Time',
            IST: 'Indiase standaardtijd',
            UTC: 'Gecoördineerde Universele Tijd',
            CST: 'Centrale standaardtijd',
            MST: 'Mountain Standard-tijd',
            EST: 'Oostelijke tijdzone',
            CEST: 'Midden-Europese tijd (GMT-1:00)',
            IMPERIAL_UNITS: 'Imperiale eenheden`',
            BRITISH_IMPERIAL_SYSTEM: 'Brits Imperiaal Systeem',
            PER_SYSTEM: 'Per systeem',
            PER_BUILDING: 'Per gebouw',
            EMAIL_PUSH_NOTIFICATION: 'E-mail, pushmelding',
            EMAIL_ONLY: 'Alleen e-mail',
            DONT_NOTIFY: "Niet melden",
            SAVE_TO_DEVICE_CLOUD: 'Opslaan op apparaat + Wolk',
            SAVE_TO_DEVICE: 'Opslaan op apparaat',
            SAVE_TO_CLOUD: 'Wolk'
        }
    },
};
export default resources;
